import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // .use(Backend)
  .use(LanguageDetector)
  // .use(reactI18nextModule)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          name: "Name",
          email: "Email",
          phone: "Phone",
          created_at: "Created at",
          action: "Action",
          feedback: "Feedback",
          size: "Size",
          save: "Save",
          cancel: "Cancel",
          ref_link: "Reference link",
          remove: "Remove",
          view_detail: "View detail",
          download: "Download",
          rename: "Rename",
          copy_url: "Copy URL",
          copied: "Copied",
          add_folder: "Add folder",
          upload_image: "Upload image",
          valid_file_name: "File name is valid",
          invalid_file_name: "File name is invalid",
          storage_items: "Storage items",
          image_list: "Image list",
          branch: "Branch",
          img_logo: "Image logo",
          album: "Album",
          voucher: "Voucher",
          menu_service: "Menu service",
          menu_item: "Menu item",
          menu_product: "Menu product",
          menu_product_category: "Menu product category",
          avatar_employee: "Avatar employee",
          avatar_customer: "Avatar customer",
          member_card: "Mmember card",
          upload_image: "Uploaded image",
          posts: "Posts",
          something_went_wrong: "Something went wrong. Please try again later",
          register_employee_employee_register_successful:
            "Registerd successfully",
          register_employee_invalid_link: "Invalid Link",
          register_employee_not_found_link: "Not Found Link",
          Searching: "Searching",
          yes: "Yes",
          no: "No",
          review: "Review",
          read_all: "Read more",
          contact_admin_to_change: "Contact admin to change",
          An_error_occurred_Please_check_internet_or_contact_your_admin:
            "An error occurred. Please check internet or contact your admin!",
          percent: "Percent",
          you_can_not_view_the_list_of_this_branch_because_you_do_not_have_permission_to_manage_this_branch:
            "You can not view the list of this branch because you do not have permission to manage this branch",
          open_map: "Show Map",
          close_map: "Hidden Map",
          backButton: "Back",
          sendButton: "Send",
          editButton: "Edit",
          agree: "Agree",
          disagree: "Disagree",
          rows_per_page: "Rows per page",
          isRead: "Status",
          isUsed: "Usage Status",
          expiredVoucher: "Expired Date",
          status: "Status",
          enabled: "Enabled",
          on_sale: "On Sale",
          discontinued: "Discontinued",
          stock_status: "Stock Status",
          spentRealMoney: "Spent real money",
          voucherMoney: "Voucher money",

          //header
          header_profile: "Profile",
          header_logout: "Log out",
          header_block: "Block",
          header_notification: "Notification",
          header_permission: "Permission",
          header_location: "Location",
          header_your_browser_blocked_permission:
            "Your browser blocked permissions",
          // sidebar
          sidebar_superadmin: "Super admin",
          sidebar_manage: "Management",
          sidebar_service_and_product: "Service & Product",
          sidebar_support: "Support",
          sidebar_owner: "Owner Spa",
          sidebar_dashboard: "Dashboard",
          sidebar_my_spa: "My Spa",
          sidebar_service: "Detail Spa",
          sidebar_list: "List",
          sidebar_detail: "Detail",
          sidebar_branch: "Branch",
          sidebar_album: "Album",
          sidebar_menu: "Services",
          sidebar_booking: "Booking",
          sidebar_post: "Post",
          sidebar_cms: "CMS",
          sidebar_users: "Users",
          sidebar_contact: "Contact",
          sidebar_visitor: "Visitor",
          sidebar_post_list: "Post List",
          sidebar_post_create: "Create Post",
          sidebar_post_category: "Post's Categories",
          sidebar_order: "Order",
          sidebar_promotion: "Promotion",
          sidebar_voucher: "Voucher",
          sidebar_discount: "Discount",
          sidebar_user: "Users",
          sidebar_customer: "Customers",
          sidebar_employee: "Employees",
          sidebar_profile: "Profile",
          sidebar_notification: "Notification",
          sidebar_develop_account: "Developer",
          sidebar_develop_account_create: "Create developer",
          sidebar_module: "Permission",
          sidebar_nps: "NPS",
          sidebar_digital_signal: "Digital signal",
          sidebar_report: "Report",
          sidebar_sms: "Sms",
          sidebar_cost: "Cost",
          sidebar_stableCost: "Stable cost",
          sidebar_service_cost: "Service cost",
          sidebar_membercard: "Member card",
          sidebar_user_membercard: "User Member Card",
          sidebar_storage: "Storage",
          sidebar_product: "Products",
          sidebar_user_voucher: "User Voucher",
          sidebar_campaign: "Campaign",
          sidebar_service_account: "Account",
          sidebar_service_payment: "Payment",
          sidebar_setting_system: "Setting",
          sidebar_list_product: "List",
          sidebar_create_product: "Create",
          //serviceUpload
          service_ownerspa_service_storage: "Storage",
          service_ownerspa_service_storage_select: "Select",
          //serviceAlbum
          service_ownerspa_service_album: "Album",
          service_ownerspa_service_album_create_album_unsuccess:
            "Create image unsuccess",
          service_ownerspa_service_album_create_album_success:
            "Create image success",
          service_ownerspa_service_album_delete_album_unsuccess:
            "Delete image unsuccess",
          service_ownerspa_service_album_delete_album_success:
            "Delete image success",
          service_ownerspa_servicealbum_cancel: "cancel",
          service_ownerspa_servicealbum_delete: "Delete",
          service_ownerspa_servicealbum_confirm: "Confirm",
          service_ownerspa_servicealbum_delete_image_from_album_list:
            "Delete image from album list?",

          //service_admin
          search: "Search",
          service_admin_search_name_adress_website:
            "Search by name, address, website",
          service_admin_spa_not_found: "Service list empty",
          service_admin_add_new_service: "Create New Spa",
          service_admin_create: "Create",
          service_admin_edit_spa: "Edit Spa",
          service_admin_list_services: "List Services",
          service_admin_owner_code: "Owner's Code",
          service_admin_list_services_add_new_spa: "Add new spa",
          service_admin_listservice_cancel: "Cancel",
          service_admin_listservice_continute: "Continue",
          service_admin_listservice_rows_paper: "Rows Paper",
          service_admin_listservice_update_successfully: "Update Successfully",
          service_admin_listservice_update_unsuccessfully:
            "Update Unsuccessfully",
          service_admin_listservice_delete_successfully: "Delete Successfully",
          service_admin_listservice_delete_unsuccessfully:
            "Delete Unsuccessfully",
          service_admin_listservice_delete: "Delete",
          service_admin_listservice_unLimit: "Unlimit",
          service_admin_listservice_delete_service_from_list_will_delete_it_on_system:
            "Delete service from list will delete it on system",
          service_admin_listservice_tablehead_support: "Support",
          service_admin_listservice_tablehead_created_at: "Created At",
          service_admin_listservice_tablehead_updated_at: "Updated At",
          service_admin_listservice_tablehead_no: "Code",
          service_admin_listservice_tablehead_expired: "Expired package",
          service_admin_listservice_tablehead_package: "Using Package",
          service_admin_listservice_tablehead_name_services: "Name",
          service_admin_listservice_tablehead_mobile: "Mobile",
          service_admin_listservice_tablehead_phone: "Phone",
          service_admin_listservice_tablehead_active: "Active",
          service_admin_listservice_tabletoolbar_selected: "Selected",
          service_admin_listservice_tabletoolbar_delete: "Delete",
          service_admin_listservice_editservice_active_status: "Active Status",
          service_admin_listservice_editservice_owner_infomation:
            "Owner Infomation",
          service_admin_listservice_editservice_permisstion: "Permission",
          service_admin_listservice_editservice_service_account:
            "Service account",
          service_admin_listservice_editservice_phone: "Phone",
          service_admin_listservice_editservice_mobile: "Mobile",
          service_admin_listservice_editservice_min_price: "Min price",
          service_admin_listservice_editservice_max_price: "Max price",
          service_admin_listservice_editservice_currency: "Currency",
          service_admin_listservice_editservice_address: "Address",
          service_admin_listservice_editservice_city: "City",
          service_admin_listservice_editservice_district: "District",
          service_admin_listservice_editservice_active: "Active",
          service_admin_listservice_editservice_add_owner_spa: "Add owner spa",
          service_admin_listservice_editservice_remove_owner_information:
            "Do you want to remove infomation owner of service",
          service_admin_listservice_editservice_remove_owner_information:
            "Do you want to remove infomation owner of service",
          service_admin_listservice_editservice_remove_owner_spa:
            "Remove owner spa",
          service_admin_listservice_editservice_name_service: "Name Services",
          service_admin_listservice_editservice_website: "Website",
          service_admin_listservice_editservice_status_changed_to_active:
            "Status changed to active",
          service_admin_listservice_editservice_status_changed_to_inactive:
            "Status changed to inactive",
          service_admin_createservice_you_must_insert_basic_information_for_service_to_countinue:
            "You must insert basic information for service to countinue",
          service_admin_createservice_you_must_insert_name_of_your_service:
            "You must insert name of your service",
          service_admin_createservice_update_successfully:
            "Update successfully",
          service_admin_createservice_update_unsuccessfully:
            "Update unsuccessfully",
          service_admin_createservice_save_unsuccessfully:
            "Save unsuccessfully",
          service_admin_createservice_save_successfully:
            "Create spa successfully",
          service_admin_createservice_cancel: "Cancel",
          service_admin_createservice_information: "Information",
          service_admin_createservice_feature_and_function:
            "Feature and Function",
          service_admin_createservice_workingDay: "Working Days",
          service_admin_createservice_album: "Album",
          service_admin_createservice_branch: "Branch",
          service_admin_createservice_menu: "Menu",
          service_admin_createservice_confirm: "Confirm",

          // create service
          service_admin_createservice_branch_add_new_branch: "Add new branch",
          service_admin_createservice_create: "Create",
          service_admin_createservice_type_your_space_spa:
            "Type your space spa",
          service_admin_createservice_type_your_color_spa:
            "Type your color spa",
          service_admin_createservice_create_new_service_with_name:
            "Create new service with name ",
          service_admin_createservice_insert_basic_information_for_service_to_countinue:
            "Insert basic information for your service to countinue",
          // album
          service_admin_createservice_album_cancel: "Cancel",
          service_admin_createservice_album_delete: "Delete",
          service_admin_createservice_album_confirm: "Confirm",
          service_admin_createservice_album_delete_this_image_from_list:
            "Delete this image from list?",
          // branch
          "service_admin_createservice_branch_you_don't_have_any_branch_create_new_branch":
            "You don't have any branch, create new branch",
          service_admin_createservice_branch_branch_name: "Branch Name",
          service_admin_createservice_branch_address: "Address",
          service_admin_createservice_branch_district: "District",
          service_admin_createservice_branch_city: "City",
          service_admin_createservice_branch_phone: "Phone",
          service_admin_createservice_branch_mobile: "Mobile",
          service_admin_createservice_newbranch_create_unsuccessfully:
            "Create unsuccessfully",
          service_admin_createservice_newbranch_cancel: "Cancel",
          service_admin_createservice_newbranch_create: "Create",
          service_admin_createservice_newbranch_confirm: "Confirm",
          service_admin_createservice_feature: "Feature",
          // Feature
          "skin-lightening": "Skin Lightening",
          "facial-massage": "Facial Massage",
          waxing: "Waxing",
          "stretch-the-skin": "Stretch the skin",
          "food-hand-massage": "Food hand massage",
          liposuction: "Liposuction",
          "wrinkle-improverment": "Wrinkle improvement",
          "raising-the-nose": "Raising the nose",
          nail: "Nail",
          wifi: "Wi fi",
          free_parking: "Free parking",
          card_accepted: "Use Card",
          sauna: "Sauna",
          space: "Space",
          color: "Color",
          music: "Music",
          soundproof: "Soundproof",
          service_admin_createservice_feature_save: "Save",
          service_admin_createservice_feature_function: "Function",
          service_admin_createservice_feature_feature: "Feature",
          service_admin_createservice_feature_type_your_space_spa:
            "Type your space spa",
          service_admin_createservice_feature_type_your_color_spa:
            "Type your color spa",
          //information
          service_admin_createservice_information_address_invalid:
            "Address invalid",
          service_admin_createservice_information_please_enter_name_spa:
            "Please enter name of spa",
          service_admin_createservice_information_please_enter_phone_spa:
            "Please enter phone of spa",
          service_admin_createservice_information_name_service: "Name service",
          service_admin_createservice_information_phone: "Phone",
          service_admin_createservice_information_mobile: "Mobile",
          service_admin_createservice_information_min_price: "Min price",
          service_admin_createservice_information_max_price: "Max price",
          service_admin_createservice_information_currency: "Currency",
          service_admin_createservice_information_address: "Address",
          service_admin_createservice_information_city: "City",
          service_admin_createservice_information_district: "District",
          service_admin_createservice_information_go_to_location:
            "Go to location",
          service_admin_createservice_information_description: "Description",
          service_admin_createservice_information_working_hours:
            "Working Hours",
          service_admin_createservice_information_image_spa: "Image Spa",
          service_admin_createservice_information_image_should_have_aspect_ratio_is_16_9:
            "Image should have aspect ratio is 16:9",
          service_admin_createservice_information_active: "Active",
          service_admin_createservice_information_point_system: "Point system",
          //menu
          service_admin_createservice_menu_add_successfully: "Add successfully",
          service_admin_createservice_menu_add_unsuccessfully:
            "Add unsuccessfully",
          //newbranch
          service_admin_createservice_newbranch_address_invalid:
            "Address invalid",
          service_admin_createservice_newbranch_create_successfully:
            "Create successfully",
          service_admin_createservice_newbranch_create_new_branch_for_your_spa:
            "Create new branch for your spa",
          service_admin_createservice_newbranch_name: "Name",
          service_admin_createservice_newbranch_mobile: "Mobile",
          service_admin_createservice_newbranch_phone: "Phone",
          service_admin_createservice_newbranch_address: "Address",
          service_admin_createservice_newbranch_city: "City",
          service_admin_createservice_newbranch_district: "District",
          service_admin_createservice_newbranch_go_to_location:
            "Go to location",
          service_admin_createservice_newbranch_save: "Save",
          //ownerspa
          service_ownerspa_spa: "Spa",
          service_ownerspa_servicedetail_please_enter_address:
            "Please enter address",
          service_ownerspa_servicedetail_can_not_detect_position_on_map:
            "Can not detect position on map",
          service_ownerspa_servicedetail_please_enter_name: "Please enter name",
          service_ownerspa_servicedetail_update_successfully:
            "Update information service successfully",
          service_ownerspa_servicedetail_update_unsuccessfully:
            "Update information service unsuccessfully",
          service_ownerspa_servicedetail_upload_image_successfully:
            "Upload image service successfully",
          service_ownerspa_servicedetail_upload_image_unsuccessfully:
            "Upload image service unsuccessfully",
          service_ownerspa_servicedetail_update_image_successfully:
            "Update image service successfully",
          service_ownerspa_servicedetail_update_image_unsuccessfully:
            "Update image service unsuccessfully",
          service_ownerspa_servicedetail_cancel: "Cancel",
          service_ownerspa_servicedetail_update: "Update",
          service_ownerspa_servicedetail_do_you_want_to_update_them:
            "Do you want to update them?",
          service_ownerspa_servicedetail_information: "Information",
          service_ownerspa_servicedetail_working_hours: "Working hours",
          service_ownerspa_servicedetail_feature_and_function:
            "Feature and Function",
          service_ownerspa_servicedetail_service_setting_settings: "Setting",
          service_ownerspa_servicedetail_service_setting_prefix_menu_item:
            "Prefix Menu Item",
          service_ownerspa_servicedetail_service_setting_total_menu_item:
            "Total Menu Item",
          service_ownerspa_servicedetail_service_setting_prefix_menu:
            "Prefix Menu",
          service_ownerspa_servicedetail_service_setting_total_menu:
            "Total Menu",
          service_ownerspa_servicedetail_service_setting_prefix_employee:
            "Prefix Employee",
          service_ownerspa_servicedetail_service_setting_total_employee:
            "Total Employee",
          service_ownerspa_servicedetail_service_setting_prefix_customer:
            "Prefix Customer",
          service_ownerspa_servicedetail_service_setting_total_customer:
            "Total Customer",
          service_ownerspa_servicedetail_service_setting_payment_type:
            "Payment method",
          service_ownerspa_servicedetail_service_setting_credit_card:
            "Credit Card",
          service_ownerspa_servicedetail_service_setting_international_card:
            "International Card",
          service_ownerspa_servicedetail_service_currrency_code:
            "Currency Code",
          service_ownerspa_servicedetail_format_datetime: "Format Date time",
          service_ownerspa_servicedetail_service_tax: "Tax",
          service_ownerspa_servicedetail_default_countryCode: "Country Code",

          service_ownerspa_servicedetail_qr_code: "QR Code",
          service_ownerspa_servicedetail_feature_feature: "Feature",
          service_ownerspa_servicedetail_feature_type_size_your_spa_area:
            "Type size your spa area",
          service_ownerspa_servicedetail_feature_type_color_for_your_spa:
            "Type color for your spa",
          service_ownerspa_servicedetail_feature_function: "Function",
          service_ownerspa_servicedetail_feature_detail: "Detail",
          service_ownerspa_servicedetail_feature_using_tax: "Using tax",
          service_ownerspa_servicedetail_feature_point_system: "Point System",
          service_ownerspa_servicedetail_feature_name: "Name",
          service_ownerspa_servicedetail_feature_phone: "Phone",
          service_ownerspa_servicedetail_feature_mobile: "Mobile",
          service_ownerspa_servicedetail_feature_min_price: "Min price",
          service_ownerspa_servicedetail_feature_max_price: "Max price",
          service_ownerspa_servicedetail_feature_currency: "Currency",
          service_ownerspa_servicedetail_feature_address:
            "Address (Please enter to get position on map)",
          service_ownerspa_servicedetail_feature_country: "Country",
          service_ownerspa_servicedetail_feature_city: "City",
          service_ownerspa_servicedetail_feature_state: "State",
          service_ownerspa_servicedetail_feature_district: "District",
          service_ownerspa_servicedetail_feature_view_on_google_map:
            "View on google map",
          service_ownerspa_servicedetail_feature_go_to_location:
            "Go to location",
          service_ownerspa_servicedetail_feature_description: "Description",
          service_ownerspa_servicedetail_feature_image_spa: "Image Spa",
          service_ownerspa_servicedetail_image_logo: "Image Logo",
          service_ownerspa_servicedetail_feature_image_should_have_aspect_ratio_is_16_9:
            "Image should have aspect ratio is 16:9",
          service_ownerspa_servicedetail_feature_print_qrcode: "Print QR Code",
          service_ownerspa_servicedetail_feature_print_barcode:
            "Print Bar Code",
          service_ownerspa_servicedetail_qr_and_bar_code: "QR Code & Bar Code",
          service_ownerspa_servicedetail_qr_code_service_code: "Service code",
          service_ownerspa_servicedetail_qr_code_service_name: "Service name",
          service_ownerspa_servicedetail_qr_code_mobile: "Mobile",
          service_ownerspa_servicedetail_qr_code_website: "Website",
          service_ownerspa_servicedetail_qr_code_code: "Code",
          service_ownerspa_servicedetail_generate_qrcode: "Generate QR Code",
          service_ownerspa_servicedetail_generate_barcode: "Generate Bar Code",
          service_ownerspa_servicedetail_generate_qr_code_successful:
            "Generate Bar Code successfully",
          service_ownerspa_servicedetail_qrcode_size: "QR Code size",
          service_ownerspa_servicedetail_barcode_height: "Bar Code Height",
          service_ownerspa_servicedetail_enter_barcode_height:
            "Enter Bar Code Height",
          service_ownerspa_servicedetail_enter_qrcode_size:
            "Enter QR Code size",
          service_ownerspa_createservice_you_must_insert_name_of_your_service:
            "You must insert name of your service",
          service_ownerspa_createservice_save_unsuccessfully:
            "Save unsuccessfully",
          service_ownerspa_createservice_save_successfully: "Save successfully",
          service_ownerspa_createservice_cancel: "Cancel",
          service_ownerspa_createservice_create: "Create",
          service_ownerspa_createservice_confirm: "Confirm",
          service_ownerspa_createservice_create_new_service_to_list:
            "Create new service to list",
          service_ownerspa_createservice_insert_basic_information_for_your_service_to_countinue:
            "Insert basic information for your service to continue",
          service_ownerspa_createservice_information_address_invalid:
            "Address invalid",
          service_ownerspa_createservice_information_point_system:
            "Point system",
          service_ownerspa_createservice_information_name_service:
            "Name service",
          service_ownerspa_createservice_information_phone: "Phone",
          service_ownerspa_createservice_information_mobile: "Mobile",
          service_ownerspa_createservice_information_min_price: "Min price",
          service_ownerspa_createservice_information_max_price: "Max price",
          service_ownerspa_createservice_information_currency: "Currency",
          service_ownerspa_createservice_information_address: "Address",
          service_ownerspa_createservice_information_city: "City",
          service_ownerspa_createservice_information_district: "District",
          service_ownerspa_createservice_information_go_to_location:
            "Go to location",
          service_ownerspa_createservice_information_description: "Description",
          service_ownerspa_createservice_information_working_hours:
            "Working Hours",
          service_ownerspa_createservice_information_image_spa: "Image Spa",
          service_ownerspa_createservice_information_image_should_have_aspect_ratio_is_16_9:
            "Image should have aspect ratio is 16:9",
          service_ownerspa_createservice_information_active: "Active",
          service_ownerspa_createservice_information_save: "Save",
          service_ownerspa_createservice_payment: "Payment",
          service_ownerspa_createservice_payment_detail: "Detail",
          service_ownerspa_createservice_payment_account_balance:
            "Account balance",
          service_ownerspa_createservice_payment_payment_history:
            "Payment history",
          // Order
          Not_have_any_order: "Not have any order",
          orders_order: "Order",
          orders_do_you_want_to_delete_this_order_from_list:
            "Do you want to delete this order from list??",
          orders_delete_orders_successfully: "Delete orders successfully",
          orders_delete_orders_unsuccessfully: "Delete unsuccessfully",
          orders_cancel: "Cancel",
          orders_continue: "Continue",
          orders_notice: "Notice",
          orders_filter_by_time: "Filter by created day",
          orders_search_by_code_customer_code_mobile:
            "Search order code, customer mobile/code",
          orders_search: "Search",
          orders_rows_paper: "Rows Paper",
          orders_tablehead_order_code: "Order Code",
          orders_tablehead_branch: "Branch",
          orders_tablehead_item: "Items",
          orders_tablehead_customer: "Customer",
          orders_tablehead_mobile: "Mobile",
          orders_tablehead_status: "Status",
          orders_tablehead_finish_payment: "Finish payment",
          orders_tablehead_updated_at: "Update at",
          orders_tablehead_price: "Total price",
          orders_tablehead_membercard_money: "Membercard money",
          orders_tabletoolbar_selected: "selected",
          orders_tabletoolbar_delete: "Delete",
          orders_listorder_more: "More",
          orders_editnote_update_successfully: "Update successfully",
          orders_editnote_update_unsuccessfully: "Update unsuccessfully",
          orders_editnote_item: "Item | Price | Time",
          orders_editnote_value_discount: "Value Discount",
          orders_editnote_voucher_money: "Voucher Money",
          orders_editnote_membercard_money: "Money pay by Membercard",
          orders_editnote_type_discount: "Type Discount",
          orders_editnote_shipping_fee: "Shipping fee",
          orders_editnote_tax: "Tax",
          orders_editnote_points: "Points",
          orders_editnote_total_points: "Total Points",
          orders_editnote_estimate_price: "Estimate Price",
          orders_editnote_total_price: "Total Price",
          orders_editnote_money_change: "Money Change",
          orders_editnote_money_received: "Money Receive",
          orders_editnote_payment_method: "Payment Method",
          orders_editnote_payment_method_cash: "Cash",
          orders_editnote_payment_method_card: "Card",
          orders_editnote_customer_comment: "Customer Comment",
          orders_editnote_customer_note: "Note of order",
          orders_editnote_customer_feedback: "Feedback of customer",
          orders_editnote_none: "None",
          orders_editnote_detail: "Detail",
          orders_editnote_history_order: "History Order",
          orders_editnote_employee: "Employee",
          orders_editnote_owner: "Owner",
          orders_editnote_changed_status: "changed status",
          orders_editnote_for_this_order: "for this order at",
          orders_editnote_not_any_action: "Not any action",
          orders_editnote_not_any_item_assigned: "Not any item assigned",
          orders_detailorder_order_info: "Order info",
          orders_detailorder_customer: "Customer",
          orders_detailorder_order_code: "Order code",
          orders_detailorder_date: "Date",
          orders_detailorder_status: "Status",
          orders_detailorder_item_name: "Item name",
          orders_detailorder_item_quantity: "Quantity",
          orders_detailorder_item_price: "Price",
          orders_detailorder_total: "Total",
          orders_detailorder_money_change: "Money change",
          orders_detailorder_payment: "Payment",
          orders_detailorder_add_new_payment: "Add new payment",
          orders_detailorder_order_item: "Order item",
          orders_detailorder_receive_money: "Received money",
          orders_detailorder_employee_code: "Employee code",
          orders_detailorder_employee_name: "Employee name",
          orders_detailorder_payment_method: "Payment method",
          orders_detailorder_payment_method_cash: "Cash",
          orders_detailorder_payment_method_card: "Card",
          orders_detailorder_updatedAt: "Updated At",
          orders_detailorder_change_money: "Change money",
          orders_detailorder_add: "Add",
          orders_detailorder_cancel: "Cancel",
          orders_detailorder_edit: "Save",
          orders_detailorder_edit_payment_success: "Edit payment successfully",
          orders_detailorder_delete_payment_success:
            "Delete payment successfully",
          orders_detailorder_delete: "Delete",
          orders_detailorder_notice: "Notice",
          orders_detailorder_add_payment_successfully:
            "Add payment successfully",
          orders_detailorder_please_fill_in_received_money:
            "Pleasse fill in received money",
          orders_detailorder_payment_record_will_be_delete_immediately_you_can_not_undo_this_action:
            "Payment record will be deleted immediately. You can’t undo this action",
          orders_detailorder_edit_payment_unsuccess:
            "Edit payment unsuccessfully",
          listOrder_apply_for_all_branches: "Apply for all branches",
          // Discount
          discount_discount: "Discount",
          discount_create_discount: "Create Discount",
          discount_listdiscount_update: "Update",
          discount_listdiscount_delete: "Clear",
          discount_listdiscount_notice: "Notice",
          discount_listdiscount_update_successfully: "Update successfully",
          discount_listdiscount_update_unsuccessfully: "Update unsuccessfully",
          discount_listdiscount_cancel: "Cancel",
          discount_listdiscount_value: "Value",
          discount_listdiscount_type: "Type",
          discount_listdiscount_start_date: "Start Date",
          discount_listdiscount_end_date: "End Date",
          discount_listdiscount_note: "Note",
          discount_listdiscount_can_be_used_with_voucher_code:
            "Can be used with voucher code",
          discount_listdiscount_all_branch: "Apply for all branches",
          discount_listdiscount_enable: "Enable discount",
          discount_listdiscount_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Please add discount less than or equal to 100 for percent",
          discount_listdiscount_edit: "Edit",
          discount_listdiscount_do_you_want_to_update_discount:
            "Do you want to update discount?",
          discount_listdiscount_do_you_want_to_delete_discount:
            "Do you want to delete discount?",
          discount_listdiscount_end_date_have_to_more_than_start_date:
            "End date have to more than start date",
          discount_listdiscount_start_date_wrong: "Start date wrong",
          discount_listdiscount_please_enter_a_value_less_than_1_for_percent_type:
            "Please enter a value less than 1 for percent type",
          discount_listdiscount_selectedbranch_branch: "Branch",
          discount_add_discount_create_successfully: "Create successfully",
          discount_add_discount_create_unsuccessfully: "Create unsuccessfully",
          discount_add_discount_cancel: "Cancel",
          discount_add_discount_notice: "Notice",
          discount_add_discount_create_new_discount: "Create new Discount",
          discount_add_discount_create: "Create",
          discount_add_discount_value: "Value",
          discount_add_discount_type: "Type",
          discount_add_discount_start_date: "Start date",
          discount_add_discount_end_date: "End date",
          discount_add_discount_note: "Note",
          discount_add_discount_please_fill_out_the_promotion:
            "Please fill out the promotion",
          discount_add_discount_please_choose_at_least_one_branch_to_apply_for_promotion:
            "Please choose at least one branch to apply for promotion",
          // Profile
          profile_profile: "Profile",
          profile_successfully: "Successfully",
          profile_unsuccessfully: "Unsuccessfully",
          profile_update_firstName_lastName_required:
            "First Name and Last Name is required",
          profile_gender: "Gender",
          profile_male: "Male",
          profile_female: "Female",
          profile_phone: "Phone",
          profile_information: "Information",
          profile_password: "Password",
          profile_first_name: "First name",
          profile_last_name: "Last name",
          profile_dob: "Date of birth",
          profile_address: "Address",
          profile_update: "Update",
          profile_current_password: "Current password",
          profile_new_password: "New password",
          profile_confirm_password: "Confirm password",
          profile_please_fill_in_passwod_and_confirm_password:
            "Please fill in password and confirm password",
          profile_change_password_password_confirm_does_not_match:
            "Password and confirm password does not match",
          profile_change_password_new_password_must_be_at_least_6_characters_long:
            "New passwords must be at least 6 characters long",
          profile_change_current_password_is_incorrect:
            "Current password is incorrect",
          profile_api_key_delete_successfully: "Delete successfully",
          profile_api_key_create_successfully: "Create successfully",
          profile_api_key_delete: "Delete",
          profile_api_key_cancel: "Cancel",
          profile_api_key_notify: "Notify",
          profile_email_is_not_valid: "is not a valid email",
          profile_api_key_api_will_be_delete_immediately_you_can_not_undo_this_action:
            "API Key will be deleted immediately. You can’t undo this action",
          // Booking
          booking_booking: "Booking",
          booking_filter_by_time: "Filter by time customer arrive",
          booking_search: "Search code, name, mobile",
          booking_listbooking_add_booking: "Add",
          booking_listbooking_all_booking: "All bookings",
          booking_listbooking_successfully: "Successfully",
          booking_listbooking_unsuccessfully: "Unsuccessfully",
          booking_listbooking_ok: "OK",
          booking_listbooking_edit: "Edit",
          booking_listbooking_cancel_bookings: "Cancel Bookings",
          booking_listbooking_row_paper: "Rows Paper",
          booking_listbooking_tablehead_status: "Status",
          booking_listbooking_cancel: "Cancel",
          booking_listbooking_tablehead_code: "Booking Code",
          booking_listbooking_tablehead_comming: "Comming",
          booking_listbooking_tablehead_customer: "Customer",
          booking_listbooking_tablehead_time: "Time",
          booking_listbooking_tablehead_quantity: "Quantity",
          booking_listbooking_tablehead_mobile: "Mobile",
          booking_listbooking_tablehead_branch: "Branch",
          booking_listbooking_tablehead_created_at: "Created at",
          booking_listbooking_no_record: "No record",
          booking_listbooking_editform_booking_code: "Code",
          booking_listbooking_editform_employee: "Employee",
          booking_listbooking_editform_status: "Status",
          booking_listbooking_editform_estimate_price: "Estimate Price",
          booking_listbooking_editform_tax: "Tax",
          booking_listbooking_editform_value_discount: "Value Discount",
          booking_listbooking_editform_voucher_money: "Voucher Money",
          booking_listbooking_editform_total_price: "Total Price",
          booking_listbooking_editform_save: "Save",
          booking_listbooking_editform_reason_spa_cancel: "Spa cancel reason",
          booking_listbooking_editform_item: "Item",
          booking_listbooking_editform_note_of_customer: "Note of Customer",
          booking_listbooking_editform_note_of_spa: "Note of Spa",
          booking_listbooking_this_status_is_not_implemented_here:
            "This status is not implemented here",
          booking_listbooking_booking_time: "Filter by time customer will come",
          booking_listbooking_click_to_pick_time: "Click to pick time",
          booking_listbooking_status_booking: "Filter by Status",
          booking_listbooking_show_all: "Show all",
          booking_listbooking_customer_comming_within_an_hour:
            "Customer comming within an hour",
          booking_create_create_booking: "Create booking",
          booking_create_customer_name: "Customer name",
          booking_create_quatity: "Quantity",
          booking_create_customerMobile: "Mobile",
          booking_create_time: "Time",
          booking_create_note_for_customer: "Note for customer",
          booking_create_note_for_spa: "Note for spa",
          booking_create_create: "Create",
          booking_create_mobile_not_valid: "Mobile is not valid",
          booking_create_please_fill_in_customer_name:
            "Please fill in customer name",
          booking_create_please_select_branch: "Please select branch",
          booking_create_not_found_service_code: "Not found service code",
          booking_bookings_cheking: "booking checking",
          booking_do_you_want_to_delete_selected_booking:
            "Do you want to delete selected booking",
          cancel: "Cancel",
          confirm: "Confirm",
          missed: "Missed",
          success: "Success",
          of: "of",
          all: "All",
          booking: "booking",

          //
          Please_select_at_least_one_method_to_send_voucher:
            "Please select at least one method to send voucher",
          voucher_list_voucher: "List Voucher",
          voucher_add_new_voucher: "Add New Voucher",
          voucher_search_code: "Search by code, title",
          voucher_image_gallery: "Image gallery",
          voucher_listvoucher_update_successfully: "Update successfully",
          voucher_listvoucher_update_unsuccessfully: "Update unsuccessfully",
          voucher_listvoucher_delete_successfully: "Delete successfully",
          voucher_listvoucher_delete_unsuccessfully: "Delete unsuccessfully",
          voucher_listvoucher_cancel: "Cancel",
          voucher_listvoucher_notice: "Notice",
          voucher_listvoucher_delete: "Delete",
          voucher_listvoucher_do_you_want_to_delete_this_voucher_from_list:
            "Do you want to delete this voucher from list?",
          voucher_listvoucher_type: "Type",
          voucher_listvoucher_update: "Update",
          voucher_listvoucher_rows_paper: "Rows Paper",
          voucher_listvoucher_tablehead_voucher_code: "Voucher Code",
          voucher_listvoucher_tablehead_voucher_title: "Title",
          voucher_listvoucher_tablehead_discount: "Discount/ times",
          voucher_listvoucher_discount: "Discount",
          voucher_listvoucher_tablehead_type: "Type",
          voucher_listvoucher_tablehead_start_date: "Start date",
          voucher_listvoucher_tablehead_end_date: "End Date",
          voucher_listvoucher_tablehead_item_time: "Item time",
          voucher_listvoucher_tablehead_total_discount: "Total discount",
          voucher_listvoucher_tablehead_times: "Times",
          voucher_listvoucher_tablehead_branch: "Branch",
          voucher_listvoucher_tabletoolbar_selected: "Selected",
          voucher_listvoucher_tabletoolbar_delete: "Delete",
          voucher_listvoucher_tabletoolbar_all_voucher: "All vouchers",
          voucher_listvoucher_cardvoucher_end_date: "End date",
          voucher_listvoucher_cardvoucher_discount: "Discount",
          voucher_listvoucher_cardvoucher_title: "Title (maximum length 255)",
          voucher_listvoucher_cardvoucher_all_branch: "Apply for all branches",
          voucher_listvoucher_cardvoucher_shortDescription:
            "Short Description (maximum length 255)",
          voucher_listvoucher_cardvoucher_description: "Description",
          voucher_listvoucher_do_you_want_to_update_this_voucher:
            "Do you want to update this voucher?",
          voucher_uservoucher_phone_number_existed_in_list_selected:
            "Phone number exist in list selected",
          voucher_uservoucher_phone_number_not_valid: "Phone number not valid",
          voucher_uservoucher_phone: "phone",
          voucher_uservoucher_customerlist: "Customer List",
          "voucher_uservoucher_system error_please_try_again":
            "System error please try again",
          voucher_uservoucher_please_select_at_least_one_customer:
            "Please select at least one customer",
          voucher_uservoucher_please_enter_at_least_one_phone_number:
            "Please enter at least one phone number",
          voucher_uservoucher_you_exceeded: "You exceeded ",
          voucher_uservoucher_times_allowed_to_send_vouchers_this_month_you_can_only_send_maximum:
            " times allowed to send vouchers this month. You can only send maximum ",
          voucher_uservoucher_mobile_phone_or_please_upgrade_your_package:
            " mobile phone or please upgrade your package",
          voucher_uservoucher_system_error_please_try_again:
            "System error, Please try again",
          voucher_uservoucher_sent_voucher: "Sent voucher ",
          voucher_uservoucher_successfully: " successfully",
          voucher_uservoucher_unsuccessfully: " unsuccessfully",
          voucher_uservoucher_cancel: "cancel",
          voucher_uservoucher_send: "send",
          voucher_uservoucher_send_by_sms: "Send by sms",
          voucher_uservoucher_send_notify_on_app: "Send notify on app",
          voucher_uservoucher_search_by_name_phone: "Search by name, mobile",
          voucher_uservoucher_notice: "Notice",
          voucher_uservoucher_upgrade: "Upgrade",
          voucher_uservoucher_send_voucher_to_customer:
            "Send Voucher To Customer",
          voucher_uservoucher_select_by_customer_list:
            "Select by customer list",
          voucher_uservoucher_select_by_phone_number: "Select by phone number",
          voucher_uservoucher_do_you_want_to_send_voucher:
            "Do you want to send voucher code",
          voucher_uservoucher_send_voucher: "Send voucher",
          voucher_uservoucher_you_can_only_send_maximum_of_100_customers_per_submission_to_send_more_customers_upgrade_your_package_to_premium:
            "You can only send maximum of 100 customers per submission. To send more customers upgrade your package to GOLD.",
          voucher_uservoucher_type_phone_number: "Type phone number",
          voucher_uservoucher_list_selected: "List selected",
          voucher_uservoucher_button_add: "Add",
          voucher_uservoucher_type_email: "Type email",
          voucher_uservoucher_to_user: "to the user?",
          voucher_uservoucher_to_user_this_will_send_notify_to_them_via_email:
            " to user. This will send notify to them via email",
          voucher_uservoucher_customers_or_please_upgrade_your_package:
            " customers or please upgrade your package",
          voucher_addvoucher_create: "Create",
          voucher_addvoucher_confirm: "Confirm",
          voucher_addvoucher_discount: "Discount",
          voucher_addvoucher_percent: "Percent",
          voucher_addvoucher_value: "Value",
          voucher_addvoucher_upload_image_in_gallery_successfully:
            "Update image in gallery successfully",
          voucher_addvoucher_upload_image_in_gallery_unsuccessfully:
            "Update image in gallery unsuccessfully",
          voucher_addvoucher_create_unsuccessfully:
            "Create voucher unsuccessfully",
          voucher_addvoucher_upload_image_unsuccessfully:
            "Upload voucher`s image unsuccessfully",
          voucher_addvoucher_cancel: "Cancel",
          voucher_addvoucher_notice: "Notice",
          voucher_addvoucher_do_you_want_to_add_new_voucher:
            "Do you want to add New Voucher?",
          voucher_addvoucher_nothing_apply_branch:
            "Nothing apply branch for this voucher",
          voucher_addvoucher_please_add_startedDate_discount:
            "Please add Start Date for this voucher",
          voucher_addvoucher_please_add_endedDate_discount:
            "Please add End Date for this voucher",
          voucher_addvoucher_please_add_endedDate_more_than_startedDate:
            "Please add End Date more than Start date",
          voucher_addvoucher_please_add_title:
            "Please add title for this voucher",
          voucher_addvoucher_please_add_shortDescription:
            "Please add short description for this voucher",
          voucher_addvoucher_please_add_discount:
            "Please add discount for this voucher",
          voucher_addvoucher_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Please add discount less than or equal to 100 for percent",
          voucher_addvoucher_create_successfully: "Create successfully",
          voucher_addvoucher_type: "Type",
          voucher_addvoucher_start_date: "Start Date",
          voucher_addvoucher_end_date: "End Date",
          voucher_addvoucher_save: "Save",
          voucher_addvoucher_image_voucher: "Image Voucher",
          voucher_addvoucher_upload_image_success: "Upload image success",
          voucher_addvoucher__upload_image_unsuccess: "Upload image unsuccess",
          voucher_delete_image_in_gallery: "Delete this image in gallery?",
          voucher_preview_voucher: "Preview voucher",
          voucher_listcustomer_edit_successfully: "Edit successfully",
          voucher_listcustomer_edit_unsuccessfully: "Edit unsuccessfully",
          voucher_listcustomer_delete_customer_successfully:
            "Delete customer successfully",
          voucher_listcustomer_delete_customer_unsuccessfully:
            "Delete customer unsuccessfully",
          voucher_listcustomer_do_you_want_to_delete_customer_from_customer_list:
            "Do you want to delete customer from customer list",
          voucher_listcustomer_customer_name: "Customer Name",
          voucher_listcustomer_mobile: "mobile",
          voucher_listcustomer_gender: "Gender",
          voucher_listcustomer_tabletoolbar_selected: "selected",
          voucher_listcustomer_district: "District",
          voucher_listcustomer_city: "City",
          voucher_listcustomer_tablehead_customer_name: "Customer name",
          voucher_listcustomer_tablehead_mobile: "Mobile",
          voucher_listcustomer_tablehead_gender: "Gender",
          voucher_listcustomer_tablehead_district: "District",
          voucher_listcustomer_tablehead_city: "City",
          selectebranchwithmap_branch: "Branch",

          // Member Card
          membercard: "Member Card",
          membercard_un_specified: "Unlimit",
          membercard_add_title: "Title",
          membercard_add_code: "Code",
          membercard_add_times: "Times",
          membercard_add_price: "Price buy",
          membercard_add_value: "Value used",
          membercard_add_shortDescription: "Short Description",
          membercard_add_all_branch: "Apply for all branches",
          membercard_add_expiredDays: "Expired Days (Day)",
          membercard_add_isShow: "Show on web",
          membercard_add_show: "Show",
          membercard_add_hide: "Hide",
          membercard_add_description: "Description",
          membercard_add_save: "Save",
          membercard_add_create_successfully: "Create Successfully",
          membercard_add_create_unsuccessfully: "Create Unsuccessfully",
          membercard_add_upload_image_unsuccessfully:
            "Upload Image Unsuccessfully",
          membercard_add_image: "Image Member Card",
          membercard_add_expired_days: "Expired Days",
          membercard_add_please_add_title: "Please add title",
          membercard_add_nothing_apply_branch:
            "Nothing apply branch for this member card",
          membercard_add_please_add_price_value: "Please add membercard price",
          membercard_add_please_add_expiredDays: "Please add expired days",
          membercard_add_new_membercard: "Add New Member Card",
          membercard_add_please_fill_in_required: "Please fill in required",
          membercard_list_update_successfully: "Update successfully",
          membercard_list_update_unsuccessfully: "Update unsuccessfully",
          membercard_list_delete_successfully: "Delete Successfully",
          membercard_list_delete_unsuccessfully: "Delete Unsuccessfully",
          membercard_list_cancel: "Cancel",
          membercard_list_notice: "Notice",
          membercard_list_membercard: "List Member Card",
          membercard_all_membercard: "All Member Card",
          membercard_list_delete: "Delete",
          membercard_list_do_you_want_to_delete_this_card_from_list:
            "Do you want to delete this card from list?",
          membercard_list_rows_paper: "Rows Paper",
          membercard_list_tabletoolbar_selected: "selected",
          membercard_list_tabletoolbar_delete: "delete",
          membercard_cardmember_description: "Description",
          membercard_search_title_code: "Search title, code",
          membercard_user_member_card_add_customer_button: "Add Customer",
          membercard_user_member_card_add_customer: "Add Customer",
          membercard_user_member_card_customer_name: "Customer Name",
          membercard_user_member_card_customer_mobile: "Customer Mobile",
          membercard_user_member_card_close: "Close",

          // UserMembercard
          user_membercard_user_already_have_the_membercard:
            "User have the membercard",
          user_membercard_history_search_by_order_code: "Search by order code",
          user_membercard_search_by_membercardCode_and_customerMobile:
            "Search by code, customer mobile",
          user_membercard_all_user_membercard: "All User Member Card",
          user_membercard_send_user_membercard_to_customer:
            "Send Member Card To Customer",
          user_membercard_do_you_want_to_delete_membercard_of_user:
            "Do you want to delete membercard of user",
          user_membercard_do_you_want_to_send_membercard: "Do you want to send",
          user_membercard_and_create_new_customer_if_they_are_not_in_customer_list:
            "Create new customers if they are not in the customer list",
          user_membercard_to_user: "to the user?",
          user_membercard_send_membercard: "Send Member card",
          user_membercard: "User Member Card",
          user_membercard_mobile: "Mobile",
          user_membercard_name: "Customer name",
          user_membercard_is_user: "User",
          user_membercard_balance: "Balance",
          user_membercard_img_member_card: "Image card",
          user_membercard_title: "Name card",
          user_membercard_expire_day: "Expire day",
          user_membercard_detail_order: "Order Detail",
          user_membercard_history_membercard: "Membercard history",
          user_membercard_history_membercard_not_found:
            "Not Found membercard history",
          user_membercard_users_card: "'s card",
          user_membercard_users: "User",
          user_membercard_time_to_use_card: "Time to use card",
          user_membercard_time_send_to_customer: "Time send to customer",
          user_membercard_value_to_use: "Value to use",
          user_membercard_type: "Membercard Type",
          user_membercard_membercardId: "Member card id",
          user_membercard_membercardCode: "Member code",
          user_membercard_short_description: "Short description",
          user_membercard_description: "Description",
          user_membercard_price_to_buy: "Price to buy",
          user_membercard_max_number_of_times_to_use:
            "Max number of times to use",
          user_membercard_used_number_of_times: "Used number of times",
          user_membercard_delete_success:
            "Delete member card of customer successfully",

          // My Spa---Branch
          servicebranch_list_branch: "List Branch",
          servicebranch_add_new_branch: "Add New Branch",
          servicebranch_search_name: "Search name",
          servicebranch_delete: "Delete",
          servicebranch_update: "Update",
          servicebranch_update_successfully: "Update successfully",
          servicebranch_update_unsuccessfully: "Update unsuccessfullly",
          servicebranch_cancel: "Cancel",
          servicebranch_notice: "Notice",
          servicebranch_row_paper: "Rows Paper",
          servicebranch_branch_name: "Branch Name",
          servicebranch_address: "Address",
          servicebranch_mobile: "Mobile",
          servicebranch_phone: "Phonei",
          are_you_sure_that_you_want_to_delete_this_branch:
            "Are you sure delete this branch?",
          servicebranch_delete_successfully: "Delete successfully",
          servicebranch_delete_unsuccessfully: "Delete unsuccessfully",
          servicebranch_tabletoolbar_selected: "selected",
          servicebranch_tabletoolbar_delete: "delete",
          servicebranch_editbranch_address_invalid: "Please enter valid addres",
          servicebranch_createbranch_please_enter_valid_phone:
            "Please enter valid mobile",
          servicebranch_editbranch_branch_name: "Branch Name",
          servicebranch_editbranch_mobile: "Mobile",
          servicebranch_editbranch_phone: "Phone",
          servicebranch_editbranch_address: "Address",
          servicebranch_editbranch_city: "City",
          servicebranch_editbranch_district: "District",
          servicebranch_editbranch_go_to_location: "Go to location",
          servicebranch_editbranch_suggest_address:
            "Suggess address to show on map",
          servicebranch_editbranch_latitude: "Latitude",
          servicebranch_editbranch_longitude: "longitude",
          servicebranch_editbranch_save: "Save",
          servicebranch_are_you_sure_that_you_want_to_update_this_branch:
            "Are you sure update this branch?",
          servicebranch_createbranch_address_invalid:
            "Address to show on map invalid",
          servicebranch_createbranch_fill_in_branch_name:
            "Please fill in branch name",
          servicebranch_createbranch_fill_in_branch_mobile:
            "Please fill in mobile",
          servicebranch_createbranch_fill_in_branch_address:
            "Please fill in address",
          servicebranch_createbranch_fill_in_branch_address_to_show_on_map:
            "Please fill in address to show on map",
          servicebranch_createbranch_create_successfully: "Create successfully",
          servicebranch_createbranch_create_unsuccessfully:
            "Create unsuccessfully",
          servicebranch_createbranch_cancel: "Cancel",
          servicebranch_createbranch_create: "Create",
          servicebranch_createbranch_confirm: "Confirm",
          servicebranch_createbranch_branch_name: "Branch Name",
          servicebranch_createbranch_mobile: "Mobile",
          servicebranch_createbranch_phone: "Phone",
          servicebranch_createbranch_address: "Address",
          servicebranch_createbranch_city: "City",
          servicebranch_createbranch_district: "District",
          servicebranch_createbranch_go_to_location: "Go to location",
          servicebranch_createbranch_save: "Save",
          servicebranch_createbranch_create_new_branch_for_your_spa:
            "Create a new branch for your spa",
          select_branch_with_map_all_branch: "All branch",
          servicebranch_tablehead_branch_name: "Branch",
          servicebranch_tablehead_address: "Address",
          servicebranch_tablehead_mobile: "Mobile",
          servicebranch_tablehead_phone: "Phone",
          servicebranch_search_code_name_address: "Search Code, name, address",

          // My Spa--Detail
          service_workingdays_opening_hour: "Opening Hour",
          service_workingdays_close_hour: "Close Hour",
          service_workingdays_day_off: "Day Off",
          service_workingdays_monday: "Monday",
          service_workingdays_tuesday: "Tuesday",
          service_workingdays_wednesday: "Wednesday",
          service_workingdays_thursday: "Thursday",
          service_workingdays_friday: "Friday",
          service_workingdays_saturday: "Saturday",
          service_workingdays_sunday: "Sunday",
          // MySpa --menu
          menu_menu: "Menu",
          menu_menugroup_cancel: "Cancel",
          menu_menugroup_yes: "Yes",
          menu_menugroup_confirm: "Confirm",
          menu_menugroup_do_you_want_to_delete_this_menu_group:
            "Do you want to delete this menu group?",
          menu_menugroup_nothing_item_selected: "Nothing item selected",
          menu_menugroup_menugroup: "Menu Group",
          menu_menugroup_selected: "Selected",
          menu_menugroup_delete: "Delete",
          menu_menugroup_delete_successfully: "Delete successfully",
          menu_menugroup_delete_unsuccessfully: "Delete unsuccessfully",
          menu_menugroup_name: "Menu",
          menu_menugroup_menu_group_empty: "Menu group empty",
          menu_menugroup_listmenugroup_delete_successfully:
            "Delete successfully",
          menu_menugroup_listmenugroup_delete_unsuccessfully:
            "Delete unsuccessfully",
          menu_menugroup_listmenugroup_cancel: "Cancel",
          menu_menugroup_listmenugroup_yes: "Yes",
          menu_menugroup_listmenugroup_confirm: "Confirm",
          menu_menugroup_listmenugroup_nothing_item_is_selected:
            "Nothing item is selected",
          menu_menugroup_listmenugroup_do_you_want_to_delete_this_menu_group:
            "Do you want to delete this menu group from list?",
          menu_menugroup_listmenugroup_menugroup: "Menu Group",
          menu_menugroup_listmenugroup_rowpaper: "Rows Paper",
          menu_menugroup_addmenugroup_cancel: "Cancel",
          menu_menugroup_addmenugroup_yes: "Yes",
          menu_menugroup_addmenugroup_confirm: "Confirm",
          menu_menugroup_addmenugroup_please_fill_in_name:
            "Please fill in category name",
          menu_menugroup_addmenugroup_add_new_menu_group: "Add Menu",
          menu_menugroup_addmenugroup_add: "Add",
          menu_menugroup_addmenugroup_title: "Title",
          menu_menugroup_editmenugroup_edit_successfully: "Edit successfully",
          menu_menugroup_editmenugroup_cancel: "Cancel",
          menu_menugroup_editmenugroup_yes: "Yes",
          menu_menugroup_editmenugroup_confirm: "Confirm",
          menu_menugroup_editmenugroup_do_you_want_to_change_name_of_this_menu_group:
            "Do you want to change information of this menu group?",
          menu_menugroup_editmenugroup_edit_unsuccessfully:
            "Edit unsuccessfully",
          menu_menugroup_editmenugroup_name: "Category Name",
          menu_menugroup_editmenugroup_save: "Save",
          menu_menugroup_editmenugroup_add: "Add",
          menu_menugroup_editmenugroup_featured: "Featured Menu",
          menu_menugroup_editmenugroup_not_featured: "Not Featured Menu",
          menu_menugroup_editmenugroup_not_selected: "Not Selected",
          menu_menuitem_search: "Search title",
          menu_menuitem_delete_successfully: "Delete successfully",
          menu_menuitem_delete_unsuccessfully: "Delete unsuccessfully",
          menu_menuitem_cancel: "Cancel",
          menu_menuitem_yes: "Yes",
          menu_menuitem_select_menu_parent: "Parent category",
          menu_menuitem_confirm: "Confirm",
          menu_menuitem_do_you_want_to_delete_this_menu_group_from_list:
            "Do you want to delete this menu group from list?",
          menu_menuitem_nothing_item_is_selected: "Nothing item is selected",
          menu_menuitem_menu_item: "Item",
          menu_menuitem_edit_menu: "Edit Menu",
          menu_menuitem_featured_item: "Featured",
          menu_menuitem_all_item: "All",
          menu_menuitem_item_type: "Item Type",
          menu_menuitem_not_featured_item: "Not Featured",
          menu_menuitem_rows_paper: "Rows Paper",
          menu_menuitem_tablehead_title: "Name",
          menu_menuitem_tablehead_description: "Description",
          menu_menuitem_tablehead_price: "Price",
          menu_menuitem_tablehead_unit: "Unit",
          menu_menuitem_tablehead_time: "Time",
          menu_menuitem_tablehead_featured: "Featured",
          menu_menuitem_toolbaritem_selected: "Selected",
          menu_menuitem_toolbaritem_delete: "Delete",
          menu_menuitem_editmenuitem_update_successfully: "Update successfully",
          menu_menuitem_editmenuitem_update_unsuccessfully:
            "Update unsuccessfully",
          menu_menuitem_editmenuitem_cancel: "Cancel",
          menu_menuitem_editmenuitem_yes: "Yes",
          menu_menuitem_editmenuitem_confirm: "Confirm",
          menu_menuitem_editmenuitem_are_you_sure_you_want_to_change_in_menu_item:
            "Are you sure you want to change in menu item?",
          menu_menuitem_selectmenu_please_select_one_menuId:
            "Please select one menuId",
          menu_menuitem_editmenuitem_title: "Title",
          menu_menuitem_editmenuitem_unit: "Unit",
          menu_menuitem_editmenuitem_price: "Price",
          menu_menuitem_editmenuitem_save: "Save",
          menu_menuitem_editmenuitem_description: "Description",
          menu_menuitem_addmenuitem_please_select_menu_group:
            "Please select menu group",
          menu_menuitem_addmenuitem_please_fill_in_title:
            "Please fill in title",
          menu_menuitem_addmenuitem_please_input_description:
            "Please input description",
          menu_menuitem_addmenuitem_please_fill_in_price:
            "Please fill in price",
          menu_menuitem_addmenuitem_please_fill_in_time: "Please fill in time",
          menu_menuitem_addmenuitem_cancel: "Cancel",
          menu_menuitem_addmenuitem_yes: "Yes",
          menu_menuitem_addmenuitem_confirm: "Confirm",
          menu_menuitem_addmenuitem_add_new_menu_item: "Add Menu Item",
          menu_menuitem_addmenuitem_title: "Title",
          menu_menuitem_addmenuitem_description: "Description",
          menu_menuitem_addmenuitem_price: "Price",
          menu_menuitem_addmenuitem_price_to_show_on_web:
            "Price to show on web",
          menu_menuitem_addmenuitem_time: "Time",
          menu_menuitem_addmenuitem_position: "Position",
          menu_menuitem_addmenuitem_group: "Group",
          menu_menuitem_editmenuitem_time: "Time",
          menu_menuitem_editmenuitem_minute: "Min",
          menu_menuitem_editmenuitem_times: "Times",
          // 'menu_menuitem_addmenuitem_type': 'Type',
          menu_menuitem_addmenuitem_add: "Add",
          menu_menuitem_remove_item_featured_successfully:
            "Remove item featured successfully",
          menu_menuitem_remove_item_featured_unsuccessfully:
            "Remove item featured unsuccessfully",
          menu_menuitem_add_item_featured_successfully:
            "Add item featured successfully",
          menu_menuitem_add_item_featured_unsuccessfully:
            "Add item featured unsuccessfully",
          menu_menuitem_menu_item_empty:
            "Menu item empty. Press add icon to create new menu item",

          remove_featured: "Remove From Feature",
          add_featured: "Add To Feature",
          menu_menuitem_min: "Min",
          menu_add_successfully: "Add successfully",
          menu_add_unsuccessfully: "Add Unsuccessfully",
          // Customer
          customer_list_customers: "List Customers",
          customer_add_new_customer: "Add New Customer",
          customer_search_by_name_email_phone: "Search name, email and phone",
          customer_chart: "Chart",
          customer_chart_edit_unsuccessfully: "Edit unsuccessfully",
          customer_chart_chartage_the_value_of: "The value of",
          customer_chart_chartgender_the_value_of: "The value of",
          customer_chart_chartage_is: "is",
          customer_chart_chartgender_is: "is",
          customer_addcustomer_cancel: "cancel",
          customer_addcustomer_create_customer: "Create",
          customer_addcustomer_cancel_customer: "Cancel",
          customer_addcustomer_phone_number_is_not_valid:
            "Phone Number is not valid",
          customer_addcustomer_notice: "Notice",
          customer_addcustomer_confirm: "Confirm",
          customer_addcustomer_add_new_customer: "Add new customer",
          customer_addcustomer_name: "Name",
          customer_addcustomer_birthDay: "Birth day",
          customer_addcustomer_add: "Add",
          customer_addcustomer_gender: "Gender",
          customer_addcustomer_address: "Address",
          customer_useSerives: "Used Services",
          customer_useSerives_placeholder:
            "Fill in some characters to show suggestions ",
          customer_interesting_placeholder:
            "Fill in character `Menu` to show suggestion",
          customer_interesting: "Interesting",
          customer_lastTime: "Last time go to spa",
          customer_addcustomer_mobile: "Mobile",
          customer_addcustomer_city: "City",
          customer_addcustomer_state: "State",
          customer_addcustomer_country: "Country",
          customer_addcustomer_district: "District",
          customer_addcustomer_please_fill_in_this_form:
            "Please fill in this form",
          customer_listcustomer_do_you_want_to_remove_customer_from_customer_list:
            "Do you want to remove customer from Customer List?",
          customer_listcustomer_editcustomer_are_you_sure_that_you_want_to_edit_customer_information:
            "Are you sure that you want to edit customer information?",
          customer_listcustomer_editcustomer_customer_code: "Customer Code",
          customer_listcustomer_editcustomer_created_at: "Create at",
          customer_listcustomer_editcustomer_updated_at: "Updated at",
          customer_listcustomer_editcustomer_name: "Name",
          customer_listcustomer_editcustomer_country_code: "Code",
          customer_listcustomer_editcustomer_mobile: "Mobile",
          customer_listcustomer_editcustomer_address: "Address",
          customer_listcustomer_editcustomer_city: "City",
          customer_listcustomer_editcustomer_district: "District",
          customer_listcustomer_editcustomer_birthDay: "Birth day",
          customer_listcustomer_editcustomer_gender: "Gender",
          customer_listcustomer_editcustomer_view_report: "View Report",
          customer_listcustomer_editcustomer_save: "Save",
          customer_chart_edit_successfully: "Edit successfully",
          customer_chart_gender: "GENDER",
          customer_chart_age: "AGE",
          customer_chart_delete_customer_successfully:
            "Delete customer successfully",
          customer_chart_delete_customer_unsuccessfully:
            "Delete customer unsuccessfully",
          customer_create_customer_successfully: "Create customer successfully",
          customer_create_customer_unsuccessfully:
            "Create customer unsuccessfully",
          customer_not_found_any_customer: "Not found any customer",
          customer_customer_existed_please_try_again:
            "Customer existed.Please try again",
          customer_upload_image_and_create_customer_unsuccessfully:
            "Upload image and create customer unsuccessfully",
          customer_addcustomer_upload_error: "Upload Error",
          customer_report: "Customer Report",
          customer_customer_report_first_order_day: "First order day",
          customer_customer_report_last_order_day: "Last order day",
          customer_customer_report_orders_to_date: "Orders to date",
          "customer_customer_report_average order value": "Average order value",
          customer_customer_report_order_value_to_date: "Order value to date",
          customer_customer_report_date: "Date",
          customer_customer_report_orders_by_items: "Orders by Items",
          customer_customer_report_items: "Items",
          customer_customer_report_orders_by_branches: "Orders by Branches",
          customer_customer_report_branches: "Branches",
          customer_customer_report_summary: "Summary",
          customer_customer_report_start_date_should_not_be_more_than_ended_date:
            "Start date should not be more than ended Date",
          customer_customer_report_end_date_should_not_be_less_than_start_date:
            "End date should not be less than start Date",
          customer_listcustomer_edit_successfully: "Edit successfully",
          customer_listcustomer_edit_unsuccessfully: "Edit unsuccessfully",
          customer_listcustomer_delete_customer_successfully:
            "Delete successfully",
          customer_listcustomer_delete_customer_unsuccessfully:
            "Delete unsuccessfully",
          customer_listcustomer_cancel: "Cancel",
          customer_listcustomer_continute: "Continue",
          customer_listcustomer_confirm: "Confirm",
          customer_listcustomer_rows_paper: "Rows Paper",
          customer_listcustomer_day_of_birth: "Day of birth",
          customer_listcustomer_created_at: "Created At",
          customer_listcustomer_mobile: "Mobile",
          customer_listcustomer_email: "Email",
          customer_listcustomer_age: "Age",
          customer_listcustomer_gender: "Gender",
          customer_listcustomer_country: "Country",
          customer_listcustomer_city: "City",
          customer_listcustomer_district: "District",
          customer_listcustomer_ward: "Ward",
          customer_listcustomer_infomation: "Infomation",
          customer_listcustomer_contact: "Contact",
          customer_listcustomer_address: "Address",
          customer_listcustomer_report: "Report",
          customer_listcustomer_all_customers: "All Customers",
          customer_listcustomer_close: "Close",
          customer_listcustomer_edit: "Edit",
          customer_listcustomer_record_found: "records found",
          customer_listcustomer_page: "page",
          customer_listcustomer_of: "of",
          customer_listcustomer_apply_filter: "Apply Filter",
          customer_listcustomer_export_excel: "Export",
          customer_listcustomer_clear: "Clear",
          customer_listcustomer_tablehead_customer_name: "Name",
          customer_listcustomer_tablehead_gender: "Gender",
          customer_listcustomer_tablehead_mobile: "Mobile",
          customer_listcustomer_tablehead_email: "Email",
          customer_listcustomer_tablehead_district: "District",
          customer_listcustomer_tablehead_city: "City",
          customer_listcustomer_tablehead_created_at: "Created at",
          customer_listcustomer_tablehead_updated_at: "Update at",
          customer_listcustomer_tablehead_edit: "Edit",
          customer_listcustomer_toolbar_selected: "selected",
          customer_listcustomer_toolbar_delete: "delete",
          customer_listcustomer_editcustomer_edit_avatar_successfully:
            "Edit avatar successfully",
          customer_listcustomer_editcustomer_edit_avatar_error:
            "Edit avatar error",
          customer_listcustomer_editcustomer_cancel: "Cancel",
          customer_listcustomer_editcustomer_continute: "Continue",
          customer_listcustomer_editcustomer_confirm: "Confirm",

          // Dashboard
          dashboard_admin_total_active_spa: "Total active spa",
          dashboard_reaction_reaction: "Reaction",
          dashboard_reaction_like: "Like",
          dashboard_reaction_heart: "Heart",
          dashboard_reaction_follow: "Follow",
          dashboard_reaction_toolbar_total_reaction: "Total Reaction",
          dashboard_reaction_toolbar_last_3_months_before:
            "Last 3 months before",
          dashboard_order: "Order",
          dashboard_order_toolbar_total: "Total",
          dashboard_order_toolbar_orders: "Orders",
          dashboard_order_toolbar_all_orders: "All Orders",
          dashboard_order_toolbar_from: "From",
          dashboard_order_toolbar_type: "Type",
          dashboard_order_toolbar_to: "To",
          dashboard_booking_from: "From",
          dashboard_booking_to: "To",
          dashboard_booking: "Booking",
          dashboard_booking_total: "Total",
          dashboard_booking_bookings: "Bookings",
          date_picker_ok: "OK",
          date_picker_cancel: "Cancel",
          new: "New",
          processing: "Processing",
          done: "Done",
          next: "Next",
          checking: "Checking",
          abort: "Abort",
          //googlemap
          "googlemap_can't_find_this_address": "Can't find this address",
          "googlemap_address_can't_empty": "Address can't empty",
          //selected language
          selectedlanguage_support: "Support",
          // Employees
          employees_add_new_employee_successfully:
            "Add new employee successfully",
          employees_add_new_employee: "Add new employee",
          employees_search: "Search code, name, nickname, mobile",
          employees_code: "Code",
          employees_listemployee_date: "Date",
          employees_listemployee_month: "Month",
          employees_listemployee_hour: "Hour",
          employees_listemployee_delete: "Delete",
          employees_listemployee_delete_successfully: "Delete successfully",
          employees_listemployee_delete_delete_unsuccessfully:
            "Delete unsuccessfully",
          employees_listemployee_cancel: "Cancel",
          employees_listemployee_notice: "Notice",
          employees_listemployee_rows_paper: "Rows paper",
          employees_listemployee_active: "Active",
          employees_listemployee_inactive: "Inactive",
          employees_listemployee_tablehead_name: "Name",
          employees_listemployee_tablehead_nickname: "Nickname",
          employees_listemployee_tablehead_mobile: "Mobile",
          employees_listemployee_tablehead_employee_type: "Type",
          employees_listemployee_tablehead_module_role: "Module-role",
          employees_listemployee_tablehead_active: "Active",
          employees_listemployee_tablehead_edit: "Edit",
          employees_listemployee_tablehead_salary: "Salary",
          employees_listemployee_toolbar_selected: "selected",
          employees_listemployee_toolbar_delete: "Delete",
          all_employee: "All employees",
          employees_listemployee_editemployee_editcontent_module_role:
            "Module role",
          employees_listemployee_editemployee_editcontent_edit_employee_information:
            "Edit Employee information",
          employees_listemployee_editemployee_editcontent_delete: "Delete",
          employees_listemployee_editemployee_editcontent_update: "Update",
          employees_listemployee_tablehead_employeeNumber: "Code",
          employees_listemployee_editemployee_editcontent_update_successfully:
            "Update successfully",
          employees_listemployee_editemployee_editcontent_update_unsuccessfully:
            "Update unsuccessfully",
          employees_listemployee_editemployee_editcontent_delete_successfully:
            "Delete successfully",
          employees_listemployee_editemployee_editcontent_delete_unsuccessfully:
            "Delete unsuccessfully",
          employees_listemployee_editemployee_editcontent_cancel: "Cancel",
          employees_listemployee_editemployee_editcontent_notice: "Notice",
          employees_listemployee_editemployee_editcontent_name: "Name",
          employees_listemployee_editemployee_editcontent_nickname: "Nickname",
          employees_listemployee_editemployee_editcontent_mobile: "Mobile",
          employees_listemployee_editemployee_editcontent_usercode: "UserCode",
          employees_listemployee_editemployee_editcontent_employee_no:
            "Employee No.",
          employees_listemployee_editemployee_editcontent_employee_code: "Code",
          employees_listemployee_editemployee_editcontent_employee_created_at:
            "Created at",
          employees_listemployee_editemployee_editcontent_employee_updated_at:
            "Updated at",
          employees_listemployee_editemployee_editcontent_employee_active:
            "Active",
          employees_listemployee_editemployee_editcontent_employee_salary:
            "Salary",
          employees_listemployee_editemployee_editcontent_employee_typeSalary:
            "Type salary",
          employees_listemployee_editemployee_editcontent_fired: "Fired",
          employees_listemployee_fire_successfully: "Fire successfully",
          employees_listemployee_fire_unsuccessfully: "Fire unsuccessfully",
          employees_listemployee_editemployee_editcontent_save: "Save",
          employees_listemployee_editemployee_editcontent_employee_notification:
            "Notification",
          employees_listemployee_editemployee_editcontent_days: "days",
          employees_listemployee_editemployee_editcontent_employee_will_expire_in:
            "will expire in",
          employees_listemployee_editemployee_editcontent_employee_bonus:
            "Bonus",
          employees_listemployee_editemployee_editcontent_employee_typeBonus:
            "Type bonus",
          employees_listemployee_editemployee_editcontent_percent: "Percent",
          employees_listemployee_editemployee_editcontent_value: "Value",
          employees_listemployee_editemployee_editcontent_value_must_be_less_than_1:
            "Value percent must be less than 1",
          employees_listemployee_editemployee_editcontent_click: ". Click",
          employees_listemployee_editemployee_editcontent_here: "here",
          "employees_listemployee_editemployee_editcontent_to update":
            "to update",
          employees_listemployee_are_you_sure_that_you_want_to_delete:
            "Are you sure that you want to delete?",
          employees_list_employees: "List Employees",
          employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_fired_employee_out_of_system:
            "Are you sure that you want to fired employee out of system?",
          employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_edit_it:
            "Are you sure that you want to edit it?",
          employees_listemployee_editemployee_editcontent_fill_in_name:
            "Please fill in employee`s name",
          employees_listemployee_editemployee_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Please add bonus less than or equal to 100 for percent",
          employee_addemployee_invite_employee: "Invite Employee",
          employee_addemployee_phone_number_no_valid_please_try_again:
            "Phone Number not valid. Please try again",
          employee_addemployee_please_pick_a_branch_at_least:
            "Please pick a branch at least for this employee",
          active_code_expired: "Active code expired",
          employee_addemployee_the_active_code_incorrect_please_try_again:
            "Active code incorrect. Please try again.",
          employee_addemployee_an_error_occurred_please_try_again_or_contact_your_administrators:
            "An error occurred. Please  try again or contact your administrators!",
          employee_addemployee_add_new_employee: "Add new employee",
          employee_addemployee_enter_activecode_send_to_phone_number:
            "Enter ActiveCode sent to phone number",
          employee_addemployee_to_confirm: "to confirm",
          employee_addemployee_the_active_code_unexpired_so_you_can_not_request_again:
            "Active code unexpired so you can not request again",
          employee_addemployee_phone_number_not_register_account_please_try_again:
            "Phone number not register account. Please try again",
          employee_addemployee_phone_number_existed_on_employee_management_system_please_try_again:
            "Phone number existed on employee management system. Please try again",
          employee_addemployee_type_phone_number: "Type phone number",
          employee_addemployee_send_an_activeCode_to_this_phone_number_and_invite_them_become_employee:
            "send an active code to this phone number and invite them become employee",
          employee_addemployee_cancel: "Cancel",
          employee_addemployee_send: "Send",
          employee_addemployee_notice: "Notice",
          employee_addemployee_confirm: "Confirm",
          employee_addemployee_error_with_code:
            "Create active code give an error code",
          employee_addemployee_user_had_role_owner_or_employee_for_this_spa:
            "User had role owner or employee for this spa",
          employee_addemployee_arrBranch: "Branch",
          employee_addemployee_phone_number: "Phone number",
          employee_addemployee_type_employee: "Type employee",
          employee_addemployee_operator: "Operator",
          employee_addemployee_executor: "Executor",
          employee_addemployee_all_branch: "All branch",
          employee_addemployee_resend: "resend",
          employee_addemployee_active_code_will_expire_after:
            "Active code will expire after",
          employee_addemployee_register_success_pls_login:
            "Your account is created successfully. Please login to Masspa Admin with your account and password",
          employee_addemployee_invite_within_three_days:
            "invite you to work. Please access the link below to register an account within 3 days: ",
          // login
          Login_user_inactive: "User inactive, please contact admin",
          Login_your_account_inactive_or_deleted:
            "Your account inactive or deleted",
          Login_your_service_deleted: "Your service deleted",
          Login_phone_number_and_password_combination_is_incorrect:
            "Username and password combination is incorrect",
          Login_please_enter_password: "Please enter password",
          Login_error_access_account:
            "You don`t have permission to access this account",
          Login_error_package_expired: "Your Package expired",
          Login_phone_number_is_not_valid: "Phone number is not valid",
          Login_the_passord_field_length_must_be_greater_than_or_equal_to_6_characters_long:
            "The 'password' field length must be greater than or equal to 6 characters long!",
          login_enter_your_new_password_that_more_than_6_character:
            "Your new password must contain at least 6 character at length",
          login_please_enter_active_code_to_send_your_phone_number_before_reseting_password:
            "Please enter active code to send your phone number before reseting password",
          login_please_enter_phone_number_that_you_want_to_reset_the_password:
            "Please enter phone number that you want to reset the password.",
          login_change_password_successfully: "Change password successfully!",
          login_change_password_unsuccessfully:
            "Change password unsuccessfully!",
          login_password_not_match: "Password not match!",
          login_active_code_is_not_correct_please_enter_activecode_again:
            "Active Code is not correct. Please enter active code again",
          login_not_found_phone_number_please_enter_again:
            "Not found phone number. Please enter again",
          login_please_enter_the_correct_phone_number_that_you_want_to_reset_the_password:
            "Please enter the correct phone number that you want to reset the password",
          login_phone_number: "Phone Number",
          login_send_active_code: "Send active code",
          login_password: "Password",
          login_forgot_password: "Forgot password?",
          login_sign_in: "Sign in",
          login_login: "Login",
          login_back: "Back",
          login_reset_password: "Reset password",
          login_enter_new_password: "ENTER NEW PASSWORD",
          login_confirm_new_password: "Confirm new passsword",
          login_new_password: "New password",
          login_set_new_password: "Set New Password",
          login_subscribe: "Subscribe",
          "login_to_subscribe_to_this_website_please_enter_your_email_address_here_we_will_send_updates_occasionally.":
            "To subscribe to this website, please enter your email address here. We will send updates occasionally",
          login_cancel: "Cancel",
          login_change: "Change",
          login_you_should_change_password_at_first_login:
            "You should change password at first login",
          login_notice: "Notice",
          login_change_password: "Change password",
          login_set_later: "Set later",
          login_employee_executor_can_not_login_admin_page:
            "Employee executor can not login admin page",
          login_you_havent_registered_a_masspa_in_system_so_you_can_not_access_admin_page_lets_click_sign_up: `Bạn chưa đăng kí một Masspa nào trên hệ thống. Do vậy bạn không thể đăng nhập vào trang quản lí. Hãy nhấn nút "Đăng kí" ngay bên dưới`,
          Login_with_role: "Login with role",
          ownerSpa: "Owner",
          user: "User",
          employeeAdmin: "Employee Admin",
          employeeSpa: "Employee Spa",
          admin: "Admin",
          //countryCode
          countrycode_code: "Code",
          //fanpage
          pls_enter_facebook_id: "Please, enter Facebook ID",
          fanpage_submit: "Submit",
          fanpage_you_have_sent_it_successfully:
            "You have save it successfully!",
          fanpage_you_have_sent_it_Unsuccessfully:
            "You have save it Unsuccessfully!",
          // serviceStableCost
          service_table_cost: "Service stable cost",
          service_table_cost_cost_name: "Cost Name",
          service_table_cost_cost_value: "Cost Value",
          service_table_cost_delete: "Delete",
          service_table_cost_electrict_cost: "Electrict cost",
          service_table_cost_water_cost: "Water cost",
          service_table_cost_internet_cost: "Internet cost",
          service_table_cost_space_cost: "Space cost",
          service_table_cost_clean_cost: "Clean cost",
          service_table_cost_please_fill_in_cost_name:
            "Please fill in cost name",
          service_table_cost_add: "Add",
          service_table_cost_save: "Save",
          service_table_cost_update_service_cost_successfully:
            "Update service cost successfully",
          service_table_cost_update_service_cost_unsuccessfully:
            "Update service cost unsuccessfully",
          service_table_cost_name_is_already_in_use:
            "Cost name is already in use by system. Please try choose another name",
          // serviceCost
          service_cost_total_price: "TOTAL PRICE",
          service_cost_add_new: "Add new",
          service_cost_total_employee_salary: "Total employee salary",
          service_cost_you_dont_save_changes:
            "Press button SAVE to save your changes for this month",
          service_cost_update_service_cost_success: "Update ",
          service_cost_salary_employee_employee_name: "Employee name",
          service_cost_salary_employee_working_time: "Working hour",
          service_cost_salary_employee_day_off: "Day off",
          service_cost_salary_employee_salary: "Salary",
          service_cost_salary_employee_bonus_salary: "Bonus salary",
          service_cost_salary_employee_delete: "Delete",
          service_cost_salary_employee_cancel: "Cancel",
          service_cost_salary_employee_continute: "Continute",
          service_cost_salary_employee_confirm: "Confirm",
          service_cost_salary_employee_delete_this_employee_salary:
            "Delete this employee`s salary",
          service_cost_confirmUpdateSalary_select_new_employees_that_you_want_to_update_their_salary_for_this_month:
            "Select new employees that you want to update their salary for this month",
          service_cost_confirmUpdateSalary_are_you_sure_you_want_to_update_salaries_of_all_employees:
            "Are you sure you want to update salaries of all employees?",
          service_cost_month_1: "January",
          service_cost_month_2: "February",
          service_cost_month_3: "March",
          service_cost_month_4: "April",
          service_cost_month_5: "May",
          service_cost_month_6: "June",
          service_cost_month_7: "July",
          service_cost_month_8: "August",
          service_cost_month_9: "September",
          service_cost_month_10: "October",
          service_cost_month_11: "November",
          service_cost_month_12: "December",
          service_cost_update_employee_salary_according_to_current_data:
            "Update employee salary according to current data",
          service_cost_are_you_sure_you_want_to_delete_this_cost:
            "Are you sure you want to delete this cost?",

          // FileReader
          file_reader_upload_photo: "Upload photo",
          file_reader_delete: "Delete",
          file_reader_select_image: "Select from storage",

          login_user_not_found: "User not found",

          // Select language
          select_language_korean: "Korean",
          select_language_japanese: "Japanese",

          //Product
          product_product_category: "Category",
          product_search: "Search SKU, name",
          product_category_please_fill_in_name: "Please fill in category name",
          product_product_category_root: "Root",
          product_product_category_parent_category: "Root Category",
          product_edit_product_category: "Edit product category",
          product_add_product_category: "Add new product category",
          product_product: "Product",
          product_please_fill_in_name_product: "Please fill in name product",
          product_edit_product: "Edit product",
          product_add_product: "Add product",
          product_product_featured_item: "Featured product",
          product_title: "Product title",
          product_visible: "Visible status",
          product_visible_status: "Visible",
          product_hide_status: "Hide",
          product_volume: "Volume",
          product_price: "Price",
          product_date_expired: "Expiration Date",
          product_manufacturing_date: "Manufacturing Date ",
          product_madeIn: "Made In",
          product_brand: "Brand",
          product_currencyCode: "Currrency code",
          product_dimensions_length: "Length",
          product_dimensions_height: "Height",
          product_dimensions_width: "Width",
          product_position: "Position",
          product_weight: "Weight",
          product_stock_quantity: "Product quantity in stock",
          product_color_name: "Color name",
          product_color_code: "Color code(example: red,black)",
          product_color_value: "Color code in hex(example: #fff)",
          product_color_type: "Color type",
          product_color_type_system: "System",
          product_color_type_image: "Image",
          product_please_fill_in_title: "Please fill in product title",

          product_additional_info: "Additional Info",
          product_sku: "Sku",
          stock_quantity: "Stock quantity",
          product_stock_weight: "Stock weight",
          product_regular_price: "Regular price",
          product_no: "No",
          product_yes: "Yes",
          product_all: "All",
          product_stock_status: "Stock status",
          product_out_of_stock: "Out of stock",
          product_available: "Available",
          product_backorder: "Backorder",
          product_preorder: "Preorder",
          product_discontinued: "Discontinuted",
          product_edit: "Edit",
          product_enabled: "Enabled",
          product_on_sale: "On sale",
          product_all_product: "All product",
          product_manage_product_category: "Manage",
          product_do_you_want_to_delete_product:
            "Do you want to delete seleced product",
          product_list_product: "List product",
          product_category: "Category",
          product_additional_category: "Addtional category",
          product_tag: "Tag",
          product_related_product: "Related product",
          product_attribute_name: "Attribute name",
          product_attribute_value: "Attribute  value",
          product_add_new_attribute: "ADD ATTRIBUTE",
          product_name: "Name",
          product_slug: "Slug",
          product_page_title: "Page title",
          product_meta_description: "Meta description",
          product_description: "Description",
          product_inventory: "Inventory",
          product_variants: "Variants",
          product_attribute: "Attributes",
          product_image: "Image",
          product_pricing: "Pricing",
          product_sale_price: "Sale price",
          product_sale_from: "Sale from",
          product_sale_to: "Sale to",
          product_expected_date: "Expected day",
          product_manage_stock: "Manage stock",
          product_search_product: "Search product by name",
          product_cancel: "Cancel",
          product_add: "Add",

          product_variant_price: "Price",
          product_variant_stock: "Variant stock",
          product_variant_weight: "Variant weight",
          product_add_new_variant: "New variant",

          product_update: "Update",
          product_create: "Create",
          product_delete: "Delete",

          // product category
          product_category_name: "Category name",
          product_category_image: "Category Iamge",
          product_category_create_product_category: "Create Product Category",
          product_category_description: "Description",
          product_category_enable: "Enabled",
          product_category_slug: "Slug",
          product_category_page_title: "Page title",
          product_category_meta_description: "Meta description",

          // category post
          category_post_add_new_category: "Add new category",
          category_post_edit_category: "Edit category",
          category_post_new_category_name: "New Category Name",
          category_post_choose_a_parent_category: "Choose a Parent Category",
          category_post_search: "Search",
          category_post_cancel: "Cancel",
          category_post_add: "Add",
          category_post_edit: "Edit",
          category_post_yes: "Yes",
          category_post_confirm: "Confirm",
          category_post_you_want_to_delete_category:
            "You want to delete category",
          category_post_add_new_category_successful:
            "Add new category successfully",
          category_post_edit_category_successful: "Edit category successfully",
          category_post_delete_new_category_successful:
            "Delete new category successfully",
          category_post_nothing_category_post: "Nothing category post",
          category_post_no_result_found: "No result found",
          category_post_top_level_category: "Top level category",
          category_post_name_category_required: "Category name required",
          category_post_select_at_least_one_parent_category:
            "Select at least one parent category",

          chose_image_from_album: "Choose image from albums",
          embed_code: "Embed code",

          post_create: "Create",
          post_update: "Update",
          post_search: "Search",
          post_list_posts: "List Posts",
          post_create_posts: "Create Post",
          post_title: "Title",
          post_content: "Content",
          post_description: "Description",
          post_featureImage: "Image",
          post_search_by_title_description_slug:
            "Search title, description and slug",
          post_publish: "Publish",
          post_publish_true: "True",
          post_publish_false: "False",
          post_category: "Category",
          post_lang: "Language",
          post_tag: "Tag",
          post_slug: "Slug",
          post_format: "Format",
          post_update_posts: "Updating post",
          post_edit: "Edit",

          post_cancel: "Cancel",
          post_continue: "Continue",
          post_notice: "Notice",
          post_ok: "OK",
          post_do_you_want_to_delete_this_post:
            "Do you want to delete this post?",

          // report
          report_report_spa: "Report",
          x: "Enter your phone number to below",
          report_review: "Review",
          report_review_report: "Review Report",
          report_print: "Print",
          report_business_sumary_report: "Business Sumary Report",
          report_employee_utilization_report: "Employee Utilization",
          report_employee_report: "Employee Report",
          report_date_time: "Date Time",
          report_report_for: "Report for",
          report_sale_break_down: "Sales Break Down",
          report_count: "Count",
          report_amount: "Amount",
          report_appointment_statistics: "Appointment Statistics",
          report_invoice_detail: "Invoice Details",
          report_profit_reakdown: "Profit Breakdown",
          report_payment_type_breakdown: "Payment Type Breakdown",
          report_subtotal: "Subtotal",
          report_tax: "Tax",
          report_total: "Total",
          report_total_booking: "Total booking",
          report_total_booking_app: "Total booking by app",
          report_unique_client: "Unique client had booking",
          report_new_client: "New client",
          report_walk_in_client: "Total walk-in client",
          report_client_not_checked_in: "Client not checked in",
          report_total_booking_success: "Total booking success",
          report_invoice: "Invoices",
          report_aborted: "Aborted",
          report_discount: "Discount",
          report_avg_sales: "Avg Sales",
          report_gross_sales: "Gross Sales",
          report_total_cost: "Total Cost",
          report_net_profit: "Net Profit",
          report_cash: "Cash",
          report_position: "Position",
          report_staff: "Staff",
          report_salary: "Salary",
          report_no: "No.",
          report_order_code: "Order Code",
          report_item: "Item",
          report_quantity: "Quantity",
          report_date: "Date",
          report_price: "Price",
          report_bonus: "Bonus",
          report_commission: "Commission",
          report_total_commission: "Total Commission",
          report_total_salary_commission: "Total Salary and Commission",
          report_employee_name: "Employee",
          report_total_all_time: "Total for all time",
          report_time_block: "Time Block",
          report_monday: "Monday",
          report_tuesday: "Tuesday",
          report_wednesday: "Wednesday",
          report_thursday: "Thursday",
          report_friday: "Friday",
          report_saturday: "Saturday",
          report_sunday: "Sunday",
          report_please_select_employee: "Please select employee",

          dont_have_account: "Don’t have account?",
          sign_up: "Sign Up",
          have_an_account: "Have an account?",
          sign_in: "Sign In",

          register_spa_informations: "Spa Informations",
          register_your_informations: "Your Informations",
          register_verification: "Verification",
          register_spa_name: "Spa name",
          register_website: "Website",
          register_phone_number: "Phone number",
          register_address: "Address",
          register_first_name: "First Name",
          register_last_name: "Last Name",
          register_verification_code: "Verification code",
          register_we_sent_code_to: "We have sent a verification code to",
          register_enter_code_below: "Enter the code to below",
          register_please_wait: "Please wait",
          register_aciveCode_will_expired_after:
            "Active code will expire after",
          register_minutes: "minutes",
          register_seconds: "seconds",
          register_before_try_to_resend_code: "before try to resend code",
          register_sign_up_success: "Sign Up Successful!",
          register_go_to_sign_in: "Go to Sign in",
          register_use_previous_password_to_login_admin:
            "Congratulation! You have successfully registered. Use your account and password to logging in into Masspa Admin page.",
          register_use_code_to_login_first_time:
            "Congratulation! You have successfully registered. Use the last code as your password to logging in for the first time.",
          post_you_dont_have_permission_to_perform_this_action:
            "You do not have permission to perform this action. Please check your permission",

          choose_your_work_place: "Choose your work place",

          pls_enter_last_name: "Please, enter last name",
          pls_enter_first_name: "Please, enter first name",
          is_invalid_phone: "is invalid phone number",
          spa_disabled_pls_contact_admin:
            "Your spa is disabled. Please, contact admin about it.",
          spa_exist: "Spa was exist",
          pls_enter_your_address: "Please, enter your address",
          pls_enter_your_phone: "Please, enter your phone",
          pls_enter_name_spa: "Please, enter name spa",
          resend: "Resend Code",
          activecode_is_incorrect_please_try_again:
            "Active code is incorrect please try again",
          activecode_is_expired_please_register_again:
            "Active code expired.Please register again!",
          forgot_enter_your_phone_below: "Enter your phone number to below",
          forgot_create_password: "Create password",
          forgot_send_different_number: "Send to different number",
          forgot_create_password_success_pls_login_with_new_password:
            "You changed password successfully. Please, using new password to login",
          you_send_message_to_phone: "You send message to phone",
          with_content: "with message like",

          module_service: "Detail",
          module_mySpa: "Spa",
          module_branch: "Branch",
          module_sms: "SMS",
          module_album: "Album",
          module_storage: "Storage",
          module_menuService: "Menu",
          module_dashboard: "Dashboard",
          module_cms: "CMS",
          module_post: "Post",
          module_voucher: "Voucher",
          module_discount: "Discount",
          module_promotion: "Promotion",
          module_memberCard: "Member Card",
          module_employee: "Employee",
          module_employeeSystem: "System",
          module_employeeMobile: "Mobile",
          module_cost: "Cost",
          module_booking: "Booking",
          module_adminBooking: "Admin",
          module_posBooking: "POS",
          module_mobileBooking: "Mobile",
          module_order: "Order",
          module_adminOrder: "Admin",
          module_posOrder: "POS",
          module_customer: "Customer",
          module_report: "Report",
          module_apiKey: "APIKey",
          module_contact: "Contact",
          module_pos: "POS",
          module_visitor: "Visitor",

          module_action_view: "View",
          module_action_insert: "Insert",
          module_action_update: "Update",
          module_action_delete: "Delete",
          module_action_viewSalary: "View Salary",
          module_action_active: "Active",
          module_action_exportPDF: "ExportPDF",
          module_action_exportExel: "ExportExel",
          module_action_chart: "Chart",
          module_action_report: "Report",
          module_action_note: "Note",
          module_action_posBooking: "Booking",
          module_action_posOrder: "Order",
          module_action_posLogin: "Login",

          module_reset: "Reset",
          module_save: "Save",
          module_change_package: "Change package",
          module_package_free: "Package Free",
          module_package_will_expired_in: "Package will expire in",
          module_package_days: "days",
          module_package_expired: "Package expired",
          module_you_using_package: "You using package",
          module_contact_your_admin_if_you_need_to_update_your_package:
            "Contact your Admin if you need to update your package",
          module_expired_day: "Expired Day",
          module_free: "Free",
          module_update_module_success: "Update module success",
          module_package_is_valid_until_date: "Package is valid until date",
          module_service_have_not_owner: "Service have not owner",
          module_service_name: "Service name",
          module_expire_day: "Expire day",
          module_status: "Status",
          module_status_is_using: "Is Using",
          module_status_expired: "Expired",
          module_using_package: "Using package for",
          module_select_package: "Select package",

          profile_apikey: "API Key",
          profile_general: "General",
          profile_secretkey: "Secret key",
          profile_edit: "Edit",
          profile_pls_enter_secret_key: "Please, enter secret key",
          profile_delete: "Delete",

          contact_phone: "Phone",
          contact_name: "Name",
          contact_email: "Email",
          contact_gender: "Gender",
          contact_age: "Age",
          contact_ip: "IP",
          contact_is_customer: "Customer",
          contact_cancel: "Cancel",
          contact_ok: "OK",
          contact_notice: "Notice",
          contact_do_you_want_to_delete_this_contact:
            "Do you want to delete this contact?",
          contact_list_contacts: "List contacts",
          contact_search_by_customer_name_phone_email:
            "Search name, phone and email",
          contact_listcontact_delete_successfully: "Delete Successfully",
          contact_listcontact_delete_unsuccessfully: "Delete Unsuccessfully",
          contact_listcontact_edit: "Edit",
          contact_listcontact_add: "Add",

          contact_fromType: "From",
          contact_content: "Content",
          contact_extraData: "Extra Data",
          contact_update: "Update",
          contact_address: "Address",
          contact_city: "City",
          contact_country: "Country",
          contact_state: "State",
          contact_district: "District",
          contact_socialId: "Social ID",
          contact_socialLink: "Social Link",
          contact_userAgent: "User Agent",
          contact_category: "Category",
          contact_categoryId: "Category ID",
          contact_note: "Note",
          contact_for_user_is_customer_of_spa: "User is customer of spa",
          contact_createdAt: "Created at",
          contact_picker_create: "Pick date created at",
          contact_pls_select: "Please, select...",

          visitor_phone: "Phone",
          visitor_name: "Name",
          visitor_email: "Email",
          visitor_gender: "Gender",
          visitor_age: "Age",
          visitor_ip: "IP",
          visitor_is_customer: "Customer",
          visitor_cancel: "Cancel",
          visitor_ok: "OK",
          visitor_notice: "Notice",
          visitor_do_you_want_to_delete_this_visitor:
            "Do you want to delete this visitor?",
          visitor_list_visitors: "List visitors",
          visitor_list_edit: "Edit",
          visitor_search_by_customer_name_phone_email:
            "Search by name, phone and email",
          visitor_fromType: "From",
          visitor_update: "Update",
          visitor_address: "Address",
          visitor_city: "City",
          visitor_country: "Country",
          visitor_state: "State",
          visitor_district: "District",
          visitor_socialId: "Social ID",
          visitor_socialLink: "Social Link",
          visitor_userAgent: "User Agent",
          visitor_note: "Note",
          visitor_for_user_is_customer_of_spa: "for user is customer of spa",
          visitor_createdAt: "Created at",
          visitor_picker_create: "Pick date created at",
          visitor_pls_select: "Please, select...",
          update_success: "Update successfully",
          delete_success: "Delete successfully",
          create_success: "Create successfully",

          // user voucher
          user_voucher_list: "User Vouchers",
          user_voucher_is_user: "User",
          user_voucher_mobile: "Mobile",
          user_voucher_customerName: "Customer Name",
          user_voucher_voucherCode: "Voucher code",
          user_voucher_imageVoucher: "Image voucher",
          user_voucher_isUsed: "Used",
          user_voucher_unUsed: "Unused",
          user_voucher_endDate: "End date",
          user_voucher_sent_at: "Sent At",
          user_voucher_time_period_sent_to_customers:
            "Time period sent to customers",
          user_voucher_click_to_pick_time: "Click to pick time",
          user_voucher_show_all: "Show all",
          user_voucher_valid: "Valid",
          user_voucher_expired_after_one_day: "Expired after one day",
          user_voucher_expired: "Expired",
          user_voucher_search_by_voucherCode_customerName:
            "Search by code, mobile",
          user_voucher_expired_date: "Expired date",
          user_voucher_usage_status: "Usage status",
          user_voucher_send_notify_to_customer: "Send notify to customer",
          user_voucher_times_the_voucher_is_used:
            "Times customers are allowed to use the voucher",
          user_voucher_updated_successful: "Updated successfully",
          user_voucher_times_is_not_valid: "Times is not valid",
          user_voucher_customer_has_used: "Customer has used",
          user_voucher_times: "Times",
          user_voucher_user_is_registered_account: "User is registered account",
          user_voucher_sure_that_you_want_to_delete_this_voucher:
            "Are you sure remove this user vouchers?",
          //Campaign
          campaign_list_campaign: "List Campaign",
          campaign_list_do_you_want_to_delete_campaign_from_list:
            "Do you want to delete campaign from list?",
          campaign_search_title_code: "Search name, code",
          campaign_add_campaign: "Add Campaign",
          campaign_add_campaign_content: "Content",
          campaign_add_campaign_title: "Title",
          campaign_add_campaign_type: "Type",
          campaign_add_campaign_start_date: "Start date",
          campaign_add_campaign_end_date: "End date",
          campaign_add_campaign_game: "Game",
          campaign_add_campaign_voucher: "Voucher",
          campaign_add_campaign_enable: "Enable Campaign",
          campaign_add_campaign_isCommingSoon:
            "Show campaign before start date",
          campaign_add_campaign_contact_info: "Contact info",
          campaign_add_campaign_isShow: "Show",
          campaign_add_campaign_isRequired: "Require",
          campaign_add_campaign_name: "Name",
          campaign_add_campaign_phone: "Phone",
          campaign_add_campaign_email: "Email",
          campaign_add_campaign_address: "Address",
          campaign_add_campaign_gender: "Gender",
          campaign_add_campaign_image: "Image",
          campaign_add_campaign_please_add_type: "Please add type",
          campaign_add_campaign_please_add_voucher: "Please add voucher",
          campaign_add_campaign_please_add_start_date: "Please add start date",
          campaign_add_campaign_please_add_end_date: "Please add end date",
          campaign_list_campaign_title: "Title",
          campaign_list_campaign_code: "Campaign Code",
          campaign_list_campaign_type: "Type",
          campaign_list_campaign_start_date: "Start date",
          campaign_list_campaign_end_date: "End date",
          campaign_list_campaign_edit: "Edit",
          age: "Age",
          gender: "Gender",
          pls_select: "Please, select",
          pls_select_item: "Please, select item",
          male: "Male",
          female: "Female",
          other: "Other",
          month: "Month",
          city: "City",
          country: "Country",
          district: "District",
          ward: "Ward",
          state: "State",
          notArrived_in: "Not arrived in",
          system: "System",
          from: "From",
          to: "To",
          value: "Value",
          toolbar_delete: "Delete",

          select_city: "Select City",
          select_country: "Select Country",
          select_district: "Select District",
          select_ward: "Select Ward",
          select_state: "Select State",

          customer_spentVirtualMoney: "Sent virtual money",
          customer_spentRealMoney: "Spent real money",
          customer_voucherBalance: "Voucher balance",
          customer_voucherMoney: "Voucher money",
          customer_balance: "Balance",
          copy_success: "Copy success",
          copy_unsuccess: "Copy unsuccess",

          nps_nps: "Net Promoter Score",
          nps_total: "Total",
          nps_interact: "Interact",
          nps_emotion: "Emotion",
          nps_all: "All",
          nps_angry: "Angry",
          nps_sad: "Bad",
          nps_normal: "Normal",
          nps_happy: "Happy",
          nps_love: "Love",
          nps_chart: "Chart",
          nps_list: "List",

          nps_listInteract_time_customer_react: "Time customer interact",
          nps_listInteract_click_to_pick_time: "Click to pick time",
          nps_listInteract_branch: "Branch",
          nps_listInteract_emotion: "Emotion",
          nps_listInteract_time: "Time",

          service_account: "Service Account",
          service_account_serviceCode: "Service Code",
          service_account_card_number: "Card Number",
          service_account_card_name: "Card Name",
          service_account_card_expired: "Card Expired",
          service_account_card_cvv: "Card Verification Value",
          service_account_balance: "Balance",
          service_account_createdAt: "Created At",
          service_account_updatedAt: "Updated At",
          service_account_status: "Status",
          service_account_role: "Role",
          service_account_save_infomation: "Save",
          service_account_add_payment: "Add payment",
          service_account_update_service_account_successful:
            "Update service account successfully",
          service_account_please_fill_in_all_infomation:
            "Please fill in all infomation",
          service_account_card_number_is_not_valid: "Card number is not valid",
          service_account_card_cvv_is_not_valid: "Card CVV is not valid",
          service_account_spa_has_not_updated_its_account:
            "Spa has not updated its account",
          service_account_add_payment_close: "Close",
          service_account_add_payment_type_money: "Type Money",
          service_account_add_payment_received_money: "Received money",
          service_account_add_payment_received_money_to_VND:
            "Received money to VND",
          service_account_add_payment_note: "Note",
          service_account_add_payment_dialog_confirm: "Confirm",
          service_account_add_payment_dialog_ok: "OK",
          service_account_add_payment_dialog_cancel: "Cancel",
          service_account_add_payment_add_money_into_owner_account:
            "Add money into owner account",
          service_account_add_payment_please_enter_received_money:
            "Please enter received money",

          // Payment Audit
          payment_audit_change_card_info: "Change card info",
          payment_audit_change_balance: "Change balance",
          payment_time: "Time",
          payment_old_balance: "Old balance",
          payment_new_balance: "New balance",
          payment_content: "Content",
          payment_creator: "Creator",
          payment_ownerSpa: "Owner Spa",
          payment_employeeSpa: "Employee Spa",
          payment_employeeAdmin: "Employee Admin",
          payment_admin: "Admin",
          payment_add_payment: "Add Payment",
          payment_order_amount: "Amount",
          payment_order_bankCode: "Bank",
          payment_order_info: "Order Info",
          payment_add_balance_successfully: "Add balance successfully",
          payment_add_balance_unsuccessfully: "Add balance unsuccessfully",
          payment_pls_enter_amount: "Please, enter amount",
          payment_pls_enter_bank: "Please, enter bank",
          payment_pls_enter_info: "Please, enter note",

          do_you_want_delete: "Do you want to delete?",
          do_you_want_delete_campaign: "Do you want to delete this campaign?",
          tabletoolbar_selected: "selected",
          notice: "Notice",
          image_detail: "Cover Spa",
          image_album: "Album",
          "image_avatar-employee": "Employee",
          "image_avatar-customer": "Customer",
          "image_customer-employee": "Customer",
          image_branch: "Branch",
          image_memberCard: "Member Card",
          "image_menu-service": "Menu Service",
          "image_menu-item": "Menu Item",
          "image_menu-product": "Menu Product",
          "image_menu-product-category": "Menu Product Category",
          image_posts: "Post",
          image_uploadImage: "Description Spa",
          image_voucher: "Voucher",
          "image_img-logo": "Logo",

          readed: "Readed",
          unread: "Unread",
          detail: "Detail",
          see_more: "More",

          permission: "Permission",
          change_cover: "Upload cover",
          ratio: "Ratio",

          show_filter: "Filters",

          map: "Map",
          image_of_branch: "Image of branch",
          show_on_shop: "Show op shop",
          is_show_price: "Show price",
          add_menu_item: "Add menu item",
          add_menu: "Add menu",
          name: "Name",
          show: "Show",
          hide: "Hide",
          limited_all: "Limited All",
          limited_money: "Limited Money",
          limited_times: "Limited Times",
          unlimited_all: "Unlimited All",
          type: "Type",
          list_users: "List User",
          go_to_spa: "Go to spa",
          users_search_by_name_phone: "Search by name or phone",

          // Upload
          upload_delete_image_from_storage: "Delete image from storage",
          upload_list_title_upload_branch: "Branch",
          upload_list_title_upload_album: "Album",

          //   Extend package
          extend: "Extend",
          extend_balance: "Balance",
          extend_card_type: "Card type",
          extend_pament_method: "Payment method",
          extend_wallet: "Wallet",
          extend_card: "Card",
          extend_next_button: "Next",
          extend_month: "Months",
          extend_month_number: "Month",
          extend_auto_payment_wallet: "Auto payment from wallet",
          extend_price_package: "Price",
          extend_credit_card: "Credit Card",
          extend_international_card: "International Card",
          extend_wallet_not_enough_money: "Balance in wallet not enough to pay",
          extend_package_success: "Extend package successfully",

          // plugin category
          plugin_category: "Plugin Category",
          plugin_category_search_by_name: "Search by name, key",
          plugin: "Plugin",
          plugin_category_all: "All",
          plugin_category_english_name_is_required: "English name is required",
          create_plugin_category: "Create Plugin Category",
          list_plugin_category: "List Plugin Category",
          list_plugin_category_key: "Key",
          list_plugin_category_name_head: "Name",
          list_plugin_category_name: "Vietnamese Name",
          list_plugin_category_english_name: "English Name",
          list_plugin_category_createdAt: "Created At",
          list_plugin_category_updatedAt: "Updated At",
          plugin_category_updateBtn: "Update",
          plugin_category_createBtn: "Create",
          do_you_want_to_delete_selected_plugin_category:
            "Do you want to delete selected Plugin Category",
          update_successful: "Update successfull",
          plugin_madeby: "Made by",
          plugin_price: "Price",
          plugin_contact_support: "Contact Support",
          plugin_privacy_policy: "Privacy Policy",
          plugin_short_description: "Short Description",
          plugin_add: "Add",
          plugin_remove: "Remove",
          plugin_add_power_up: "Add Power Up",
          plugin_remove_power_up: "Remove Power Up",

          // Users
          user_detail_login_time: "Login Time",
          user_detail_visitor: "Visitor",
          user_detail_address: "Address",
          user_detail_gender: "Gender",
          user_detail_birthday: "Birth Day",
          user_detail_email: "Email",

          //Developer Account
          developer_account_developer_account: "Develop Account",
          developer_account_username: "Username",
          developer_account_password: "Password",
          developer_account_tag: "Tag",
          developer_account_code: "Code",
          create_developer_account_username: "User name",
          create_developer_account_password: "Password",
          create_developer_account_tag: "Tag",
          create_developer_account_sms: "SMS",
          create_developer_account_createbtn: "Create",
          create_developer_account_addbtn: "Add new account",
          update_developer_account_updatebtn: "Update",
          update_developer_account_deletebtn: "Delete",
          update_developer_account_cancelbtn: "Cancel",
          create_developer_account_success: "Create developer successfully",
          create_developer_account_unsuccess: "Create developer unsuccessfully",
          update_developer_account_success: "Update developer successfully",
          update_developer_account_unsuccess: "Update developer unsuccessfully",
          delete_developer_account_success: "Delete developer successfully",
          delete_developer_account_unsuccess: "Delete developer unsuccessfully",
          create_developer_account_account_exist: "Account Exist",
          create_developer_account_service_tag_exist:
            "Service can create 1 account each tag",
          create_developer_account_pls_fill_username:
            "Please fill in user name",
          create_developer_account_pls_fill_password: "Please fill in password",

          // Digital Signal
          digital_signal_search: "Search title, code",
          digital_signal_title_list: "List digital",
          digital_signal_title_create: "Create digital",
          digital_signal_create_title: "Title",
          digital_signal_create_description: "Description",
          digital_signal_create_is_active: "Enable",
          digital_signal_create_show_on_show: "Show on shop",
          digital_signal_create_add_media: "Add media",
          digital_signal_create_remove_media: "Remove media",
          digital_signal_create: "Create",
          digital_signal_create_upload: "Upload",
          digital_signal_create_media_time: "Time",
          digital_signal_create_media_content: "Content",
          digital_signal_update: "Update",
          digital_signal_list_title: "Title",
          digital_signal_list_creator: "Creator",
          digital_signal_list_created: "Created At",
          digital_signal_list_total_media: "Total media",
          digital_signal_list_is_active: "Active",
          digital_signal_list_do_you_want_to_remove_digital_from_list:
            "Do you want to remove digital from List?",
          digital_signal_list_delete_success: "Delete successfully",
          digital_signal_list_delete_unsuccess: "Delete unsuccessfully",
          create_degital_signal_success: "Create successfully",
          create_degital_signal_unsuccess: "Create unsuccessfully",
          create_degital_signal_pls_insert_title: "Please insert title",
          update_degital_signal_success: "Update successfully",
          update_degital_signal_unsuccess: "Update unsuccessfully",

          // notification
          notification_notification: "Notification",
          notification_received_notification: "Received Notification",
          notification_sent_notification: "Sent Notification",
          notification_template: "Template",
          notification_send: "Send",
          notification_type_notification: "Type Notification",
          notification_title: "Title",
          notification_description: "Description",
          notification_content: "Content",
          notification_update: "Update",
          notification_send_notification: "Send Notification",
          notification_search_by_name: "Search by name",
          notification_load_more: "Load More",
          notification_template_please_fill_in_title_and_description:
            "Please fill in title and description",
          notification_template_update_successful: "Update template successful",
          notification_send_to_all_user: "Send to all users in system",
          notification_send_to_all_customer: "Send to all customers",
          notification_send_to_all_owner_service: "Send to all owner service",
          notification_send_not_have_template:
            "You haven't updated notification content yet. Please update your notification content",
          notification_time: "Time",
          notification_content: "Content",
          notification_list_users: "List Users",
          CREATE_BOOKING: "Create Booking",
          UPDATE_STATUS_BOOKING_BY_USER: "User update status booking",
          UPDATE_STATUS_BOOKING_BY_SERVICE: "Service update status booking",
          SEND_VOUCHER: "Send Voucher",
          SEND_MEMBERCARD: "Send membercard",
          SYSTEM_NOTIFICATION: "System notification",
          SERVICE_ALERT_NOTIFICATION: "Service alert notification",

          // service package
          custom: "Custom",
          gold: "Gold",
          silver: "Silver",
          bronze: "Bronze",
          basic: "Basic",

          // SMS
          sms_tag_sms_manage: "SMS",
          sms_tag_device_manage: "Device",
          sms_title_sms_send: "Send SMS",
          sms_filter_by_time: "Filter by created day",
          sms_send_sms: "Send SMS",
          sms_send_sms_by_masspa_device: "Send SMS by Masspa device",
          sms_send: "Send",
          sms_search_by_to_phone_number: "Search by phone number",
          sms_listsms_show_all: "Show all",
          sms_manage_title_code: "Code",
          sms_manage_title_to: "Phone number",
          sms_manage_title_message: "Message",
          sms_manage_title_status: "Status",
          sms_manage_sms_status_sending: "Sending",
          sms_manage_sms_status_finish: "Finish",
          sms_manage_sms_status_fail: "Fail",
          sms_manage_device_title_deviceid: "Device ID",
          sms_manage_device_title_version: "Version",
          sms_manage_device_title_model: "Device model",
          sms_manage_device_title_status: "Status",
          sms_send_error_pls_fill_phone: "Please fill in phone number",
          sms_send_error_pls_fill_message: "Please fill in message",
          sms_send_successfully: "Send sms successfully",
          customer_feedback: "Customer feedback",
          customer_feedback_list: "Feedback list",
          customer_add_feedback: "Add new feedback",
          customer_edit_feedback: "Edit feedback",
          customer_add_feedback_created: "Feedback was created",
          customer_add_feedback_updated: "Feedback was updated",
          customer_add_feedback_deleted: "Feedback was deleted",
          customer_remove_feedback_confirm:
            "Are you sure to delete this feedback?",
          // ERROR
          SMS_SEND_SERVICE_NOT_DEVICE_CONNECTED:
            "Do not have any device connected to send sms",
          delete: "Delete",
          confirm_delete_message: "Are you sure to delete ",
          no_apply: "No apply",
          free: "Free",
          insert_ulr: "Insert url",
          enter_url: "Enter ulr",
          select_this_image: "Select this image",
        },
      },
      vi: {
        translations: {
          name: "Tên",
          email: "Email",
          phone: "Số điện thoại",
          created_at: "Tạo vào",
          action: "Thao tác",
          feedback: "Phản hồi",
          size: "Dung lượng",
          save: "Lưu",
          cancel: "Hủy bỏ",
          ref_link: "Liên kết",
          remove: "Xoá",
          view_detail: "Xem chi tiết",
          rename: "Đổi tên",
          copy_url: "Sao chép URL",
          copied: "Đã sao chép",
          add_folder: "Thêm thư mục",
          upload_image: "Tải ảnh lên",
          valid_file_name: "Tên file phù hợp",
          invalid_file_name: "Tên file không phù hợp",
          storage_items: "Các mục lưu trữ",
          image_list: "Danh sách ảnh",
          branch: "Chi nhánh",
          img_logo: "Ảnh logo",
          album: "Album",
          voucher: "Phiếu quà tặng",
          menu_service: "Menu dịch vụ",
          menu_item: "Menu mặt hàng",
          menu_product: "Menu sản phẩm",
          menu_product_category: "Menu danh mục sản phẩm",
          avatar_employee: "Ảnh đại diện nhân viên",
          avatar_customer: "Ảnh đại diện khách hàng",
          member_card: "Thẻ thành viên",
          upload_image: "Ảnh tải lên",
          posts: "Bài viết",
          download: "Tải về",
          something_went_wrong: "Đã xảy ra lỗi, vui lòng thử lại sau",
          register_employee_employee_register_successful: "Đăng ký thành công",
          register_employee_invalid_link: "Đường dẫn không đúng",
          register_employee_not_found_link: "Đường dẫn không tìm thấy",
          Searching: "Tìm kiếm",
          yes: "Có",
          no: "Không",
          notice: "Thông Báo",
          An_error_occurred_Please_check_internet_or_contact_your_admin:
            "Có lỗi xảy ra. Vui lòng kiểm tra internet hoặc liên lạc với admin",
          percent: "Phần trăm",
          you_can_not_view_the_list_of_this_branch_because_you_do_not_have_permission_to_manage_this_branch:
            "Bạn không thể xem danh sách của chi nhánh này vì bạn không có quyền quản lý chi nhánh",
          open_map: "Mở bản đồ",
          close_map: "Ẩn bản đồ",
          backButton: "Trở về",
          sendButton: "Gửi",
          editButton: "Sửa",
          agree: "Đồng ý",
          disagree: "Hủy",
          rows_per_page: "Số dòng trong trang",
          isRead: "Trạng Thái",
          isUsed: "Trạng Thái Sử Dụng",
          expiredVoucher: "Ngày Hết Hạn",
          status: "Trạng Thái",
          enabled: "Hiển Thị",
          on_sale: "Giảm Giá",
          discontinued: "Không Tiếp Tục",
          stock_status: "Trạng Thái Tồn Kho",
          spentRealMoney: "Số tiền thật đã tiêu",
          voucherMoney: "Giá trị của voucher",

          //header
          header_profile: "Thông tin",
          header_logout: "Đăng xuất",
          header_block: "Chặn",
          header_notification: "Thông báo",
          header_permission: "Quyền truy cập",
          header_location: "Định vị",
          header_your_browser_blocked_permission:
            "Trình duyệt của bạn đã chặn quyền truy cập",
          //sidebar
          sidebar_superadmin: "Super admin",
          sidebar_manage: "Quản lý",
          sidebar_service_and_product: "Dịch vụ và sản phẩm",
          sidebar_support: "Hỗ trợ",
          sidebar_owner: "Chủ Spa",
          sidebar_dashboard: "Tổng quan",
          sidebar_my_spa: "Spa của tôi",
          sidebar_service: "Chi tiết spa",
          sidebar_list: "Danh sách",
          sidebar_detail: "Chi tiết",
          sidebar_branch: "Chi nhánh",
          sidebar_album: "Thư viện ảnh",
          sidebar_menu: "Dịch vụ",
          sidebar_booking: "Đặt chỗ",
          sidebar_post: "Bài viết",
          sidebar_cms: "CMS",
          sidebar_users: "Người dùng",
          sidebar_contact: "Tư vấn liên hệ",
          sidebar_visitor: "Người truy cập",
          sidebar_post_list: "Danh sách bài viết",
          sidebar_post_create: "Thêm bài viết",
          sidebar_post_category: "Thể loại",
          sidebar_order: "Đơn hàng",
          sidebar_promotion: "Khuyến mãi",
          sidebar_voucher: "Phiếu giảm giá",
          sidebar_discount: "Giảm giá",
          sidebar_user: "Người sử dụng",
          sidebar_customer: "Khách hàng",
          sidebar_employee: "Nhân viên",
          sidebar_profile: "Trang cá nhân",
          sidebar_notification: "Thông báo",
          sidebar_develop_account: "Nhà phát triển",
          sidebar_develop_account_create: "Tạo mới",

          sidebar_module: "Phân quyền",
          sidebar_nps: "Tương tác",
          sidebar_digital_signal: "Tín hiệu số",
          sidebar_report: "Báo cáo",
          sidebar_sms: "Tin nhắn",
          sidebar_cost: "Chi phí",
          sidebar_stableCost: "Chi phí cố định",
          sidebar_service_cost: "Chi phí hàng tháng",
          sidebar_membercard: "Thẻ thành viên",
          sidebar_user_membercard: "Người nhận thẻ",
          sidebar_storage: "Lưu trữ",
          sidebar_product: "Sản phẩm",
          sidebar_user_voucher: "Người nhận phiếu",
          sidebar_campaign: "Chiến dịch",
          sidebar_service_account: "Tài khoản",
          sidebar_service_payment: "Thanh toán",
          sidebar_setting_system: "Cài đặt",
          sidebar_list_product: "Danh sách",
          sidebar_create_product: "Tạo",
          //serviceUpload
          service_ownerspa_service_storage: "Kho ảnh",
          service_ownerspa_service_storage_select: "Chọn",
          //serviceAlbum
          service_ownerspa_service_album: "Thư viện ảnh",
          service_ownerspa_service_album_create_album_unsuccess:
            "Tạo ảnh mới không thành công",
          service_ownerspa_service_album_create_album_success:
            "Tạo ảnh mới thành công",
          service_ownerspa_service_album_delete_album_unsuccess:
            "Xóa hình ảnh không thành công",
          service_ownerspa_service_album_delete_album_success:
            "Xóa hình ảnh thành công",
          service_ownerspa_servicealbum_cancel: "Hủy bỏ",
          service_ownerspa_servicealbum_delete: "Xóa bỏ",
          service_ownerspa_servicealbum_confirm: "Xác nhận",
          service_ownerspa_servicealbum_delete_image_from_album_list:
            "Xóa bỏ ảnh từ danh sách album",

          //service_admin
          service_admin_add_new_service: "Tạo spa mới",
          service_admin_search_name_adress_website:
            "Tìm theo tên, địa chỉ, website",
          service_admin_spa_not_found: "Danh sách spa rỗng",
          service_admin_create: "Tạo",
          service_admin_edit_spa: "Chỉnh sửa thông tin spa",
          search: "Tìm kiếm",
          service_admin_listservice_editservice_name_service: "Tên dịch vụ",
          service_admin_listservice_editservice_website: "Trang web",
          service_admin_listservice_editservice_status_changed_to_active:
            "Trạng thái đã được thay đổi thành hoạt động",
          service_admin_listservice_editservice_status_changed_to_inactive:
            "Trạng thái đã được thay đổi thành không hoạt động",
          service_admin_listservice_editservice_address: "Địa chỉ",
          service_admin_list_services: "Danh Sách Spa",
          service_admin_owner_code: "Mã của chủ spa",
          service_admin_list_services_add_new_spa: "Tạo spa mới",
          service_admin_listservice_update_successfully: "Cập nhật thành công",
          service_admin_listservice_update_unsuccessfully:
            "Cập nhật không thành công",
          service_admin_listservice_delete_successfully: "Xoá bỏ thành công",
          service_admin_listservice_delete_unsuccessfully:
            "Xóa bỏ không thành công",
          service_admin_listservice_cancel: "Hủy bỏ",
          service_admin_listservice_continute: "Đồng ý",
          service_admin_listservice_delete: "Xóa",
          service_admin_listservice_unLimit: "Không thời hạn",
          service_admin_listservice_delete_service_from_list_will_delete_it_on_system:
            "Dịch vụ xóa khỏi danh sách sẽ xóa khỏi hệ thống",
          service_admin_listservice_rows_paper: "Số dòng",
          service_admin_listservice_tablehead_no: "Mã",
          service_admin_listservice_tablehead_expired: "Ngày hết hạn gói",
          service_admin_listservice_tablehead_package: "Gói sử dụng",
          service_admin_listservice_tablehead_name_services: "Tên",
          service_admin_listservice_tablehead_support: "Hỗ trợ",
          service_admin_listservice_tablehead_mobile: "Điện thoại di động",
          service_admin_listservice_tablehead_phone: "Số điện thoại",
          service_admin_listservice_tablehead_created_at: "Ngày khởi tạo",
          service_admin_listservice_tablehead_updated_at: "Ngày cập nhật",
          service_admin_listservice_tablehead_active: "Trạng thái",
          service_admin_listservice_tabletoolbar_selected: "đã chọn",
          service_admin_listservice_tabletoolbar_delete: "Xóa",
          service_admin_listservice_editservice_active_status:
            "Trạng thái hoạt động của spa",
          service_admin_listservice_editservice_owner_infomation:
            "Thông tin chủ spa",
          service_admin_listservice_editservice_permisstion: "Quyền truy cập",
          service_admin_listservice_editservice_service_account: "Tài khoản",
          service_admin_listservice_editservice_phone: "Số điện thoại",
          service_admin_listservice_editservice_mobile: "Điện thoại di động",
          service_admin_listservice_editservice_min_price: "Giá nhỏ nhất",
          service_admin_listservice_editservice_max_price: "Giá lớn nhất",
          service_admin_listservice_editservice_currency: "Đơn vị",
          service_admin_listservice_editservice_city: "Thành phố",
          service_admin_listservice_editservice_district: "Quận/Huyện",
          service_admin_listservice_editservice_active: "Hoạt động",
          service_admin_listservice_editservice_add_owner_spa:
            "Thêm chủ sở hữu cho spa",
          service_admin_listservice_editservice_remove_owner_information:
            "Bạn muốn xoá thông tin chủ sở hữu đối với spa này",
          service_admin_listservice_editservice_remove_owner_spa:
            "Xóa chủ sở hữu cho spa",
          // Create service
          service_admin_createservice_you_must_insert_basic_information_for_service_to_countinue:
            "Bạn phải thêm thông tin cơ bản cho dịch vụ",
          service_admin_createservice_you_must_insert_name_of_your_service:
            "Bạn phải thêm tên dịch vụ của bạn",
          service_admin_createservice_update_successfully:
            "Cập nhật thành công",
          service_admin_createservice_update_unsuccessfully:
            "Cập nhật không thành công",
          service_admin_createservice_save_unsuccessfully:
            "Lưu không thành công",
          service_admin_createservice_save_successfully:
            "Tạo thông tin spa thành công",
          service_admin_createservice_cancel: "Hủy",
          service_admin_createservice_create: "Khởi tạo",
          service_admin_createservice_information: "Thông tin",
          service_admin_createservice_feature_and_function:
            "Tính năng và chức năng",
          service_admin_createservice_workingDay: "Ngày làm việc",
          service_admin_createservice_album: "Album",
          service_admin_createservice_branch: "Chi nhánh",
          service_admin_createservice_confirm: "Xác nhận",
          service_admin_createservice_menu: "Danh sách",
          service_admin_createservice_album_cancel: "Hủy bỏ",
          service_admin_createservice_album_delete: "Xóa bỏ",
          service_admin_createservice_album_confirm: "Xác nhận",
          service_admin_createservice_album_delete_this_image_from_list:
            "Xóa bỏ ảnh này khỏi danh sách",
          service_admin_createservice_create_new_service_with_name:
            "Tạo mới dịch vụ với tên ",
          service_admin_createservice_insert_basic_information_for_service_to_countinue:
            "Nhập thông tin cho dịch vụ của bạn",
          //branch
          service_admin_createservice_branch_add_new_branch:
            "Thêm chi nhánh mới",
          service_admin_createservice_branch_branch_name: "Tên chi nhánh",
          service_admin_createservice_branch_address: "Địa chỉ",
          service_admin_createservice_branch_district: "Quận/Huyện",
          service_admin_createservice_branch_city: "Thành phố",
          service_admin_createservice_branch_phone: "Số điện thoại",
          service_admin_createservice_branch_mobile: "Điện thoại di động",
          service_admin_createservice_newbranch_create_successfully:
            "Khởi tạo thành công",
          service_admin_createservice_newbranch_create_unsuccessfully:
            "Khởi tạo không thành công",
          service_admin_createservice_newbranch_cancel: "Hủy bỏ",
          service_admin_createservice_newbranch_create: "Khởi tạo",
          service_admin_createservice_newbranch_confirm: "Xác nhận",
          "service_admin_createservice_branch_you_don't_have_any_branch_create_new_branch":
            "Bạn không có bất cứ chi nhánh nào.Hãy tạo chi nhánh mới",
          // Feature
          "skin-lightening": "Làm trắng da",
          "facial-massage": "Mát xa mặt",
          waxing: "Tẩy lông",
          "stretch-the-skin": "Căng da mặt",
          "food-hand-massage": "Mát xa tay chân",
          liposuction: "Hút mỡ",
          "wrinkle-improverment": "Cải thiện nếp nhăn",
          "raising-the-nose": "Nâng mũi",
          nail: "Làm móng",
          wifi: "Wi fi",
          free_parking: "Giữ xe miễn phí",
          card_accepted: "Sử dụng thẻ tín dụng",
          sauna: "Xông hơi",
          space: "Không gian",
          color: "Màu sắc",
          music: "Âm nhạc",
          soundproof: "Cách âm",
          service_admin_createservice_feature_function: "Chức năng",
          service_admin_createservice_feature_feature: "Tính năng",
          service_admin_createservice_feature_save: "Lưu",
          service_admin_createservice_feature_type_your_space_spa:
            "Nhập diện tích spa của bạn",
          service_admin_createservice_feature_type_your_color_spa:
            "Nhập màu sắc chủ đạo spa của bạn",
          //information
          service_admin_createservice_information_save: "Lưu",
          service_admin_createservice_information_name_service: "Tên dịch vụ",
          service_admin_createservice_information_address_invalid:
            "Địa chỉ không tồn tại",
          service_admin_createservice_information_please_enter_name_spa:
            "Vui lòng điền vào tên của spa",
          service_admin_createservice_information_please_enter_phone_spa:
            "Vui lòng điền vào số điện thoại của spa",
          service_admin_createservice_information_phone: "Số điện thoại",
          service_admin_createservice_information_mobile: "Điện thoại di động",
          service_admin_createservice_information_min_price: "Giá nhỏ nhất",
          service_admin_createservice_information_max_price: "Giá lớn nhất",
          service_admin_createservice_information_currency: "Đơn vị",
          service_admin_createservice_information_address: "Địa chỉ",
          service_admin_createservice_information_city: "Thành phố",
          service_admin_createservice_information_district: "Quận/Huyện",
          service_admin_createservice_information_go_to_location: "Đi đến nơi",
          service_admin_createservice_information_description: "Mô tả",
          service_admin_createservice_information_working_hours: "Giờ làm việc",
          service_admin_createservice_information_image_spa: "Ảnh Spa",
          service_admin_createservice_information_image_should_have_aspect_ratio_is_16_9:
            "Hình ảnh nên theo tỷ lệ 16:9",
          service_admin_createservice_information_active: "Hoạt động",
          service_admin_createservice_information_point_system: "Hệ thống điểm",
          service_admin_createservice_menu_add_successfully: "Thêm thành công",
          service_admin_createservice_menu_add_unsuccessfully:
            "Thêm không thành công",
          //newbranch
          service_admin_createservice_newbranch_address_invalid:
            "Địa chỉ không hợp lệ",
          service_admin_createservice_newbranch_create_new_branch_for_your_spa:
            "Tạo chi nhánh mới cho spa",
          service_admin_createservice_newbranch_name: "Tên",
          service_admin_createservice_newbranch_mobile: "Điện thoại di động",
          service_admin_createservice_newbranch_phone: "Số điện thoại",
          service_admin_createservice_newbranch_address: "Địa chỉ",
          service_admin_createservice_newbranch_city: "Thành phố",
          service_admin_createservice_newbranch_district: "Quận/Huyện",
          service_admin_createservice_newbranch_go_to_location: "Đi đến nơi",
          service_admin_createservice_newbranch_save: "Lưu",
          //ownerspa
          service_ownerspa_spa: "Spa",
          service_ownerspa_servicedetail_please_enter_address:
            "Vui lòng điền vào địa chỉ",
          service_ownerspa_servicedetail_can_not_detect_position_on_map:
            "Không thể xác định được vị trí trên bản đồ",
          service_ownerspa_servicedetail_please_enter_name:
            "Vui lòng điền vào tên dịch vụ",
          service_ownerspa_servicedetail_update_successfully:
            "Cập nhật thông tin spa thành công",
          service_ownerspa_servicedetail_update_unsuccessfully:
            "Cập nhật thông tin spa không thành công",
          service_ownerspa_servicedetail_upload_image_successfully:
            "Tải ảnh lên thành công",
          service_ownerspa_servicedetail_upload_image_unsuccessfully:
            "Tải ảnh lên không thành công",
          service_ownerspa_servicedetail_update_image_successfully:
            "Cập nhật hình ảnh spa thành công",
          service_ownerspa_servicedetail_update_image_unsuccessfully:
            "Cập nhật hình ảnh spa không thành công",
          service_ownerspa_servicedetail_cancel: "Hủy bỏ",
          service_ownerspa_servicedetail_update: "Cập nhật",
          service_ownerspa_servicedetail_do_you_want_to_update_them:
            "Bạn muốn cập nhật mới?",
          service_ownerspa_servicedetail_information: "Thông tin",
          service_ownerspa_servicedetail_working_hours: "Giờ làm việc",
          service_ownerspa_servicedetail_feature_and_function:
            "Tính năng và chức năng",
          service_ownerspa_servicedetail_service_setting_settings: "Cài đặt",
          service_ownerspa_servicedetail_service_setting_prefix_menu_item:
            "Tiền tố dịch vụ",
          service_ownerspa_servicedetail_service_setting_total_menu_item:
            "Tổng dịch vụ",
          service_ownerspa_servicedetail_service_setting_prefix_menu:
            "Tiền tố danh mục",
          service_ownerspa_servicedetail_service_setting_total_menu: "Tổng",
          service_ownerspa_servicedetail_service_setting_prefix_employee:
            "Tiền tố nhân viên",
          service_ownerspa_servicedetail_service_setting_total_employee:
            "Tổng nhân viên",
          service_ownerspa_servicedetail_service_setting_prefix_customer:
            "Tiền tố khách hàng",
          service_ownerspa_servicedetail_service_setting_total_customer:
            "Tồng khách hàng",
          service_ownerspa_servicedetail_service_setting_payment_type:
            "Loại hình thanh toán",
          service_ownerspa_servicedetail_service_setting_credit_card:
            "Thẻ nội địa",
          service_ownerspa_servicedetail_service_setting_international_card:
            "Thẻ quốc tế",
          service_ownerspa_servicedetail_service_currrency_code: "Mã tiền tệ",
          service_ownerspa_servicedetail_format_datetime: "Định dạng ngày giờ",
          service_ownerspa_servicedetail_service_tax: "Thuế",
          service_ownerspa_servicedetail_default_countryCode: "Mã quốc gia",

          service_ownerspa_servicedetail_qr_code: "Mã QR",
          service_ownerspa_servicedetail_feature_feature: "Tính năng",
          service_ownerspa_servicedetail_feature_type_size_your_spa_area:
            "Nhập diện tích spa của bạn",
          service_ownerspa_servicedetail_feature_function: "Chức năng",
          service_ownerspa_servicedetail_feature_detail: "Chi tiết",
          service_ownerspa_servicedetail_feature_point_system: "Hệ thống điểm",
          service_ownerspa_servicedetail_feature_using_tax: "Sử dụng thuế",
          service_ownerspa_servicedetail_feature_name: "Tên",
          service_ownerspa_servicedetail_feature_phone: "Số điện thoại",
          service_ownerspa_servicedetail_feature_mobile: "Điện thoại di động",
          service_ownerspa_servicedetail_feature_min_price: "Giá nhỏ nhất",
          service_ownerspa_servicedetail_feature_max_price: "Giá lớn nhất",
          service_ownerspa_servicedetail_feature_currency: "Đơn vị",
          service_ownerspa_servicedetail_feature_address:
            "Địa chỉ (Vui lòng Enter để lấy vị trí trên bản đồ)",
          service_ownerspa_servicedetail_feature_country: "Quốc gia",
          service_ownerspa_servicedetail_feature_city: "Thành phố",
          service_ownerspa_servicedetail_feature_state: "Bang",
          service_ownerspa_servicedetail_feature_district: "Quận/Huyện",
          service_ownerspa_servicedetail_feature_view_on_google_map:
            "Xem bản đồ trên google",
          service_ownerspa_servicedetail_feature_go_to_location: "Đi đến nơi",
          service_ownerspa_servicedetail_feature_description: "Mô tả",
          service_ownerspa_servicedetail_feature_image_spa: "Ảnh Spa",
          service_ownerspa_servicedetail_image_logo: "Ảnh Logo",
          service_ownerspa_servicedetail_feature_image_should_have_aspect_ratio_is_16_9:
            "Hình ảnh nên theo tỷ lệ 16:9",
          service_ownerspa_servicedetail_feature_print_qrcode: "In mã QR Code",
          service_ownerspa_servicedetail_feature_print_barcode: "In Mã vạch",
          service_ownerspa_servicedetail_qr_and_bar_code: "Mã QR và mã vạch",
          service_ownerspa_servicedetail_qr_code_service_code: "Mã Spa",
          service_ownerspa_servicedetail_qr_code_service_name: "Tên Spa",
          service_ownerspa_servicedetail_qr_code_mobile: "Số di động",
          service_ownerspa_servicedetail_qr_code_website: "Trang web",
          service_ownerspa_servicedetail_qr_code_code: "Mã",
          service_ownerspa_servicedetail_generate_qrcode: "Tạo Mã QR",
          service_ownerspa_servicedetail_generate_barcode: "Tạo Mã vạch",
          service_ownerspa_servicedetail_generate_qr_code_successful:
            "Tạo Mã QR thành công",
          service_ownerspa_servicedetail_qrcode_size: "Kích thước QR code",
          service_ownerspa_servicedetail_barcode_height: "Chiều cao mã vạch",
          service_ownerspa_servicedetail_enter_barcode_height:
            "Nhập Chiều cao mã vạch",
          service_ownerspa_servicedetail_enter_qrcode_size:
            "Nhập Kích thước mã QR",
          service_ownerspa_createservice_you_must_insert_name_of_your_service:
            "Bạn phải thêm tên dịch vụ",
          service_ownerspa_createservice_save_unsuccessfully:
            "Lưu không thành công",
          service_ownerspa_createservice_save_successfully: "Lưu thành công",
          service_ownerspa_createservice_cancel: "Hủy bỏ",
          service_ownerspa_createservice_create: "Khởi tạo",
          service_ownerspa_createservice_confirm: "Xác nhận",
          service_ownerspa_createservice_create_new_service_to_list:
            "Khởi tạo dịch vụ mới",
          service_ownerspa_createservice_insert_basic_information_for_your_service_to_countinue:
            "Thêm thông tin cơ bản về dịch vụ của bạn",
          service_ownerspa_createservice_information_address_invalid:
            "Địa chỉ không hợp lệ",
          service_ownerspa_createservice_information_point_system:
            "Hệ thống điểm",
          service_ownerspa_createservice_information_name_service:
            "Tên dịch vụ",
          service_ownerspa_createservice_information_phone: "Số điện thoại",
          service_ownerspa_createservice_information_mobile:
            "Điện thoại di động",
          service_ownerspa_createservice_information_min_price: "Giá nhỏ nhất",
          service_ownerspa_createservice_information_max_price: "Giá lớn nhất",
          service_ownerspa_createservice_information_currency: "Đơn vị",
          service_ownerspa_createservice_information_address: "Địa chỉ",
          service_ownerspa_createservice_information_city: "Thành phố",
          service_ownerspa_createservice_information_district: "Quận/Huyện",
          service_ownerspa_createservice_information_go_to_location:
            "Đi đến nơi",
          service_ownerspa_createservice_information_description: "Mô tả",
          service_ownerspa_createservice_information_working_hours:
            "Giờ làm việc",
          service_ownerspa_createservice_information_image_spa: "Ảnh spa",
          service_ownerspa_createservice_information_image_should_have_aspect_ratio_is_16_9:
            "Hình ảnh nên theo tỷ lệ 16:9",
          service_ownerspa_createservice_information_active: "Hoạt động",
          service_ownerspa_createservice_information_save: "Lưu",
          service_ownerspa_createservice_payment: "Thanh toán",
          service_ownerspa_createservice_payment_detail: "Chi tiết",
          service_ownerspa_createservice_payment_account_balance:
            "Tài khoản thanh toán",
          service_ownerspa_createservice_payment_payment_history: "Lịch sử",
          //googlemap
          "googlemap_can't_find_this_address": "Không thể tìm địa chỉ này",
          "googlemap_address_can't_empty": "địa chỉ không thể bỏ trống",
          // Order
          Not_have_any_order: "Không có đơn hàng nào được ghi nhận",
          orders_order: "Đơn hàng",
          orders_do_you_want_to_delete_this_order_from_list:
            "Bạn muốn xóa đơn hàng này khỏi danh sách?",
          orders_delete_orders_successfully: "Xóa đơn hàng thành công",
          orders_delete_orders_unsuccessfully: "Xóa đơn hàng không thành công",
          orders_cancel: "Hủy bỏ",
          orders_continue: "Đồng ý",
          orders_notice: "Thông báo",
          orders_filter_by_time: "Lọc theo ngày tạo",
          orders_search_by_code_customer_code_mobile:
            "Tìm mã đơn hàng, số điện thoại/mã khách hàng",
          orders_search: "Tìm kiếm",
          orders_rows_paper: "Số dòng",
          orders_tablehead_order_code: "Mã",
          orders_tablehead_branch: "Chi nhánh",
          orders_tablehead_item: "Dịch vụ",
          orders_tablehead_customer: "Khách hàng",
          orders_tablehead_mobile: "Điện thoại di động",
          orders_tablehead_status: "trạng thái",
          orders_tablehead_finish_payment: "Đã trả xong tiền",
          orders_tablehead_updated_at: "Ngày cập nhật",
          orders_tablehead_price: "Tổng tiền",
          orders_tablehead_membercard_money: "Tiền từ thẻ thành viên",
          orders_tabletoolbar_selected: "đã chọn",
          orders_tabletoolbar_delete: "Xóa",
          orders_listorder_more: "Chi tiết",
          orders_editnote_update_successfully: "Cập nhật thành công",
          orders_editnote_update_unsuccessfully: "Cập nhật không thành công",
          orders_editnote_item: "Dịch vụ | Giá tiền | Thời gian",
          orders_editnote_value_discount: "Giá giảm",
          orders_editnote_voucher_money: "Tiền từ Voucher",
          orders_editnote_membercard_money: "Tiền trả bằng thẻ thành viên",
          orders_editnote_type_discount: "Kiểu giảm giá",
          orders_editnote_shipping_fee: "Phí giao hàng",
          orders_editnote_tax: "Thuế",
          orders_editnote_points: "Điểm",
          orders_editnote_total_points: "Tổng điểm",
          orders_editnote_estimate_price: "Giá ước tính",
          orders_editnote_total_price: "Tổng tiền phải trả",
          orders_editnote_money_change: "Tiền trả lại",
          orders_editnote_money_received: "Tiền đã nhận",
          orders_editnote_payment_method: "Phương thức thanh toán",
          orders_editnote_payment_method_cash: "Tiền mặt",
          orders_editnote_payment_method_card: "Thẻ ngân hàng",
          orders_editnote_customer_comment: "Bình luận từ khách hàng",
          orders_editnote_customer_note: "Ghi chú đơn hàng",
          orders_editnote_customer_feedback: "Phản hồi",
          orders_editnote_none: "Không có",
          orders_editnote_detail: "Chi tiết",
          orders_editnote_history_order: "Lịch sử đơn hàng",
          orders_editnote_employee: "Nhân viên",
          orders_editnote_owner: "Chủ spa",
          orders_editnote_changed_status: "đã thay đổi trạng thái",
          orders_editnote_for_this_order: "cho đơn hàng lúc",
          orders_editnote_not_any_action: "Không có hành động nào",
          orders_editnote_not_any_item_assigned:
            "Không có dịch vụ nào được chỉ định",
          orders_detailorder_order_info: "Thông tin đơn hàng",
          orders_detailorder_customer: "Khách hàng",
          orders_detailorder_order_code: "Mã",
          orders_detailorder_date: "Ngày",
          orders_detailorder_status: "Trạng thái",
          orders_detailorder_item_name: "Tên sản phẩm",
          orders_detailorder_item_quantity: "Số lượng",
          orders_detailorder_item_price: "Giá",
          orders_detailorder_total: "Tổng",
          orders_detailorder_money_change: "Số tiền trả lại",
          orders_detailorder_payment: "Số tiền thanh toán",
          orders_detailorder_add_new_payment: "Thêm thanh toán",
          orders_detailorder_order_item: "Dịch vụ trong đơn hàng",
          orders_detailorder_receive_money: "Số tiền đã nhận",
          orders_detailorder_employee_code: "Mã nhân viên",
          orders_detailorder_employee_name: "Tên nhân viên",
          orders_detailorder_payment_method: "Phương thức",
          orders_detailorder_payment_method_cash: "Tiền mặt",
          orders_detailorder_payment_method_card: "Thẻ ngân hàng",
          orders_detailorder_updatedAt: "Ngày cập nhật",
          orders_detailorder_change_money: "Số tiền trả lại",
          orders_detailorder_add: "Thêm",
          orders_detailorder_cancel: "Huỷ",
          orders_detailorder_edit: "Lưu",
          orders_detailorder_delete: "Xoá",
          orders_detailorder_do_you_want: "Xoá",
          orders_detailorder_edit_payment_success:
            "Chỉnh sửa thanh toán thành công",
          orders_detailorder_delete_payment_success:
            "Xoá thanh toán thành công",
          orders_detailorder_delete: "Xoá",
          orders_detailorder_notice: "Thông báo",
          orders_detailorder_add_payment_successfully:
            "Thêm thanh toán thành công",
          orders_detailorder_please_fill_in_received_money:
            "Điền vào số tiền nhận",
          orders_detailorder_cancel: "Huỷ",
          orders_detailorder_payment_record_will_be_delete_immediately_you_can_not_undo_this_action:
            "Lần thanh toán này sẽ bị xoá. Bạn không thể hoàn tác hành động này",
          orders_detailorder_edit_payment_unsuccess:
            "Chỉnh sửa thanh toán không thành công",
          listOrder_apply_for_all_branches: "Áp dụng tất cả chi nhánh",
          // Discount
          discount_discount: "Giảm giá",
          discount_create_discount: "Tạo giảm giá",
          discount_listdiscount_update: "Cập nhật",
          discount_listdiscount_delete: "Xóa",
          discount_listdiscount_notice: "Thông báo",
          discount_listdiscount_update_successfully: "Cập nhật thành công",
          discount_listdiscount_update_unsuccessfully:
            "Cập nhật không thành công",
          discount_listdiscount_cancel: "Hủy bỏ",
          discount_listdiscount_value: "Giá Trị",
          discount_listdiscount_type: "Loại",
          discount_listdiscount_start_date: "Ngày bắt đầu",
          discount_listdiscount_end_date: "Ngày kết thúc",
          discount_listdiscount_note: "Ghi chú",
          discount_listdiscount_can_be_used_with_voucher_code:
            "Có thể sử dụng kèm với mã khuyến mãi",
          discount_listdiscount_all_branch: "Áp dụng cho tất cả chi nhánh",
          discount_listdiscount_enable: "Kích hoạt chương trình giảm giá",
          discount_listdiscount_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Vui lòng nhập 1 số giảm giá nhỏ hơn hoặc bằng 100 cho loại phần trăm",
          discount_listdiscount_edit: "Chỉnh sửa",
          discount_listdiscount_do_you_want_to_update_discount:
            "Bạn có muốn cập nhật giảm giá mới?",
          discount_listdiscount_do_you_want_to_delete_discount:
            "Bạn có muốn xóa giảm giá này?",
          discount_listdiscount_end_date_have_to_more_than_start_date:
            "Ngày kết thúc phải lớn hơn ngày bắt đầu",
          discount_listdiscount_start_date_wrong: "Ngày bắt đầu không đúng",
          discount_listdiscount_please_enter_a_value_less_than_1_for_percent_type:
            "Vui lòng nhập giá trị nhỏ hơn 1 cho loại %",
          discount_listdiscount_selectedbranch_branch: "Chi nhánh",
          discount_add_discount_create_successfully: "Khởi tạo thành công",
          discount_add_discount_create_unsuccessfully:
            "Khởi tạo không thành công",
          discount_add_discount_cancel: "Hủy bỏ",
          discount_add_discount_notice: "Thông báo",
          discount_add_discount_create_new_discount: "Tạo giảm giá mới",
          discount_add_discount_create: "Khởi tạo",
          discount_add_discount_value: "Giá trị",
          discount_add_discount_type: "Loại",
          discount_add_discount_start_date: "Ngày bắt đầu",
          discount_add_discount_end_date: "Ngày kết thúc",
          discount_add_discount_note: "Ghi chú",
          discount_add_discount_please_choose_at_least_one_branch_to_apply_for_promotion:
            "Chọn ít nhất 1 chi nhánh để áp dụng khuyến mãi",
          discount_add_discount_please_fill_out_the_promotion:
            "Vui lòng điền đầy đủ thông tin khuyến mãi",
          // Profile
          profile_successfully: "Cập nhật thành công",
          profile_unsuccessfully: "Cập nhật không thành công",
          profile_update_firstName_lastName_required:
            "Vui lòng điền vào Tên và Họ",
          profile_profile: "Thông Tin Cá Nhân",
          profile_gender: "Giới tính",
          profile_male: "Nam",
          profile_female: "Nữ",
          profile_phone: "Số điện thoại",
          profile_address: "Địa chỉ",
          profile_information: "Thông tin",
          profile_password: "Mật khẩu",
          profile_first_name: "Tên",
          profile_last_name: "Họ",
          profile_dob: "Ngày sinh",
          profile_update: "Cập nhật",
          profile_current_password: "Mật khẩu hiện tại",
          profile_new_password: "Mật khẩu mới",
          profile_confirm_password: "Xác nhận mật khẩu",
          profile_please_fill_in_passwod_and_confirm_password:
            "Điền vào mật khẩu và xác nhận lại mật khẩu",
          profile_change_password_password_confirm_does_not_match:
            "Mật khẩu xác nhận không trùng khớp",
          profile_change_password_new_password_must_be_at_least_6_characters_long:
            "Mật khẩu mới phải có ít nhất 6 ký tự",
          profile_change_current_password_is_incorrect: "Mật khẩu hiện tại sai",
          profile_api_key_delete_successfully: "Xóa thành công",
          profile_api_key_create_successfully: "Khởi tạo thành công",
          profile_api_key_delete: "Xoá",
          profile_api_key_cancel: "Huỷ",
          profile_api_key_notify: "Thông báo",
          profile_email_is_not_valid: "không là một email đúng",
          profile_api_key_api_will_be_delete_immediately_you_can_not_undo_this_action:
            "API Key sẽ bị xoá. Bạn không thể hoàn tác hành động này",
          // Booking
          booking_booking: "Đặt chỗ",
          booking_filter_by_time: "Lọc theo thời gian khách đến",
          booking_search: "Tìm Mã, tên, số điện thoại",
          booking_listbooking_add_booking: "Tạo mới",
          booking_listbooking_all_booking: "Tất cả đặt chỗ",
          booking_listbooking_successfully: "Thành công",
          booking_listbooking_unsuccessfully: "Không thành công",
          booking_listbooking_ok: "Đồng ý",
          booking_listbooking_edit: "Cập nhật",
          booking_listbooking_cancel_bookings: "Hủy đặt chỗ",
          booking_listbooking_row_paper: "Số dòng",
          booking_listbooking_tablehead_code: "Mã",
          booking_listbooking_tablehead_comming: "Sắp đến",
          booking_listbooking_tablehead_customer: "Khách hàng",
          booking_listbooking_tablehead_time: "Thời gian khách đến",
          booking_listbooking_tablehead_quantity: "Số lượng",
          booking_listbooking_tablehead_mobile: "Điện thoại di động",
          booking_listbooking_tablehead_branch: "Chi nhánh",
          booking_listbooking_tablehead_created_at: "Thời gian tạo",
          booking_listbooking_tablehead_status: "Trạng thái",
          booking_listbooking_cancel: "Hủy bỏ",
          booking_listbooking_no_record: "Chưa ghi nhận",
          booking_listbooking_editform_booking_code: "Mã",
          booking_listbooking_editform_employee: "Nhân viên",
          booking_listbooking_editform_status: "Trạng thái",
          booking_listbooking_editform_estimate_price: "Giá ước tính",
          booking_listbooking_editform_tax: "Thuế",
          booking_listbooking_editform_value_discount: "Giá giảm",
          booking_listbooking_editform_voucher_money: "Tiền từ Voucher",
          booking_listbooking_editform_total_price: "Tổng tiền phải trả",
          booking_listbooking_editform_save: "Lưu",
          booking_listbooking_editform_reason_spa_cancel: "Lý do Spa huỷ đơn",
          booking_listbooking_editform_item: "Dịch vụ",
          booking_listbooking_editform_note_of_customer:
            "Ghi chú của khách hàng",
          booking_listbooking_editform_note_of_spa: "Ghi chú của Spa",
          booking_listbooking_this_status_is_not_implemented_here:
            "Trạng thái này không được thực hiện tại đây",
          booking_listbooking_booking_time: "Lọc theo thời gian khách đến",
          booking_listbooking_click_to_pick_time: "Nhấn để chọn thời gian",
          booking_listbooking_status_booking: "Lọc theo trạng thái",
          booking_listbooking_show_all: "Hiển thị tất cả",
          booking_listbooking_customer_comming_within_an_hour:
            "Khách hàng sẽ đến trong vòng 1 giờ nữa",
          booking_create_create_booking: "Tạo booking",
          booking_create_customer_name: "Tên khách hàng",
          booking_create_quatity: "Số lượng khách hàng",
          booking_create_customerMobile: "Số di động",
          booking_create_time: "Thời gian",
          booking_create_note_for_customer: "Ghi chú của khách hàng",
          booking_create_note_for_spa: "Ghi chú của spa",
          booking_create_create: "Tạo",
          booking_create_mobile_not_valid: "Số điện thoại không đúng",
          booking_create_please_fill_in_customer_name:
            "Vui lòng điền vào tên khách hàng",
          booking_create_please_select_branch: "Vui lòng chọn chi nhánh",
          booking_create_not_found_service_code: "Không tìm thấy mã của spa",
          booking_bookings_cheking: "đặt chỗ đang kiểm tra",
          booking_do_you_want_to_delete_selected_booking:
            "Bạn muốn xoá đặt chỗ đã chọn",
          checking: "Đang kiểm tra",
          abort: "Huỷ sau khi xuất hoá đơn",
          confirm: "Xác nhận",
          missed: "Không đến",
          success: "Thành công",
          cancel: "Hủy bỏ",
          of: "của",
          all: "Tất cả",
          booking: "đặt chỗ",
          // Voucher
          Please_select_at_least_one_method_to_send_voucher:
            "Vui lòng chọn ít nhất 1 phương thức để gửi mã giảm giá đến người dùngr",
          voucher_add_new_voucher: "Thêm mới phiếu giảm giá",
          voucher_search_code: "Tìm kiếm theo mã,tên phiếu",
          voucher_image_gallery: "Bộ sưu tập ảnh",
          voucher_list_voucher: "Phiếu giảm giá",
          voucher_listvoucher_update_successfully: "Cập nhật thành công",
          voucher_listvoucher_update_unsuccessfully:
            "Cập nhật không thành công",
          voucher_listvoucher_delete_successfully: "Xóa bỏ thành công",
          voucher_listvoucher_delete_unsuccessfully: "Xóa bỏ không thành công",
          voucher_listvoucher_cancel: "Hủy bỏ",
          voucher_listvoucher_notice: "Thông báo",
          voucher_listvoucher_delete: "Xóa",
          voucher_listvoucher_do_you_want_to_delete_this_voucher_from_list:
            "Bạn muốn xóa phiếu giảm giá này khỏi danh sách",
          voucher_listvoucher_type: "loại",
          voucher_listvoucher_update: "Cập nhật",
          voucher_listvoucher_rows_paper: "Số dòng",
          voucher_listvoucher_discount: "Giảm giá",
          voucher_listvoucher_tablehead_voucher_code: "Mã",
          voucher_listvoucher_tablehead_voucher_title: "Tên phiếu",
          voucher_listvoucher_tablehead_discount: "Giảm giá/ lần",
          voucher_listvoucher_tablehead_type: "Loại",
          voucher_listvoucher_tablehead_start_date: "Ngày bắt đầu",
          voucher_listvoucher_tablehead_end_date: "Ngày kết thúc",
          voucher_listvoucher_tablehead_item_time: "Thời gian",
          voucher_listvoucher_tablehead_total_discount: "Tổng giảm giá",
          voucher_listvoucher_tablehead_times: "Số lần",
          voucher_listvoucher_tablehead_branch: "Chi nhánh",
          voucher_listvoucher_tabletoolbar_selected: "đã chọn",
          voucher_listvoucher_tabletoolbar_delete: "xóa bỏ",
          voucher_listvoucher_tabletoolbar_all_voucher: "Tất cả phiếu giảm giá",
          voucher_listvoucher_cardvoucher_end_date: "Ngày kết thúc",
          voucher_listvoucher_cardvoucher_discount: "Giảm giá",
          voucher_listvoucher_cardvoucher_title: "Chủ đề (Tối đa 255 ký tự)",
          voucher_listvoucher_cardvoucher_all_branch:
            "Áp dụng cho tất cả chi nhánh",
          voucher_listvoucher_cardvoucher_shortDescription:
            "Mô tả ngắn (Tối đa 255 ký tự)",
          voucher_listvoucher_cardvoucher_description: "Mô tả",
          voucher_listvoucher_do_you_want_to_update_this_voucher:
            "Bạn muốn cập nhật mới cho phiếu giảm giá này?",
          voucher_listcustomer_edit_successfully: "Chỉnh sửa thành công",
          voucher_listcustomer_edit_unsuccessfully:
            "Chỉnh sửa không thành công",
          voucher_listcustomer_delete_customer_successfully:
            "Xóa khách hàng thành công",
          voucher_listcustomer_delete_customer_unsuccessfully:
            "Xóa khách hàng không thành công",
          voucher_listcustomer_do_you_want_to_delete_customer_from_customer_list:
            "Bạn muốn xoá khách hànng này ra khỏi danh sách?",
          voucher_listcustomer_mobile: "Điện thoại",
          voucher_listcustomer_gender: "Giới tính",
          voucher_listcustomer_tabletoolbar_selected: "đã chọn",
          voucher_listcustomer_customer_name: "Tên khách hàng",
          voucher_listcustomer_district: "Quận/Huyện",
          voucher_listcustomer_city: "Thành phố",

          voucher_listcustomer_tablehead_customer_name: "Tên khách hàng",
          voucher_listcustomer_tablehead_mobile: "Điện thoại",
          voucher_listcustomer_tablehead_gender: "Giới tính",
          voucher_listcustomer_tablehead_district: "Quận/Huyện",
          voucher_listcustomer_tablehead_city: "Thành phố",
          selectebranchwithmap_branch: "Chi nhánh",
          voucher_uservoucher_to_user_this_will_send_notify_to_them_via_email:
            " đến khách hàng và sẽ gửi thông báo đến email khách hàng?",
          voucher_uservoucher_to_user: " đến khách hàng?",
          voucher_uservoucher_customers_or_please_upgrade_your_package:
            " khách hàng hoặc vui lòng nâng cấp gói đang sử dụng",
          voucher_uservoucher_phone_number_existed_in_list_selected:
            "Số điện thoại đã tồn tại trong danh sách",
          voucher_uservoucher_phone_number_not_valid:
            "Số điện thoại không hợp lệ",
          voucher_uservoucher_phone: "Điện thoại",
          voucher_uservoucher_customerlist: "Danh sách khách hàng",
          voucher_uservoucher_please_select_at_least_one_customer:
            "Vui lòng chọn ít nhất 1 khách hàng",
          voucher_uservoucher_please_enter_at_least_one_phone_number:
            "Vui lòng nhập ít nhất 1 số điện thoại",
          "voucher_uservoucher_system error_please_try_again":
            "Hệ thống bị lỗi vui lòng thử lại lần nữa",
          voucher_uservoucher_send_voucher: "Gửi phiếu giảm giá",
          voucher_uservoucher_you_exceeded: "Bạn đã vượt quá",
          voucher_uservoucher_times_allowed_to_send_vouchers_this_month_you_can_only_send_maximum:
            " thời gian được gửi phiếu giảm giá tháng này.Bạn chỉ có thể gửi tối đa",
          voucher_uservoucher_mobile_phone_or_please_upgrade_your_package:
            "số điện thoại hoặc nâng cấp thêm gói của bạn đang sử dụng",
          voucher_uservoucher_successfully: " thành công",
          voucher_uservoucher_unsuccessfully: " không thành công",
          voucher_uservoucher_system_error_please_try_again:
            "Hệ thống bị lỗi, vui lòng thử lại lần nữa",
          voucher_uservoucher_sent_voucher: "Đã gửi phiếu giảm giá",
          voucher_uservoucher_cancel: "Hủy bỏ",
          voucher_uservoucher_send: "Gửi",
          voucher_uservoucher_send_by_sms: "Gửi thông qua tin nhắn",
          voucher_uservoucher_send_notify_on_app: "Gửi qua thông báo trên app",
          voucher_uservoucher_search_by_name_phone: "Tìm kiếm tên, điện thoại",
          voucher_uservoucher_notice: "Thông báo",
          voucher_uservoucher_upgrade: "Nâng cấp",
          voucher_uservoucher_you_can_only_send_maximum_of_100_customers_per_submission_to_send_more_customers_upgrade_your_package_to_premium:
            "Bạn chỉ có thể gửi tối đa 100 khách hàng.Để gửi nhiều khách hàng hơn nữa cần nâng cấp lên gói Gold",
          voucher_uservoucher_type_phone_number: "Nhập số điện thoại",
          voucher_uservoucher_list_selected: "Danh sách đã chọn",
          voucher_uservoucher_button_add: "Thêm",
          voucher_uservoucher_type_email: "Nhập email",
          voucher_uservoucher_send_voucher_to_customer:
            "Gửi phiếu giảm giá này đến khách hàng",
          voucher_uservoucher_select_by_customer_list: "Chọn khách hàng",
          voucher_uservoucher_select_by_phone_number: "Chọn số điện thoại",
          voucher_uservoucher_do_you_want_to_send_voucher:
            "Bạn muốn gửi mã phiếu giảm giá",
          voucher_addvoucher_cancel: "Hủy bỏ",
          voucher_addvoucher_create_successfully: "Khởi tạo thành công",
          voucher_addvoucher_create_unsuccessfully: "Khởi tạo không thành công",
          voucher_addvoucher_upload_image_unsuccessfully:
            "Tải ảnh lên firebase không thành công",
          voucher_addvoucher_create: "Khởi tạo",
          voucher_addvoucher_confirm: "Xác nhận",
          voucher_addvoucher_notice: "Thông báo",
          voucher_addvoucher_do_you_want_to_add_new_voucher:
            "Bạn muốn thêm mới cho phiếu giảm giá?",
          voucher_addvoucher_nothing_apply_branch:
            "Không có chi nhánh nào được áp dụng",
          voucher_addvoucher_please_add_discount:
            "Vui lòng thêm số tiền hoặc phần trăm giảm giá",
          voucher_addvoucher_please_add_startedDate_discount:
            "Vui lòng thêm ngày bắt đầu giảm giá",
          voucher_addvoucher_please_add_endedDate_discount:
            "Vui lòng thêm ngày kết thúc giảm giá",
          voucher_addvoucher_please_add_endedDate_more_than_startedDate:
            "Vui lòng thêm ngày kết thúc lớn hơn ngày bắt đầu",
          voucher_addvoucher_please_add_title:
            "Vui lòng thêm chủ đề của phiếu giảm giá này",
          voucher_addvoucher_please_add_shortDescription:
            "Vui lòng thêm một mô tả ngắn của phiếu giảm giá này",
          voucher_addvoucher_discount: "Giảm giá",
          voucher_addvoucher_percent: "Phần trăm",
          voucher_addvoucher_value: "Tiền mặt",
          voucher_addvoucher_upload_image_in_gallery_successfully:
            "Cập nhật ảnh trong bộ sưu tập thành công",
          voucher_addvoucher_upload_image_in_gallery_unsuccessfully:
            "Cập nhật ảnh trong bộ sưu tập không thành công",
          voucher_addvoucher_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Vui lòng nhập 1 số giảm giá nhỏ hơn hoặc bằng 100 cho loại phần trăm",
          voucher_addvoucher_type: "Loại",
          voucher_addvoucher_start_date: "Ngày bắt đầu",
          voucher_addvoucher_end_date: "Ngày kết thúc",
          voucher_addvoucher_save: "Lưu",
          voucher_addvoucher_image_voucher: "Ảnh phiếu giảm giá",
          voucher_addvoucher_upload_image_success:
            "Tải ảnh trong phiếu giảm giá thành công",
          voucher_addvoucher__upload_image_unsuccess:
            "Tải ảnh trong phiếu giảm giá không thành công",
          voucher_delete_image_in_gallery:
            "Xóa ảnh này trong bộ sưu tập ảnh của phiếu giảm giá",
          voucher_preview_voucher: "Xem trước phiếu giảm giá",

          // Member Card
          membercard: "Thẻ thành viên",
          membercard_un_specified: "Không giới hạn",
          membercard_add_title: "Tiêu đề",
          membercard_add_code: "Code",
          membercard_add_times: "Số lần sử dụng",
          membercard_add_price: "Giá (Số tiền khách hàng cần trả)",
          membercard_add_value: "Giá trị thật (Số tiền khách hàng nhận được)",
          membercard_add_shortDescription: "Mô tả ngắn",
          membercard_add_all_branch: "Áp dụng cho tất cả chi nhánh",
          membercard_add_expiredDays: "Thời hạn (Ngày)",
          membercard_add_isShow: "Hiển thị trên web",
          membercard_add_show: "Hiển thị",
          membercard_add_hide: "Ẩn",
          membercard_add_description: "Mô tả",
          membercard_add_save: "Lưu",
          membercard_add_create_successfully: "Tạo thành công",
          membercard_add_create_unsuccessfully: "Tạo thất bại",
          membercard_add_upload_image_unsuccessfully: "Tải ảnh lên thất bại",
          membercard_add_image: "Hình ảnh",
          membercard_add_expired_days: "Thời hạn",
          membercard_add_please_add_title:
            "Vui lòng thêm chủ đề của thẻ thành viên này",
          membercard_add_nothing_apply_branch:
            "Không có chi nhánh nào được áp dụng",
          membercard_add_please_add_price_value:
            "Vui lòng thêm giá phải trả của thẻ thành viên này",
          membercard_add_please_add_expiredDays:
            "Vui lòng nhập thời hạn của thẻ",
          membercard_add_new_membercard: "Thêm một thẻ mới",
          membercard_add_please_fill_in_required:
            "Vui lòng điển vào trường được yêu cầu",
          membercard_list_update_successfully: "Cập nhật thành công",
          membercard_list_update_unsuccessfully: "Cập nhật không thành công",
          membercard_list_delete_successfully: "Xóa thành công",
          membercard_list_delete_unsuccessfully: "Xóa không thành công",
          membercard_list_cancel: "Hủy",
          membercard_list_notice: "Thông báo",
          membercard_list_membercard: "Danh sách thẻ thành viên",
          membercard_all_membercard: "Tất cả thẻ",
          membercard_list_delete: "Xóa",
          membercard_list_do_you_want_to_delete_this_card_from_list:
            "Bạn muốn xóa Thẻ thành viên này khỏi danh sách",
          membercard_list_rows_paper: "Số dòng",
          membercard_list_tabletoolbar_selected: "đã chọn",
          membercard_list_tabletoolbar_delete: "xóa bỏ",
          membercard_cardmember_description: "Mô tả",
          membercard_search_title_code: "Tìm theo tên và code",
          membercard_user_member_card_add_customer_button: "Thêm khách hàng",
          membercard_user_member_card_add_customer: "Thêm khách hàng",
          membercard_user_member_card_customer_name: "Tên khách hàng",
          membercard_user_member_card_customer_mobile: "Số di động khách hàng",
          membercard_user_member_card_close: "Đóng",

          // UserMembercard
          user_membercard_user_already_have_the_membercard:
            "Người dùng đã có thẻ",
          user_membercard_history_search_by_order_code:
            "Tìm theo code đơn hàng",
          user_membercard_search_by_membercardCode_and_customerMobile:
            "Tìm theo mã, số điện thoại",
          user_membercard_all_user_membercard: "Tất cả người nhận thẻ",
          user_membercard_send_user_membercard_to_customer:
            "Gửi thẻ thành viên đến khách hàng",
          user_membercard_do_you_want_to_delete_membercard_of_user:
            "Bạn muốn xóa thẻ thành viên của người dùng",
          user_membercard_do_you_want_to_send_membercard:
            "Bạn có muốn gửi thẻ thành viên",
          user_membercard_and_create_new_customer_if_they_are_not_in_customer_list:
            "Tạo khách hàng mới nếu họ chưa có trong danh sách khách hàng",
          user_membercard_to_user: "đến khách hàng?",
          user_membercard_send_membercard: "Gửi thẻ thành viên",
          user_membercard: "Người nhận thẻ thành viên",
          user_membercard_mobile: "Số di động",
          user_membercard_name: "Tên khách hàng",
          user_membercard_is_user: "Người dùng",
          user_membercard_balance: "Số tiền còn lại trong thẻ",
          user_membercard_img_member_card: "Ảnh thẻ",
          user_membercard_title: "Tên thẻ",
          user_membercard_expire_day: "Ngày hết hạn thẻ",
          user_membercard_detail_order: "Chi tiết đơn hàng",
          user_membercard_history_membercard: "Lịch sử sử dụng",
          user_membercard_history_membercard_not_found:
            "Không tìm thấy lịch sử sử dụng",
          user_membercard_users_card: "Thẻ của",
          user_membercard_users: "KH",
          user_membercard_time_to_use_card: "Tổng thời gian sử dụng thẻ",
          user_membercard_time_send_to_customer:
            "Thời gian gửi thẻ tới khách hàng",
          user_membercard_value_to_use: "Số tiền có thể sử dụng",
          user_membercard_type: "Loại thẻ thành viên",
          user_membercard_membercardId: "Id của thẻ",
          user_membercard_membercardCode: "Mã Code của thẻ",
          user_membercard_short_description: "Mô tả ngắn",
          user_membercard_description: "Mô tả",
          user_membercard_price_to_buy: "Giá mua",
          user_membercard_max_number_of_times_to_use: "Số lần tối đa sử dụng",
          user_membercard_used_number_of_times: "Số lần đã sử dụng",
          user_membercard_delete_success:
            "Xóa thẻ thành viên của khách hàng thành công",
          //MySpa---Branch
          servicebranch_list_branch: "Danh sách chi nhánh",
          servicebranch_add_new_branch: "Thêm chi nhánh mới",
          servicebranch_search_name: "Tìm kiếm tên",
          servicebranch_delete: "Xóa bỏ",
          servicebranch_update: "Cập nhật",
          servicebranch_update_successfully: "Cập nhật thành công",
          servicebranch_update_unsuccessfully: "Cập nhật không thành công",
          servicebranch_cancel: "Hủy bỏ",
          servicebranch_notice: "Thông báo",
          servicebranch_row_paper: "Số dòng",
          servicebranch_branch_name: "Tên chi nhánh",
          servicebranch_address: "Địa chỉ",
          servicebranch_mobile: "Điện thoại di động",
          servicebranch_phone: "Số điện thoại",
          servicebranch_tablehead_branch_name: "Chi nhánh",
          servicebranch_tablehead_address: "Địa chỉ",
          servicebranch_tablehead_mobile: "Điện thoại di động",
          servicebranch_tablehead_phone: "Điện thoại bàn",
          servicebranch_search_code_name_address: "Tìm tên, mã, địa chỉ",
          are_you_sure_that_you_want_to_delete_this_branch:
            "Bạn chắc muốn xóa chi nhánh này?",
          servicebranch_delete_successfully: "Xóa bỏ thành công",
          servicebranch_delete_unsuccessfully: "Xóa bỏ không thành công",
          servicebranch_tabletoolbar_selected: "đã chọn",
          servicebranch_tabletoolbar_delete: "xóa",
          servicebranch_editbranch_address_invalid: "Địa chỉ không hợp lệ",
          servicebranch_createbranch_please_enter_valid_phone:
            "Số di động không hợp lệ",
          servicebranch_editbranch_branch_name: "Tên chi nhánh",
          servicebranch_editbranch_mobile: "Điện thoại di động",
          servicebranch_editbranch_phone: "Điện thoại",
          servicebranch_editbranch_address: "Địa chỉ",
          servicebranch_editbranch_city: "Thành phố",
          servicebranch_editbranch_district: "Quận/Huyện",
          servicebranch_editbranch_go_to_location: "đến nơi",
          servicebranch_editbranch_suggest_address:
            "Địa chỉ để hiển thị lên bản đồ",
          servicebranch_editbranch_latitude: "Vĩ độ",
          servicebranch_editbranch_longitude: "Kinh độ",
          servicebranch_editbranch_save: "Lưu",
          servicebranch_createbranch_cancel: "Hủy bỏ",
          servicebranch_createbranch_address_invalid:
            "Địa chỉ để hiển thị trên bản đồ không hợp lệ",
          servicebranch_createbranch_fill_in_branch_name:
            "Vui lòng điền vào tên chi nhánh",
          servicebranch_createbranch_fill_in_branch_mobile:
            "Vui lòng điền vào điện thoại di động",
          servicebranch_createbranch_fill_in_branch_address:
            "Vui lòng điền vào địa chỉ",
          servicebranch_createbranch_fill_in_branch_address_to_show_on_map:
            "Vui lòng điền vào địa chỉ hiển thị trên bản đồ",
          servicebranch_createbranch_create_successfully: "Khởi tạo thành công",
          servicebranch_createbranch_create_unsuccessfully:
            "Khởi tạo không thành công",
          servicebranch_createbranch_create: "Khởi tạo",
          servicebranch_createbranch_confirm: "Xác nhận",
          servicebranch_createbranch_create_new_branch_for_your_spa:
            "Khởi tạo chi nhánh mới cho spa của bạn",
          servicebranch_createbranch_branch_name: "Tên chi nhánh",
          servicebranch_createbranch_mobile: "Điện thoại di động",
          servicebranch_createbranch_phone: "Số điện thoại",
          servicebranch_createbranch_address: "Địa chỉ",
          servicebranch_createbranch_city: "Thành phố",
          servicebranch_createbranch_district: "Quận/Huyện",
          servicebranch_are_you_sure_that_you_want_to_update_this_branch:
            "Bạn có chắc muốn cập nhật cho chi nhánh này?",
          servicebranch_createbranch_go_to_location: "Đi đến nơi",
          servicebranch_createbranch_save: "Lưu",
          select_branch_with_map_all_branch: "Tất cả",
          // MySpa--Detail
          service_workingdays_opening_hour: "Giờ mở cửa",
          service_workingdays_close_hour: "Giờ đóng cửa",
          service_workingdays_day_off: "Ngày nghỉ",
          service_workingdays_monday: "Thứ Hai",
          service_workingdays_tuesday: "Thứ Ba",
          service_workingdays_wednesday: "Thứ Tư",
          service_workingdays_thursday: "Thứ Năm",
          service_workingdays_friday: "Thứ Sáu",
          service_workingdays_saturday: "Thứ Bảy",
          service_workingdays_sunday: "Chủ Nhật",
          service_ownerspa_servicedetail_feature_type_color_for_your_spa:
            "Nhập màu sắc chủ đạo spa của bạn",
          // MySpa --- menu
          menu_menu: "Danh Mục",
          menu_add_successfully: "Thêm thành công",
          menu_add_unsuccessfully: "Thêm không thành công",
          menu_menugroup_delete_successfully: "Xóa bỏ thành công",
          menu_menugroup_delete_unsuccessfully: "Xóa bỏ không thành công",
          menu_menugroup_cancel: "Hủy",
          menu_menugroup_yes: "Đồng ý",
          menu_menugroup_confirm: "Xác nhận",
          menu_menugroup_do_you_want_to_delete_this_menu_group:
            "Bạn muốn xóa nhóm danh mục này?",
          menu_menugroup_nothing_item_selected:
            "Không có dịch vụ nào được chọn",
          menu_menugroup_menugroup: "Nhóm danh mục",
          menu_menugroup_selected: "đã chọn",
          menu_menugroup_delete: "xóa",
          menu_menugroup_name: "Danh mục",
          menu_menugroup_menu_group_empty:
            "Không có nhóm dịch vụ. Nhấn nút cộng để thêm mới",
          menu_menugroup_listmenugroup_delete_successfully: "Xóa bỏ thành công",
          menu_menugroup_listmenugroup_delete_unsuccessfully:
            "Xóa bỏ không thành công",
          menu_menugroup_listmenugroup_cancel: "Hủy bỏ",
          menu_menugroup_listmenugroup_yes: "Đồng ý",
          menu_menugroup_listmenugroup_confirm: "Xác nhận",
          menu_menugroup_listmenugroup_nothing_item_is_selected:
            "Không có hàng hóa nào được chọn",
          menu_menugroup_listmenugroup_menugroup: "Danh sách nhóm",
          menu_menugroup_listmenugroup_do_you_want_to_delete_this_menu_group:
            "Bạn muốn xóa nhóm danh mục này?",
          menu_menugroup_listmenugroup_rowPaper: "Số dòng",
          menu_menugroup_addmenugroup_cancel: "Hủy bỏ",
          menu_menugroup_addmenugroup_yes: "Đồng ý",
          menu_menugroup_addmenugroup_confirm: "Xác nhận",
          menu_menugroup_addmenugroup_add: "Thêm",
          menu_menugroup_addmenugroup_please_fill_in_name:
            "Vui lòng điền vào tên danh mục",
          menu_menugroup_addmenugroup_add_new_menu_group: "Thêm danh mục",
          menu_menugroup_addmenugroup_title: "Tiêu đề",
          menu_menugroup_editmenugroup_edit_successfully:
            "Chỉnh sửa thành công",
          menu_menugroup_editmenugroup_edit_unsuccessfully:
            "Chỉnh sửa không thành công",
          menu_menugroup_editmenugroup_cancel: "Hủy bỏ",
          menu_menugroup_editmenugroup_yes: "Đồng ý",
          menu_menugroup_editmenugroup_confirm: "Xác nhận",
          menu_menugroup_editmenugroup_do_you_want_to_change_name_of_this_menu_group:
            "Bạn muốn thay đổi thông tin cho nhóm danh mục này?",
          menu_menugroup_editmenugroup_name: "Tên danh mục",
          menu_menugroup_editmenugroup_save: "Lưu",
          menu_menugroup_editmenugroup_add: "Thêm",
          menu_menugroup_editmenugroup_featured: "Danh Mục Nổi Bật",
          menu_menugroup_editmenugroup_not_featured: "Danh Mục Không Nổi Bật",
          menu_menugroup_editmenugroup_not_selected: "Không chọn",
          menu_menuitem_search: "Tìm tiêu đề",
          menu_menuitem_delete_successfully: "Xóa bỏ thành công",
          menu_menuitem_delete_unsuccessfully: "Xóa bỏ không thành công",
          menu_menuitem_cancel: "Hủy bỏ",
          menu_menuitem_yes: "Đồng ý",
          menu_menuitem_select_menu_parent: "Danh mục gốc",
          menu_menuitem_confirm: "Xác nhận",
          menu_menuitem_do_you_want_to_delete_this_menu_group_from_list:
            "Bạn muốn xóa danh mục này?",
          menu_menuitem_nothing_item_is_selected:
            "Không có hàng hóa nào được chọn",
          menu_menuitem_menu_item: "Dịch Vụ",
          menu_menuitem_edit_menu: "Chỉnh sửa dịch vụ",
          menu_menuitem_featured_item: "Nổi Bật",
          menu_menuitem_all_item: "Tất cả",
          menu_menuitem_item_type: "Loại dịch vụ",
          menu_menuitem_not_featured_item: "Không Nổi Bật",
          menu_menuitem_rows_paper: "Số dòng",
          menu_menuitem_tablehead_title: "Tên",
          menu_menuitem_tablehead_description: "Mô tả",
          menu_menuitem_tablehead_price: "Giá cả",
          menu_menuitem_tablehead_unit: "Đơn vị",
          menu_menuitem_tablehead_time: "Thời gian",
          menu_menuitem_tablehead_featured: "Nổi bật",
          menu_menuitem_toolbaritem_selected: "đã chọn",
          menu_menuitem_toolbaritem_delete: "Xóa",
          menu_menuitem_editmenuitem_update_successfully: "Cập nhật thành công",
          menu_menuitem_editmenuitem_update_unsuccessfully:
            "Cập nhật không thành công",
          menu_menuitem_editmenuitem_cancel: "Hủy bỏ",
          menu_menuitem_editmenuitem_yes: "Đồng ý",
          menu_menuitem_editmenuitem_confirm: "Xác nhận",
          menu_menuitem_editmenuitem_are_you_sure_you_want_to_change_in_menu_item:
            "Bạn có có chắc muốn cập nhật lại thông tin của dịch vụ này?",
          menu_menuitem_selectmenu_please_select_one_menuid:
            "Vui lòng chon 1 menuId",
          menu_menuitem_editmenuitem_title: "Tiêu đề",
          menu_menuitem_editmenuitem_unit: "Đơn vị",
          menu_menuitem_editmenuitem_price: "Giá cả",
          menu_menuitem_editmenuitem_save: "Lưu",
          menu_menuitem_editmenuitem_description: "Mô tả",
          menu_menuitem_addmenuitem_please_select_menu_group:
            "Vui lòng chọn nhóm",
          menu_menuitem_addmenuitem_please_fill_in_title:
            "Vui lòng điền tiêu đề",
          menu_menuitem_addmenuitem_please_input_description:
            "Vui lòng điền vào mô tả",
          menu_menuitem_addmenuitem_please_fill_in_price:
            "Vui lòng điền giá cả",
          menu_menuitem_addmenuitem_please_fill_in_time:
            "Vui lòng điền thời gian",
          menu_menuitem_editmenuitem_time: "Thời gian",
          menu_menuitem_editmenuitem_minute: "Phút",
          menu_menuitem_editmenuitem_times: "Lần",
          menu_menuitem_editmenuitem_position: "Vị trí",
          menu_menuitem_addmenuitem_cancel: "Hủy bỏ",
          menu_menuitem_addmenuitem_yes: "Đồng ý",
          menu_menuitem_addmenuitem_confirm: "Xác nhận",
          menu_menuitem_addmenuitem_add_new_menu_item: "Thêm Dịch Vụ",
          menu_menuitem_addmenuitem_title: "Tiêu đề",
          menu_menuitem_addmenuitem_description: "Mô tả",
          menu_menuitem_addmenuitem_price: "Giá cả",
          menu_menuitem_addmenuitem_price_to_show_on_web:
            "Giá để hiển thị trên web",
          // 'menu_menuitem_addmenuitem_type': 'Loại',
          menu_menuitem_addmenuitem_time: "Thời gian",
          menu_menuitem_addmenuitem_group: "Danh mục",
          menu_menuitem_addmenuitem_add: "Thêm",
          menu_menuitem_remove_item_featured_successfully:
            "Bỏ tính nổi bật của dịch vụ thành công",
          menu_menuitem_remove_item_featured_unsuccessfully:
            "Bỏ tính nổi bật của dịch vụ không thành công",
          menu_menuitem_add_item_featured_successfully:
            "Thêm tính nổi bật của dịch vụ thành công",
          menu_menuitem_add_item_featured_unsuccessfully:
            "Thêm tính nổi bật của dịch vụ không thành công",
          menu_menuitem_menu_item_empty:
            "Không có dịch vụ. Nhấn nút cộng để thêm mới",
          remove_featured: "Bỏ Khỏi Tiêu Biểu",
          add_featured: " Thêm Vào Tiêu Biểu",
          menu_menuitem_min: "Phút",
          // Customer
          customer_list_customers: "Danh sách khách hàng",
          customer_add_new_customer: "Thêm khách hàng mới",
          customer_search_by_name_email_phone:
            "Tìm tên, email và số điện thoại",
          customer_chart: "Biểu đồ",
          customer_chart_chartage_the_value_of: "Giá trị",
          customer_chart_chartgender_the_value_of: "Giá trị",
          customer_chart_chartage_is: "là",
          customer_chart_chartgender_is: "là",
          customer_addcustomer_add_new_customer: "Thêm khách hàng mới",
          customer_addcustomer_cancel: "Hủy bỏ",
          customer_addcustomer_add: "Thêm",
          customer_addcustomer_confirm: "Xác nhận",
          customer_addcustomer_notice: "Thông báo",
          customer_addcustomer_name: "Tên",
          customer_addcustomer_birthDay: "Ngày sinh",
          customer_addcustomer_gender: "Giới tính",
          customer_addcustomer_address: "Địa chỉ",
          customer_useSerives: "Dịch vụ đã sử dụng",
          customer_useSerives_placeholder:
            "Điền vào một số ký tự của dịch vụ để hiện gợi ý",
          customer_interesting: "Quan tâm",
          customer_interesting_placeholder:
            "Điền vào ký tự `Menu` để hiện gợi ý",
          customer_lastTime: "Lần cuối đến spa",
          customer_addcustomer_mobile: "Điện thoại",
          customer_addcustomer_city: "Thành phố",
          customer_addcustomer_state: "Tiểu Bang",
          customer_addcustomer_country: "Quốc Gia",
          customer_addcustomer_district: "Quận/Huyện",
          customer_addcustomer_create_customer: "Khởi tạo",
          customer_addcustomer_cancel_customer: "Hủy",
          customer_addcustomer_please_fill_in_this_form:
            "Vui lòng điền đầy đủ thông tin bắt buộc",
          customer_addcustomer_phone_number_is_not_valid:
            "Số điện thoại không hợp lệ",
          customer_customer_report_items: "Dịch vụ|Giá tiền",
          customer_listcustomer_do_you_want_to_remove_customer_from_customer_list:
            "Bạn muốn xoá khách hàng này ra khỏi danh sách khách hàng?",
          customer_listcustomer_editcustomer_are_you_sure_that_you_want_to_edit_customer_information:
            "Bạn chắc bạn muốn chỉnh sửa thông tin khách hàng?",
          customer_listcustomer_editcustomer_customer_code: "Mã khách hàng",
          customer_listcustomer_editcustomer_created_at: "Ngày khởi tạo",
          customer_listcustomer_editcustomer_updated_at: "Ngày cập nhật",
          customer_listcustomer_editcustomer_name: "Tên",
          customer_listcustomer_editcustomer_country_code: "Mã",
          customer_listcustomer_editcustomer_mobile: "Điện thoại",
          customer_listcustomer_editcustomer_address: "Địa chỉ",
          customer_listcustomer_editcustomer_city: "Thành phố",
          customer_listcustomer_editcustomer_district: "Quận/Huyện",
          customer_listcustomer_editcustomer_birthDay: "Ngày sinh",
          customer_listcustomer_editcustomer_gender: "Giới tính",
          customer_listcustomer_editcustomer_view_report: "Xem báo cáo",
          customer_listcustomer_editcustomer_save: "Lưu",
          customer_chart_edit_successfully: "Chỉnh sửa thành công",
          customer_chart_edit_unsuccessfully: "Chỉnh sửa không thành công",
          customer_chart_gender: "Giới tính",
          customer_chart_age: "Tuổi",
          customer_chart_delete_customer_successfully:
            "Xoá bỏ khách hàng thành công",
          customer_chart_delete_customer_unsuccessfully:
            "Xóa bỏ khách hàng không thành công",
          customer_create_customer_successfully: "Tạo khách hàng thành công",
          customer_create_customer_unsuccessfully:
            "Tạo khách hàng không thành công",
          customer_not_found_any_customer: "Không tìm thấy khách hàng nào",
          customer_customer_existed_please_try_again:
            "Khách hàng này đã tồn tại. Vui lòng thử lại",
          customer_upload_image_and_create_customer_unsuccessfully:
            "Đăng ảnh và tạo khách hàng không thành công",
          customer_addcustomer_upload_error: "Đăng ảnh bị lỗi",
          customer_report: "Báo cáo khách hàng",
          customer_customer_report_first_order_day: "Ngày đặt hàng đầu tiên",
          customer_customer_report_last_order_day: "Ngày đặt hàng cuối cùng",
          customer_customer_report_orders_to_date: "Số đơn hàng đã đặt",
          "customer_customer_report_average order value":
            "Giá trị đơn hàng trung bình",
          customer_customer_report_order_value_to_date:
            "Tổng giá trị các đơn hàng đã đặt",
          customer_customer_report_date: "Ngày",
          customer_customer_report_orders_by_items: "Đơn hàng dịch vụ",
          customer_customer_report_orders_by_branches: "Đơn hàng chi nhánh",
          customer_customer_report_branches: "Chi nhánh",
          customer_customer_report_summary: "Tổng cộng",
          customer_listcustomer_edit_successfully: "Chỉnh sửa thành công",
          customer_listcustomer_edit_unsuccessfully:
            "Chỉnh sửa không thành công",
          customer_customer_report_start_date_should_not_be_more_than_ended_date:
            "Ngày bắt đầu không được lớn hơn ngày kết thúc",
          customer_customer_report_end_date_should_not_be_less_than_start_date:
            "Ngày kết thúc không được nhỏ hơn ngày bắt đầu",
          customer_listcustomer_delete_customer_successfully:
            "Xóa bỏ thành công",
          customer_listcustomer_delete_customer_unsuccessfully:
            "Xóa bỏ không thành công",
          customer_listcustomer_continute: "Đồng ý",
          customer_listcustomer_confirm: "Xác nhận",
          customer_listcustomer_rows_paper: "Số dòng",
          customer_listcustomer_day_of_birth: "Ngày sinh",
          customer_listcustomer_created_at: "Ngày khởi tạo",
          customer_listcustomer_mobile: "Số di động",
          customer_listcustomer_email: "Email",
          customer_listcustomer_age: "Tuổi",
          customer_listcustomer_gender: "Giới tính",
          customer_listcustomer_country: "Quốc gia",
          customer_listcustomer_city: "Thành phố",
          customer_listcustomer_district: "Quận(huyện)",
          customer_listcustomer_ward: "Phường(xã)",
          customer_listcustomer_infomation: "Thông tin",
          customer_listcustomer_contact: "Liên lạc",
          customer_listcustomer_address: "Địa chỉ",
          customer_listcustomer_report: "Báo cáo",
          customer_listcustomer_all_customers: "Tất cả khách hàng",
          customer_listcustomer_close: "Đóng",
          customer_listcustomer_edit: "Chi tiết",
          customer_listcustomer_record_found: "dòng được tìm thấy",
          customer_listcustomer_page: "trang",
          customer_listcustomer_of: "của",
          customer_listcustomer_apply_filter: "Áp dụng lọc",
          customer_listcustomer_export_excel: "Xuất",
          customer_listcustomer_clear: "Xóa lọc",
          customer_listcustomer_tablehead_customer_name: "Tên",
          customer_listcustomer_tablehead_mobile: "Điện thoại",
          customer_listcustomer_tablehead_email: "Email",
          customer_listcustomer_tablehead_gender: "Giới tính",
          customer_listcustomer_tablehead_district: "Quận/Huyện",
          customer_listcustomer_tablehead_city: "Thành phố",
          customer_listcustomer_tablehead_created_at: "Ngày khởi tạo",
          customer_listcustomer_tablehead_updated_at: "Ngày cập nhật",
          customer_listcustomer_tablehead_edit: "Chỉnh sửa",
          customer_listcustomer_toolbar_selected: "đã chọn",
          customer_listcustomer_toolbar_delete: "xóa",
          customer_listcustomer_editcustomer_edit_avatar_successfully:
            "Chỉnh sửa avatar thành công",
          customer_listcustomer_editcustomer_edit_avatar_error:
            "Chỉnh sửa avatar bị lỗi",
          customer_listcustomer_editcustomer_cancel: "Hủy bỏ",
          customer_listcustomer_editcustomer_continute: "Đồng ý",
          customer_listcustomer_editcustomer_confirm: "Xác nhận",
          customer_listcustomer_cancel: "Hủy bỏ",
          // Dashboard
          dashboard_admin_total_active_spa: "Tổng số spa đang hoạt động",
          dashboard_reaction_reaction: "Phản hồi",
          dashboard_reaction_like: "Thích",
          dashboard_reaction_heart: "Yêu thích",
          dashboard_reaction_follow: "Theo dõi",
          dashboard_reaction_toolbar_total_reaction: "Tổng Phản Hồi",
          dashboard_reaction_toolbar_last_3_months_before: "3 tháng trước",
          dashboard_order: "Đơn hàng",
          dashboard_order_toolbar_total: "Tổng cộng",
          dashboard_order_toolbar_orders: "Đơn Hàng",
          dashboard_order_toolbar_from: "Từ",
          dashboard_order_toolbar_type: "Loại",
          dashboard_order_toolbar_to: "Đến",
          dashboard_order_toolbar_all_orders: "Tất cả đơn hàng",
          dashboard_booking_total: "Tổng số",
          dashboard_booking_from: "Từ",
          dashboard_booking_to: "Đến",
          dashboard_booking: "Đặt chỗ",
          dashboard_booking_bookings: "Đặt Chỗ",
          date_picker_ok: "Đồng ý",
          date_picker_cancel: "Đóng",
          new: "Mới",
          processing: "Đang tiến hành",
          done: "Hoàn tất",
          next: "Tiếp tục",
          toolbar_delete: "Xóa",
          // Employees
          employees_add_new_employee_successfully:
            "Thêm nhân viên mới thành công",
          employees_add_new_employee: "Thêm mới",
          employees_search: "Tìm mã, tên, nickname, số điện thoại",
          employees_code: "Mã QG",
          employees_listemployee_date: "Ngày",
          employees_listemployee_month: "Tháng",
          employees_listemployee_hour: "Giờ",
          employees_listemployee_delete: "Xóa",
          employees_listemployee_delete_successfully: "Xóa bỏ thành công",
          employees_listemployee_delete_delete_unsuccessfully:
            "Xóa bỏ không thành công",
          employees_listemployee_cancel: "Hủy bỏ",
          employees_listemployee_notice: "Thông báo",
          employees_listemployee_rows_paper: "Số dòng",
          employees_list_employees: "Danh sách nhân viên",
          employees_listemployee_active: "Hoạt động",
          employees_listemployee_inactive: "Không hoạt động",
          employees_listemployee_tablehead_employeeNumber: "Mã",
          employees_listemployee_tablehead_name: "Tên",
          employees_listemployee_tablehead_nickname: "Nickname",
          employees_listemployee_tablehead_mobile: "Điện thoại",
          employees_listemployee_tablehead_employee_type: "Loại",
          employees_listemployee_tablehead_module_role: "Module-role",
          employees_listemployee_tablehead_active: "Hoạt động",
          employees_listemployee_tablehead_salary: "Lương",
          employees_listemployee_tablehead_edit: "Chỉnh sửa",
          employees_listemployee_toolbar_selected: "đã chọn",
          employees_listemployee_toolbar_delete: "xóa",
          all_employee: "Tất cả nhân viên",
          employees_listemployee_editemployee_editcontent_module_role:
            "Phân quyền",
          employees_listemployee_editemployee_editcontent_update_successfully:
            "Cập nhật thành công",
          employees_listemployee_editemployee_editcontent_update_unsuccessfully:
            "Cập nhật không thành công",
          employees_listemployee_editemployee_editcontent_delete_successfully:
            "Xóa bỏ thành công",
          employees_listemployee_editemployee_editcontent_delete_unsuccessfully:
            "Xóa bỏ không thành công",
          employees_listemployee_editemployee_editcontent_cancel: "Hủy bỏ",
          employees_listemployee_editemployee_editcontent_notice: "Thông báo",
          employees_listemployee_editemployee_editcontent_name: "Tên",
          employees_listemployee_editemployee_editcontent_nickname: "Nickname",
          employees_listemployee_editemployee_editcontent_mobile: "Điện thoại",
          employees_listemployee_editemployee_editcontent_userCode:
            "Mã người dùng",
          employees_listemployee_are_you_sure_that_you_want_to_delete:
            "Bạn có chắc là bạn muốn xóa không?",
          employees_listemployee_editemployee_editcontent_edit_employee_information:
            "Điều chỉnh thông tin nhân viên",
          employees_listemployee_editemployee_editcontent_employee_no:
            "Số thứ tự",
          employees_listemployee_editemployee_editcontent_employee_code: "Mã",
          employees_listemployee_editemployee_editcontent_employee_created_at:
            "Ngày khởi tạo",
          employees_listemployee_editemployee_editcontent_employee_updated_at:
            "Ngày cập nhật",
          employees_listemployee_editemployee_editcontent_employee_active:
            "Hoạt động",
          employees_listemployee_editemployee_editcontent_employee_salary:
            "Lương",
          employees_listemployee_editemployee_editcontent_employee_typeSalary:
            "Loại lương",
          employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_fired_employee_out_of_system:
            "Bạn có chắc rằng bạn muốn xóa nhân viên ra khỏi hệ thống?",
          employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_edit_it:
            "Bạn có chắc là bạn muốn điều chỉnh?",
          employees_listemployee_editemployee_editcontent_fill_in_name:
            "Vui lòng điền vào tên nhân viên",
          employees_listemployee_editemployee_please_enter_discount_less_than_or_equal_to_100_for_percent:
            "Vui lòng nhập 1 số hoa hồng nhỏ hơn hoặc bằng 100 cho loại phần trăm",
          employees_listemployee_editemployee_editcontent_fired: "Sa Thải",
          employees_listemployee_fire_successfully:
            "Sa thài nhân viên thành công",
          employees_listemployee_fire_unsuccessfully:
            "Sa thải nhân viên thất bại",
          employees_listemployee_editemployee_editcontent_save: "Lưu",
          employees_listemployee_editemployee_editcontent_employee_notification:
            "Thông báo",
          employees_listemployee_editemployee_editcontent_employee_will_expire_in:
            "sẽ hết hạn trong",
          employees_listemployee_editemployee_editcontent_employee_bonus:
            "Tiền thưởng",
          employees_listemployee_editemployee_editcontent_employee_typeBonus:
            "Loại tiền thưởng",
          employees_listemployee_editemployee_editcontent_percent: "Phần trăm",
          employees_listemployee_editemployee_editcontent_value: "Giá trị",
          employees_listemployee_editemployee_editcontent_value_must_be_less_than_1:
            "Giá trị phần trăm phải nhỏ hơn 1",
          employees_listemployee_editemployee_editcontent_days: "ngày",
          employees_listemployee_editemployee_editcontent_click: ". Nhấn vào",
          employees_listemployee_editemployee_editcontent_here: "đây",
          employees_listemployee_editemployee_editcontent_to_update:
            "để cập nhật",
          employees_listemployee_editemployee_editcontent_usercode:
            "Mã người dùng",
          employees_listemployee_editemployee_editcontent_delete: "Xóa",
          employees_listemployee_editemployee_editcontent_update: "Cập nhật",
          employee_addemployee_invite_employee: "Mời nhân viên",
          employee_addemployee_confirm: "Xác nhận",
          employee_addemployee_type_phone_number: "Nhập số điện thoại",
          employee_addemployee_send: "Gửi",
          employee_addemployee_send_an_activeCode_to_this_phone_number_and_invite_them_become_employee:
            "Gửi 1 active code đến số điện thoại này và mời họ trở thành nhân viên",
          employee_addemployee_phone_number_no_valid_please_try_again:
            "Số điện thoại không hợp lệ. Vui lòng nhập lại",
          employee_addemployee_please_pick_a_branch_at_least:
            "Vui lòng chọn ít nhất 1 chi nhánh mà nhân viên làm việc",
          active_code_expired: "Active code đã hết hạn",
          employee_addemployee_the_active_code_incorrect_please_try_again:
            "Active code không đúng.Vui lòng thử lại.",
          employee_addemployee_an_error_occurred_please_try_again_or_contact_your_administrators:
            "Lỗi đã xảy ra. Vui lòng thử lại hoặc liên hệ quản lý!",
          employee_addemployee_add_new_employee: "Thêm nhân viên mới",
          employee_addemployee_enter_activecode_send_to_phone_number:
            "Vui lòng nhập mã xác nhận được gửi đến số điện thoại",
          employee_addemployee_to_confirm: "để xác nhận",
          employee_addemployee_the_active_code_unexpired_so_you_can_not_request_again:
            "Active code đã được gửi bạn không thể yêu cầu lần nữa",
          employee_addemployee_phone_number_not_register_account_please_try_again:
            "Số điện thoại chưa đăng ký tài khoản nên không thể trở thành nhân viên",
          employee_addemployee_phone_number_existed_on_employee_management_system_please_try_again:
            "Số điện thoại đã tồn tại trên hệ thống quản lý. Vui lòng thử lại.",
          employee_addemployee_cancel: "Hủy bỏ",
          employee_addemployee_notice: "Thông báo",
          employee_addemployee_error_with_code:
            "Tạo mã xác nhận không thành công với mã lỗi",
          employee_addemployee_user_had_role_owner_or_employee_for_this_spa:
            "Người dùng này đã có quyền sở hữu hoặc nhân viên của spa này",
          employee_addemployee_arrBranch: "Chi nhánh",
          employee_addemployee_phone_number: "Số điện thoại",
          employee_addemployee_type_employee: "Loại nhân viên",
          employee_addemployee_operator: "Người quản lý",
          employee_addemployee_executor: "Người làm dịch vụ",
          employee_addemployee_all_branch: "Tất cả chi nhánh",
          employee_addemployee_resend: "Gửi lại mã",
          employee_addemployee_active_code_will_expire_after:
            "Active code sẽ hết hạn sau",
          employee_addemployee_register_success_pls_login:
            "Tài khoản của bạn đã được đăng kỳ thành công. Vui lòng đăng nhập lại vào trang Masspa Admin",
          employee_addemployee_invite_within_three_days:
            "mời bạn làm việc. Vui lòng truy cập đường đẫn dưới đây trong vòng 3 ngày:",

          // login
          Login_user_inactive:
            "Lỗi người dùng không được kích hoạt, vui lòng liên hệ admin",
          Login_your_account_inactive_or_deleted:
            "Tài khoản của bạn bị khoá hoặc đã bị xoá",
          Login_your_service_deleted: "Dịch vụ của bạn đã bị xoá",
          Login_phone_number_and_password_combination_is_incorrect:
            "Số điện thoại hoặc mật khẩu không chính xác",
          Login_please_enter_password: "Vui lòng nhập mật khẩu",
          Login_error_access_account:
            "Bạn không được phép truy cập vào tài khoản này!",
          Login_error_package_expired: "Gói sử dụng của bạn đã hết hạn",
          Login_phone_number_is_not_valid: "Số điện thoại không hợp lệ",
          Login_the_passord_field_length_must_be_greater_than_or_equal_to_6_characters_long:
            "Độ dài mật khẩu phải lớn hơn hoặc bằng 6 ký tự!",
          login_enter_your_new_password_that_more_than_6_character:
            "Mật khẫu của bạn phải có ít nhất 6 kí tự",
          login_please_enter_active_code_to_send_your_phone_number_before_reseting_password:
            "Vui lòng nhập active code để gửi đến số điện thoại của bạn trước khi mật khẩu cài lại",
          login_please_enter_phone_number_that_you_want_to_reset_the_password:
            "Vui lòng nhập số điện thoại bạn muốn cài đặt mật khẩu",
          login_change_password_successfully: "Thay đổi mật khẩu thành công !",
          login_change_password_unsuccessfully:
            "Thay đổi mật khẩu không thành công !",
          login_password_not_match: "Mật khẩu không trùng khớp!",
          login_active_code_is_not_correct_please_enter_activecode_again:
            "Active code không đúng. Vui lòng nhập active code lại",
          login_not_found_phone_number_please_enter_again:
            "Số điện thoại này không tìm thấy.Vui lòng nhập lại",
          login_please_enter_the_correct_phone_number_that_you_want_to_reset_the_password:
            "Vui lòng nhập đúng số điện thoại bạn muốn cài đặt",
          login_forgot_password: "Quên mật khẩu?",
          login_login: "Đăng nhập",
          login_send_active_code: "Gửi active code",
          login_phone_number: "Số điện thoại",
          login_password: "Mật khẩu",
          login_sign_in: "Đăng nhập",
          login_back: "Trở lại",
          login_reset_password: "Cài đặt lại mật khẩu",
          login_enter_new_password: "Nhập mật khẩu mới",
          login_new_password: "Mật khẩu mới",
          login_confirm_new_password: "Nhập lại mật khẩu mới",
          login_set_new_password: "Lập mật khẩu mới",
          login_subscribe: "Theo dõi",
          "login_to_subscribe_to_this_website_please_enter_your_email_address_here_we_will_send_updates_occasionally.":
            "Để theo dõi trang web này, vui lòng nhập địa chỉ email của bạn ở đây.Chúng tôi sẽ gửi thông tin cập nhật",
          login_cancel: "Hủy bỏ",
          login_change: "Thay đổi",
          login_you_should_change_password_at_first_login:
            "Bạn nên thay đổi mật khẩu trong lần đầu đăng nhập trang quản trị",
          login_notice: "Thông báo",
          login_change_password: "Đổi mật khẩu",
          login_set_later: "Để sau",
          login_employee_executor_can_not_login_admin_page:
            "Nhân viên làm dịch vụ không được phép đăng nhập",
          login_you_havent_registered_a_masspa_in_system_so_you_can_not_access_admin_page_lets_click_sign_up: `You haven't registered a Masspa in system. So you can not access Admin page. Let's click "Sign Up`,
          Login_with_role: "Đăng nhập với quyền",
          ownerSpa: "Chủ tiệm spa",
          user: "Nguời dùng",
          employeeSpa: "Nhân viên spa",
          employeeAdmin: "Nhân viên của người quản trị",
          admin: "Người quản trị",
          //support language
          selectedlanguage_support: "Hỗ trợ",
          //countryCode
          countrycode_code: "Mã QG",
          //fanpage
          pls_enter_facebook_id: "Vui lòng nhập Facebook ID",
          fanpage_submit: "Gửi",
          fanpage_you_have_sent_it_Unsuccessfully:
            "Bạn đã lưu không thành công",
          fanpage_you_have_sent_it_successfully: "Bạn đã lưu thành công",
          // serviceStableCost
          service_table_cost: "Chi phí cố định của spa",
          service_table_cost_cost_name: "Tên chi phí",
          service_table_cost_cost_value: "Giá Tiền",
          service_table_cost_delete: "Xóa",
          service_table_cost_electrict_cost: "Tiền điện",
          service_table_cost_water_cost: "Tiền nước",
          service_table_cost_internet_cost: "Tiền internet",
          service_table_cost_space_cost: "Tiền mặt bằng",
          service_table_cost_clean_cost: "Tiền vệ sinh",
          service_table_cost_please_fill_in_cost_name:
            "Vui lòng điền vào tên chi phí",
          service_table_cost_add: "Thêm mới",
          service_table_cost_save: "Lưu",
          service_table_cost_update_service_cost_successfully:
            "Cập nhật chi phí thành công",
          service_table_cost_update_service_cost_unsuccessfully:
            "Cập nhật chi phí không thành công",
          service_table_cost_name_is_already_in_use:
            "Tên chi phí đã được hệ thống sử dụng, vui lòng chọn tên khác",
          // serviceCost
          service_cost_total_price: "TỔNG TIỀN",
          service_cost_add_new: "Thêm mới",
          service_cost_total_employee_salary: "Tổng số lương nhân viên",
          service_cost_you_dont_save_changes:
            "Nhấn nút LƯU để lưu lại những thay đổi của bạn đối với tháng này",
          service_cost_salary_employee_employee_name: "Tên nhân viên",
          service_cost_salary_employee_working_time: "Giờ làm việc",
          service_cost_salary_employee_day_off: "Ngày nghỉ",
          service_cost_salary_employee_salary: "Tiền lương",
          service_cost_salary_employee_bonus_salary: "Tiền thưởng",
          service_cost_salary_employee_delete: "Xóa",
          service_cost_salary_employee_cancel: "Hủy",
          service_cost_salary_employee_continute: "Tiếp tục",
          service_cost_salary_employee_confirm: "Xác nhận",
          service_cost_salary_employee_delete_this_employee_salary:
            "Xóa lương của nhân viên này",
          service_cost_confirmUpdateSalary_select_new_employees_that_you_want_to_update_their_salary_for_this_month:
            "Chọn những nhân viên mới mà bạn muốn cập nhật lương của họ trong tháng này",
          service_cost_confirmUpdateSalary_are_you_sure_you_want_to_update_salaries_of_all_employees:
            "Bạn muốn cập nhật lương của tất cả nhân viên?",
          service_cost_month_1: "Tháng 1",
          service_cost_month_2: "Tháng 2",
          service_cost_month_3: "Tháng 3",
          service_cost_month_4: "Tháng 4",
          service_cost_month_5: "Tháng 5",
          service_cost_month_6: "Tháng 6",
          service_cost_month_7: "Tháng 7",
          service_cost_month_8: "Tháng 8",
          service_cost_month_9: "Tháng 9",
          service_cost_month_10: "Tháng 10",
          service_cost_month_11: "Tháng 11",
          service_cost_month_12: "Tháng 12",
          service_cost_update_employee_salary_according_to_current_data:
            "Cập nhật lương nhân viên theo dữ liệu hiện tại",
          service_cost_are_you_sure_you_want_to_delete_this_cost:
            "Bạn có chắc muốn xóa chi phí này?",

          // FileReader
          file_reader_upload_photo: "Tải ảnh lên",
          file_reader_delete: "Xóa",
          file_reader_select_image: "Chọn từ kho ảnh",

          login_user_not_found: "Tài khoản không tồn tại",

          // Select language
          select_language_korean: "Tiếng Hàn",
          select_language_japanese: "Tiếng Nhật",

          //Product
          product_product_category: "Danh mục",
          product_search: "Tìm SKU, tên",
          product_category_please_fill_in_name:
            "Vui lòng điền vào tên của loại sản phẩm",
          product_product_category_root: "Thư mục cha",
          product_product_category_parent_category: "Thư mục cha",
          product_edit_product_category: "Chỉnh sửa danh mục",
          product_add_product_category: "Thêm danh mục mới",
          product_product: "Danh sách sản phẩm",
          product_please_fill_in_name_product: "Vui lòng điền vào tên sản phẩm",
          product_edit_product: "Chỉnh sửa sản phẩm",
          product_add_product: "Thêm sản phẩm",
          product_product_featured_item: "Sản phẩm tiêu biểu",
          product_title: "Tên sản phẩm",
          product_visible: "Trạng thái hiển thị",
          product_visible_status: "Hiển thị",
          product_hide_status: "Ẩn",
          product_volume: "Dung tích",
          product_price: "Giá",
          product_sale_price: "Giá bán",
          product_date_expired: "Ngày hết hạn",
          product_manufacturing_date: "Ngày sản xuất",
          product_madeIn: "Nơi sản xuất",
          product_brand: "Thương hiệu",
          product_currencyCode: "Đơn vị tính",
          product_dimensions_length: "Chiều dài",
          product_dimensions_height: "Chiều cao",
          product_dimensions_width: "Chiều rộng",
          product_position: "Vị trí",
          product_weight: "Trọng lượng",
          product_stock_quantity: "Số lương sản phẩm trong kho",
          product_color_name: "Tên màu",
          product_color_code: "Mã màu tự đặt(vd đỏ,đen)",
          product_color_value: "Mã màu hex(vd #fff)",
          product_color_type: "Loại màu",
          product_color_type_system: "Hệ thống",
          product_color_type_image: "Hình ảnh",
          product_please_fill_in_title: "Vui lòng điền vào tên sản phẩm",

          product_additional_info: "Thông tin bổ sung",
          product_sku: "Mã sản phẩm",
          stock_quantity: "Số lượng tồn kho",
          product_stock_weight: "Khối lượng",
          product_no: "Không",
          product_yes: "Có",
          product_all: "Tất cả",
          product_stock_status: "Trạng thái tồn kho",
          product_out_of_stock: "Hết hàng",
          product_available: "Còn hàng",
          product_backorder: "Dự trữ",
          product_preorder: "Đặt hàng trước",
          product_discontinued: "Không tiếp tục",
          product_edit: "Sửa",
          product_enabled: "Hiển thị",
          product_on_sale: "Giảm giá",
          product_all_product: "Tất cả sản phẩm",
          product_manage_product_category: "Quản lý",
          product_do_you_want_to_delete_product:
            "Bạn muốn xoá sản phẩm đã chọn",
          product_list_product: "Danh sách sản phẩm",
          product_category: "Danh mục",
          product_additional_category: "Danh mục bổ sung",
          product_tag: "Gắn thẻ",
          product_related_product: "Sản phẩm liên quan",
          product_attribute_name: "Tên thuộc tính",
          product_attribute_value: "Giá trị thuộc tính",
          product_add_new_attribute: "THÊM THUỘC TÍNH",
          product_name: "Tên",
          product_slug: "Slug",
          product_page_title: "Tựa đề trang",
          product_meta_description: "Mô tả ngắn",
          product_description: "Mô tả",
          product_inventory: "Hàng tồn kho",
          product_variants: "Các loại sản phẩm",
          product_attribute: "Thuộc tính",
          product_image: "Hình ảnh",
          product_pricing: "Giá sản phẩm",
          product_regular_price: "Giá thường niên",
          product_sale_from: "Từ ngày",
          product_sale_to: "Đến ngày",
          product_expected_date: "Ngày hết hạn",
          product_manage_stock: "Quản lý kho",
          product_search_product: "Tìm khiếm bằng tên sản phẩm",
          product_cancel: "Huỷ",
          product_add: "Thêm",

          product_variant_price: "Giá",
          product_variant_stock: "Tồn kho",
          product_variant_weight: "Khối lượng",
          product_add_new_variant: "Thêm biến thể",

          product_update: "Cập nhật",
          product_create: "Tạo",
          product_delete: "Xoá",

          // product category
          product_category_name: "Tên Danh mục",
          product_category_image: "Hình ảnh",
          product_category_create_product_category: "Tạo Danh mục sản phẩm",
          product_category_description: "Mô tả",
          product_category_enable: "Hiển thị",
          product_category_slug: "Slug",
          product_category_page_title: "Tựa đề trang",
          product_category_meta_description: "Mô tả ngắn",

          // category post
          category_post_add_new_category: "Thêm danh mục bài đăng mới",
          category_post_edit_category: "Chỉnh sửa danh mục",
          category_post_new_category_name: "Tên danh mục",
          category_post_choose_a_parent_category: "Chọn một danh mục gốc",
          category_post_search: "Tìm kiếm",
          category_post_cancel: "Hủy",
          category_post_add: "Thêm",
          category_post_edit: "Chỉnh sửa",
          category_post_yes: "Đồng ý",
          category_post_confirm: "Xác nhận",
          category_post_you_want_to_delete_category: "Bạn muốn xóa danh mục",
          category_post_add_new_category_successful:
            "Thêm danh mục mới thành công",
          category_post_edit_category_successful:
            "Chỉnh sửa danh mục mới thành công",
          category_post_delete_new_category_successful:
            "Xóa danh mục thành công",
          category_post_nothing_category_post: "Không có danh mục nào",
          category_post_no_result_found: "Không có kết quả nào dược tìm thấy",
          category_post_top_level_category: "Chọn làm thư mục gốc",
          category_post_name_category_required: "Tên danh mục được yêu cầu",
          category_post_select_at_least_one_parent_category:
            "Chọn ít nhất một thư mục gốc",

          chose_image_from_album: "Chọn ảnh từ thư mục hình ảnh",
          embed_code: "Chèn code",

          post_search: "Tìm kiềm",
          post_list_posts: "Danh sách bài viết",
          post_create_posts: "Thêm bài viết",
          post_title: "Tiêu đề",
          post_content: "Nội dung",
          post_description: "Mô tả",
          post_featureImage: "Hình ảnh",
          post_search_by_title_description_slug: "Tìm tiêu đề, mô tả và slug",
          post_publish: "Xuất bản",
          post_publish_true: "Có",
          post_publish_false: "Không",
          post_category: "Thể loại",
          post_lang: "Ngôn ngữ",
          post_tag: "Nhãn",
          post_format: "Định dạng",
          post_create: "Tạo",
          post_update: "Cập nhật",
          post_slug: "Slug",
          post_update_posts: "Cập nhật bài viết",
          post_edit: "Sửa",
          post_cancel: "Huỷ bỏ",
          post_continue: "Tiếp tục",
          post_notice: "Thông báo",
          post_ok: "Đồng ý",
          post_do_you_want_to_delete_this_post:
            "Bạn có muốn xoá những bài viết này?",

          // report
          report_report_spa: "Báo cáo",
          report_review: "Xem Trước",
          report_review_report: "Xem Trước Báo Cáo",
          report_print: "In",
          report_business_sumary_report: "Báo Cáo Tóm Tắt Doanh Thu",
          report_employee_utilization_report:
            "Báo Cáo Về Tỉ Lệ Nhân Viên Làm Việc",
          report_employee_report: "Báo Cáo Về Nhân Viên",
          report_date_time: "Thời Gian",
          report_report_for: "Báo cáo ",
          report_sale_break_down: "Thống Kê Doanh Số",
          report_count: "Số Lượng",
          report_amount: "Tổng Tiền",
          report_appointment_statistics: "Thống Kê Bổ Nhiệm",
          report_invoice_detail: "Chi Tiết Đơn Hàng",
          report_profit_reakdown: "Thống Kê Lợi Nhuận",
          report_payment_type_breakdown: "Thống Kê Loại Hình Thanh Toán",
          report_subtotal: "Tạm Tính",
          report_tax: "Thuế",
          report_total: "Tổng cộng",
          report_total_booking: "Tổng đơn đặt hàng",
          report_total_booking_app: "Tổng đơn đặt hàng trên app",
          report_unique_client: "Khách hàng đã từng đặt dịch vụ",
          report_new_client: "Khách hàng mới",
          report_walk_in_client: "Khách hàng đi đến spa ",
          report_client_not_checked_in: "Khách hàng hủy cuộc hẹn",
          report_total_booking_success: "Tổng đơn đặt hàng thành công",
          report_invoice: "Hóa đơn",
          report_aborted: "Hủy bỏ",
          report_discount: "Khuyến mãi",
          report_avg_sales: "Trung bình",
          report_gross_sales: "Doanh thu",
          report_total_cost: "Chi Phí",
          report_net_profit: "Lợi Nhuận",
          report_cash: "Tiền mặt",
          report_position: "Vị trí",
          report_staff: "Nhân Viên",
          report_salary: "Lương",
          report_no: "STT",
          report_order_code: "Mã Đơn Hàng",
          report_item: "Sản Phẩm",
          report_quantity: "Số Lượng",
          report_date: "Ngày",
          report_price: "Giá",
          report_bonus: "Bonus",
          report_commission: "Hoa Hồng",
          report_total_commission: "Tổng Hoa Hồng",
          report_total_salary_commission: "Tổng Cộng",
          report_employee_name: "Nhân Viên",
          report_total_all_time: "Tất Cả Thời Gian",
          report_time_block: "Thời Gian",
          report_monday: "Thứ 2",
          report_tuesday: "Thứ 3",
          report_wednesday: "Thứ 4",
          report_thursday: "Thứ 5",
          report_friday: "Thứ 6",
          report_saturday: "Thứ 7",
          report_sunday: "Chủ Nhật",
          report_please_select_employee: "VUi lòng chọn nhân viên",

          dont_have_account: "Không có tài khoản?",
          sign_up: "Đăng ký",
          have_an_account: "Đã có tài khoản?",
          sign_in: "Đăng nhập",

          register_spa_informations: "Thông tin của Spa",
          register_your_informations: "Thông tin của bạn",
          register_verification: "Xác minh",
          register_spa_name: "Tên Spa",
          register_website: "Website",
          register_phone_number: "Số điện thoại",
          register_address: "Địa chỉ",
          register_first_name: "Tên",
          register_last_name: "Họ",
          register_verification_code: "Mã xác minh",
          register_we_sent_code_to: "Chúng tôi đã gửi mã đến",
          register_enter_code_below: "Vui lòng nhập mã xuống đây",
          register_please_wait: "Vui lòng chờ",
          register_aciveCode_will_expired_after: "Mã xác nhận sẽ hết hạn sau",
          register_minutes: "phút",
          register_seconds: "giây",
          register_before_try_to_resend_code: "trước khi gửi lại lần nữa",
          register_sign_up_success: "Đăng ký thành công!",
          register_go_to_sign_in: "Đi đến đăng nhập",
          register_use_previous_password_to_login_admin:
            "Chúc mừng bạn đã đăng kí thành công. Hãy sử dụng mật khẩu tài khoản của bạn để đăng nhập trang Masspa Admin",
          register_use_code_to_login_first_time:
            "Chúc mừng bạn đã đăng kí thành công. Hãy sử dụng mã xác minh cho lần đăng nhập đầu tiên",

          pls_enter_last_name: "Vui lòng nhập họ của bạn",
          pls_enter_first_name: "Vui lòng nhập tên của bạn",
          is_invalid_phone: "là không hợp lệ",
          spa_disabled_pls_contact_admin:
            "Spa của bạn hiện đang không được kích hoat. Vui lòng liên hệ với admin để giải quyết tình huống",
          spa_exist: "Spa đã tồn tại",
          pls_enter_your_address: "Vui lòng nhập địa chỉ của bạn",
          pls_enter_your_phone: "Vui lòng nhập số điện thoại của bạn",
          pls_enter_name_spa: "Vui lòng nhập tên spa",

          resend: "Gửi lại mã",
          activecode_is_incorrect_please_try_again:
            "Mã xác thực không đúng, vui lòng thử lại lần nữa",
          activecode_is_expired_please_register_again:
            "Mã xác thực đã quá hạn. Vui lòng gửi lại!",

          forgot_enter_your_phone_below:
            "Vui lòng nhập số điện thoại của bạn xuống đây",
          forgot_create_password: "Tạo mật khẩu",
          forgot_send_different_number: "Gửi đến số khác",
          forgot_create_password_success_pls_login_with_new_password:
            "Bạn đã thay đổi mật khẩu thành công, vui lòng đăng nhập với mật khẩu mới",
          post_you_dont_have_permission_to_perform_this_action:
            "Bạn không được phép thực hiện hành động này. Kiểm tra lại quyền truy cập",
          choose_your_work_place: "Lựa chọn nơi làm việc của bạn",
          you_send_message_to_phone: "Bạn đã gửi tin nhắn đến số diện thoại",
          with_content: "với nội dung dưới đây.",

          module_service: "Chi tiết",
          module_mySpa: "Spa",
          module_branch: "Chi nhánh",
          module_sms: "Tin nhắn",
          module_album: "Thư viện ảnh",
          module_storage: "Kho ảnh",
          module_menuService: "Dịch vụ",
          module_dashboard: "Bảng điều khiển",
          module_cms: "CMS",
          module_post: "Bài viết",
          module_voucher: "Phiếu giảm giá",
          module_discount: "Giảm giá",
          module_promotion: "Khuyến mãi",
          module_memberCard: "Thẻ thành viên",
          module_employee: "Nhân viên",
          module_employeeSystem: "Hệ thống",
          module_employeeMobile: "Mobile",
          module_cost: "Chi phí",
          module_booking: "Đặt chỗ",
          module_adminBooking: "Admin",
          module_posBooking: "POS",
          module_mobileBooking: "Mobile",
          module_order: "Đơn hàng",
          module_adminOrder: "Admin",
          module_posOrder: "POS",
          module_customer: "Khách hàng",
          module_report: "Báo cáo",
          module_apiKey: "APIKey",
          module_contact: "Liên hệ",
          module_pos: "POS",
          module_visitor: "Người truy cập",
          module_action_view: "Xem",
          module_action_insert: "Thêm",
          module_action_update: "Sửa",
          module_action_delete: "Xóa",
          module_action_viewSalary: "Xem lương",
          module_action_active: "Kích hoạt",
          module_action_exportPDF: "Xuất PDF",
          module_action_exportExel: "Xuất Exel",
          module_action_chart: "Biểu đồ",
          module_action_report: "Báo cáo",
          module_action_note: "Ghi chú",
          module_action_posBooking: "Đặt hàng",
          module_action_posOrder: " Đơn hàng",
          module_action_posLogin: "Đăng nhập",

          module_reset: "Đặt lại",
          module_save: "Lưu",
          module_change_package: "Thay đổi gói",
          module_package_free: "Gói miễn phí",
          module_package_will_expired_in: "Gói sẽ hết hạn trong",
          module_package_days: "ngày",
          module_package_expired: "Gói đã hết hạn",
          module_you_using_package: "Bạn đang sử dụng gói",
          module_contact_your_admin_if_you_need_to_update_your_package:
            "Liên lạc Admin nếu bạn cần cập nhật gói của bạn",
          module_expired_day: "Ngày hết hạn",
          module_free: "Miễn phí",
          module_update_module_success: "Cập nhật thành công",
          module_package_is_valid_until_date: "Gói có giá trị đến ngày",
          module_service_have_not_owner: "Spa chưa có chủ sở hữu",
          module_service_name: "Tên dịch vụ",
          module_expire_day: "Ngày hết hạn",
          module_status: "Trạng thái",
          module_status_is_using: "Đang sử dụng",
          module_status_expired: "Hết hạn",
          module_using_package: "Gói sử dụng của",
          module_select_package: "Chọn gói",

          profile_apikey: "API Key",
          profile_general: "Tạo",
          profile_secretkey: "Mã bí mật",
          profile_edit: "Chỉnh sửa",
          profile_pls_enter_secret_key: "Vui lòng nhập mã bí mật",
          profile_delete: "Xoá",

          contact_phone: "Điện thoại",
          contact_name: "Tên",
          contact_email: "Email",
          contact_gender: "Giới tính",
          contact_age: "Tuổi",
          contact_ip: "IP",
          contact_is_customer: "Khách hàng",
          contact_cancel: "Huỷ bỏ",
          contact_ok: "Đồng ý",
          contact_notice: "Thông báo",
          contact_do_you_want_to_delete_this_contact:
            "Bạn có muốn xoá bỏ những liên hệ này",
          contact_list_contacts: "Danh sách liên hệ",
          contact_search_by_customer_name_phone_email:
            "Tìm họ tên, số điện thoại và email",
          contact_listcontact_delete_successfully: "Xóa thành công",
          contact_listcontact_delete_unsuccessfully: "Xóa thất bại",
          contact_listcontact_edit: "Sửa",
          contact_listcontact_add: "Thêm",
          contact_fromType: "Liên hệ từ",
          contact_content: "Nội dung",
          contact_extraData: "Dữ liệu mở rộng",
          contact_update: "Cập nhật",
          contact_address: "Địa chỉ",
          contact_city: "Thành phố",
          contact_country: "Quốc gia",
          contact_state: "Tiểu bang",
          contact_district: "Quận/Huyện",

          contact_socialId: "Social ID",
          contact_socialLink: "Social Link",
          contact_userAgent: "User Agent",
          contact_category: "Danh mục",
          contact_categoryId: "Mã danh mục",
          contact_note: "Chú thích",
          contact_for_user_is_customer_of_spa:
            "Người dùng là khách hàng của spa",
          contact_createdAt: "Ngày tạo",
          contact_picker_create: "Chọn ngày khởi tạo",
          contact_pls_select: "Vui lòng, chọn...",

          visitor_phone: "Điện thoại",
          visitor_name: "Tên",
          visitor_email: "Email",
          visitor_gender: "Giới tính",
          visitor_age: "Tuổi",
          visitor_ip: "IP",
          visitor_is_customer: "Khách hàng",
          visitor_cancel: "Huỷ bỏ",
          visitor_ok: "Đồng ý",
          visitor_notice: "Thông báo",
          visitor_do_you_want_to_delete_this_visitor:
            "Bạn có muốn xoá bỏ những nguời truy cập này",
          visitor_list_visitors: "Danh sách nguời truy cập",
          visitor_list_edit: "Sửa",
          visitor_search_by_customer_name_phone_email:
            "Tìm tên, số điện thoại, email",
          visitor_fromType: "Ghé thăm từ",

          visitor_update: "Cập nhật",
          visitor_address: "Địa chỉ",
          visitor_city: "Thành phố",
          visitor_country: "Quốc gia",
          visitor_state: "Tiểu bang",
          visitor_district: "Quận/Huyện",

          visitor_socialId: "Social ID",
          visitor_socialLink: "Social Link",
          visitor_userAgent: "User Agent",
          visitor_note: "Chú thích",
          visitor_for_user_is_customer_of_spa:
            "cho người dùng là khách hàng của spa",
          visitor_createdAt: "Ngày tạo",
          visitor_picker_create: "Chọn ngày khởi tạo",
          visitor_pls_select: "Vui lòng, chọn...",

          update_success: "Cập nhật thành công",
          delete_success: "Xoá thành công",
          create_success: "Tạo thành công",

          // user voucher
          user_voucher_list: "Người nhận phiếu giảm giá",
          user_voucher_is_user: "Người dùng",
          user_voucher_mobile: "Số điện thoại",
          user_voucher_customerName: "Tên khách hàng",
          user_voucher_voucherCode: "Mã phiếu",
          user_voucher_imageVoucher: "Hình ảnh",
          user_voucher_isUsed: "Đã sử dụng",
          user_voucher_unUsed: "Chưa sử dụng",
          user_voucher_endDate: "Ngày hết hạn của phiếu",
          user_voucher_sent_at: "Ngày gửi phiếu",
          user_voucher_time_period_sent_to_customers:
            "Khoảng thời gian gửi phiếu đến khách hàng",
          user_voucher_click_to_pick_time: "Nhấn vào để chọn thời gian",
          user_voucher_show_all: "Hiển thị tất cả",
          user_voucher_valid: "Còn hạn sử dụng",
          user_voucher_expired_after_one_day: "Sẽ hết hạn sau 1 ngày nữa",
          user_voucher_expired: "Đã hết hạn sử dụng",
          user_voucher_search_by_voucherCode_customerName:
            "Tìm kiếm mã phiếu, số điện thoại",
          user_voucher_expired_date: "Ngày hết hạn phiếu",
          user_voucher_usage_status: "Trạng thái sử dụng",

          user_voucher_send_notify_to_customer:
            "Gửi thông báo qua app cho khách hàng",
          user_voucher_times_the_voucher_is_used:
            "Số lần khách hàng được phép sử dụng voucher",
          user_voucher_updated_successful: "Cập nhật thành công",
          user_voucher_times_is_not_valid: "Số lần không hợp lệ",
          user_voucher_customer_has_used: "Khách hàng đã sử dụng",
          user_voucher_times: "lần",
          user_voucher_user_is_registered_account:
            "Người dùng đã đăng ký tài khoản",
          user_voucher_sure_that_you_want_to_delete_this_voucher:
            "Are you sure remove this user vouchers?",
          //Campaign
          campaign_list_campaign: "Danh Sách Chiến Dịch",
          campaign_list_do_you_want_to_delete_campaign_from_list:
            "Bạn có chắc muốn xóa chiến dịch này?",
          campaign_search_title_code: "Tìm theo tên",
          campaign_add_campaign: "Thêm Chiến Dịch",
          campaign_add_campaign_content: "Nội Dung",
          campaign_add_campaign_title: "Tiêu Đề",
          campaign_add_campaign_type: "Thể Loại",
          campaign_add_campaign_start_date: "Ngày bắt đầu",
          campaign_add_campaign_end_date: "Ngày kết thúc",
          campaign_add_campaign_game: "Trò Chơi",
          campaign_add_campaign_voucher: "Phiếu Giảm Giá",
          campaign_add_campaign_enable: "Kích hoạt chiến dịch",
          campaign_add_campaign_isCommingSoon:
            "Hiện thị chiến dịch trước ngày bắt đầu",
          campaign_add_campaign_contact_info: "Thông tin hiển thị",
          campaign_add_campaign_isShow: "Hiển thị",
          campaign_add_campaign_isRequired: "Bắt buộc",
          campaign_add_campaign_name: "Tên",
          campaign_add_campaign_phone: "Số điện thoại",
          campaign_add_campaign_email: "Email",
          campaign_add_campaign_address: "Địa chỉ",
          campaign_add_campaign_gender: "Giới tính",
          campaign_add_campaign_image: "Hình ảnh",
          campaign_add_campaign_please_add_type:
            "Vui lòng chọn loại chiến dịch",
          campaign_add_campaign_please_add_voucher: "Vui lòng chọn thẻ ưu đãi",
          campaign_add_campaign_please_add_start_date:
            "Vui lòng chọn ngày bắt đầu",
          campaign_add_campaign_please_add_end_date:
            "Vui lòng chọn ngày kết thúc",
          campaign_list_campaign_title: "Tiêu Đề",
          campaign_list_campaign_code: "Mã Chiến Dịch",
          campaign_list_campaign_type: "Thể Loại",
          campaign_list_campaign_start_date: "Ngày bắt đầu",
          campaign_list_campaign_end_date: "Ngày kết thúc",
          campaign_list_campaign_edit: "Sửa",

          age: "Tuổi",
          gender: "Giới tính",
          pls_select: "Vui lòng chọn",
          pls_select_item: "Vui lòng chọn danh mục",
          male: "Nam",
          female: "Nữ",
          other: "Khác",
          month: "Tháng",
          city: "Thành phố",
          country: "Quốc gia",
          district: "Quận/Huyện",
          ward: "Phường/Xã",
          state: "Tiểu bang",
          notArrived_in: "Không đến trong vòng",
          system: "Hệ thống",
          from: "Từ",
          to: "Đến",
          value: "Giá trị",
          select_city: "Chọn Thành phố",
          select_country: "Chọn Quốc gia",
          select_district: "Chọn Quận/Huyện",
          select_ward: "Chọn Phường/Xã",
          select_state: "Chọn Tiểu bang",

          customer_balance: "Số dư",
          customer_voucherBalance: "Số dư của voucher",
          customer_voucherMoney: "Giá trị của voucher",
          customer_spentRealMoney: "Số tiền thật đã tiêu",
          customer_spentVirtualMoney: "Số tiền ảo đã tiêu",
          copy_unsuccess: "Sao chép không thành công",
          copy_success: "Sao chép thành công",

          nps_nps: "Chỉ số đo lường sự hài lòng của khách hàng",
          nps_total: "Tổng số",
          nps_interact: "Lượt tương tác",
          nps_emotion: "Cảm xúc",
          nps_all: "Tất cả",
          nps_angry: "Giận dữ",
          nps_sad: "Tệ",
          nps_normal: "Bình thường",
          nps_happy: "Tốt",
          nps_love: "Yêu thích",
          nps_chart: "Biểu đồ",
          nps_list: "Danh sách",

          nps_listInteract_time_customer_react:
            "Thời gian khách hàng tương tác",
          nps_listInteract_click_to_pick_time: "Nhấn vào để chọn thời gian",
          nps_listInteract_branch: "Chi nhánh",
          nps_listInteract_emotion: "Cảm xúc",
          nps_listInteract_time: "Thời gian",

          service_account: "Tài khoản",
          service_account_serviceCode: "Mã của spa",
          service_account_card_number: "Số thẻ",
          service_account_card_name: "Tên chủ thẻ",
          service_account_card_expired: "Ngày hết hạn của thẻ",
          service_account_card_cvv: "Mã xác minh của thẻ",
          service_account_balance: "Số tiền trong ví",
          service_account_createdAt: "Ngày tạo",
          service_account_updatedAt: "Ngày cập nhật",
          service_account_status: "Trạng thái",
          service_account_role: "Vai trò",
          service_account_save_infomation: "Lưu",
          service_account_update_service_account_successful:
            "Cập nhật tài khoản thành công",
          service_account_please_fill_in_all_infomation:
            "Vui lòng điển đầy đủ tất cả thông tin",
          service_account_card_number_is_not_valid: "Số tài khoản không hợp lệ",
          service_account_card_cvv_is_not_valid: "Mã xác minh không hợp lệ",
          service_account_spa_has_not_updated_its_account:
            "Spa này chưa cập nhật thông tin tài khoản",
          service_account_add_payment_close: "Đóng",
          service_account_add_payment_type_money: "Loại tiền",
          service_account_add_payment_received_money: "Tiền đã nhận",
          service_account_add_payment_received_money_to_VND:
            "Chuyển tiền đã nhận sang VND",
          service_account_add_payment_note: "Ghi chú",
          service_account_add_payment_dialog_confirm: "Xác nhận",
          service_account_add_payment_dialog_ok: "Đồng ý",
          service_account_add_payment_dialog_cancel: "Hủy",
          service_account_add_payment_add_money_into_owner_account:
            "Nạp tiền vào tài khoản chủ spa với số tiền nhận được",
          service_account_add_payment_please_enter_received_money:
            "Vui lòng nhập số tiền nhận dược cần nạp vào tài khoản",
          service_account_add_payment: "Nạp tiền",

          // Payment Audit
          payment_audit_change_card_info: "Thay đổi thông tin thẻ",
          payment_audit_change_balance: "Thay đổi tiền thanh toán",
          payment_time: "Thời gian",
          payment_old_balance: "Số tiền cũ",
          payment_new_balance: "Số tiền mới",
          payment_content: "Nội dung",
          payment_creator: "Người tạo",
          payment_ownerSpa: "Chủ spa",
          payment_employeeSpa: "Nhân viên spa",
          payment_employeeAdmin: "Nhân viên admin",
          payment_admin: "Admin",
          payment_add_payment: "Nạp tiền",
          payment_order_amount: "Số tiền",
          payment_order_bankCode: "Ngân hàng",
          payment_order_info: "Nội dung",
          payment_add_balance_successfully: "Nạp tiền thành công",
          payment_add_balance_unsuccessfully: "Nạp tiền không thành công",
          payment_pls_enter_amount: "Vui lòng nhập số tiền",
          payment_pls_enter_bank: "Vui lòng chọn ngân hàng",
          payment_pls_enter_info: "Vui lòng nhập ghi chú",

          do_you_want_delete: "Bạn chắc chắn muốn xoá?",
          do_you_want_delete_campaign: "Bạn có muốn xoá chiến dịch này?",
          tabletoolbar_selected: "đã chọn",

          image_detail: "Ảnh đại diện của Spa",
          image_album: "Thư viện ảnh",
          "image_avatar-employee": "Nhân viên",
          "image_avatar-customer": "Khách hàng",
          "image_customer-employee": "Khách hàng",
          image_branch: "Chi nhánh",
          image_memberCard: "Thẻ thành viên",
          "image_menu-service": "Danh mục dịch vụ",
          "image_menu-item": "Dịch vụ",
          "image_menu-product": "Sản phẩm",
          "image_menu-product-category": "Danh mục sản phẩm",
          image_posts: "Bài viết",
          image_uploadImage: "Ảnh mô tả của Spa",
          image_voucher: "Phiếu giảm giá",
          "image_img-logo": "Logo",
          readed: "Đã đọc",
          unread: "Chưa đọc",
          detail: "Chi tiết",
          see_more: "Xem thêm",
          permission: "Phân quyền",
          change_cover: "Cập nhật hình nền",
          ratio: "Tỉ lệ",
          show_filter: "Bộ lọc",

          map: "Bản đồ",
          image_of_branch: "Hình ảnh đại diện chi nhánh",

          show_on_shop: "Hiển thị trên của hàng",
          is_show_price: "Hiển thị giá",
          add_menu_item: "Thêm dịch vụ",
          add_menu: "Thêm danh mục",
          name: "Tên",
          show: "Hiển thị",
          hide: "Ẩn",
          limited_all: "Giới hạn tất cả",
          limited_money: "Giới hạn tiền",
          limited_times: "Giới hạn số lần",
          unlimited_all: "Không giới hạn tất cả",
          type: "Loại",
          list_users: "Danh sách người dùng",
          go_to_spa: "Đi đến spa",
          users_search_by_name_phone: "Tìm theo tên, số điện thoại",

          // Upload
          upload_delete_image_from_storage: "Xóa ảnh từ kho ảnh",

          review: "Xem trước",
          read_all: "Đọc thêm",
          contact_admin_to_change: "Liên hệ admin để thay đổi",

          //   Extend package
          extend: "Gia hạn",
          extend_balance: "Số dư",
          extend_card_type: "Loại thẻ",
          extend_pament_method: "Phương thức thanh toán",
          extend_wallet: "Ví",
          extend_card: "Thẻ",
          extend_next_button: "Tiếp tục",
          extend_month: "Tháng",
          extend_month_number: "Số tháng",
          extend_auto_payment_wallet: "Tự động gia hạn từ tiền trong ví",
          extend_price_package: "Số tiền phải trả",
          extend_credit_card: "Thẻ tín dụng",
          extend_international_card: "Thẻ thanh toán quốc tế",
          extend_wallet_not_enough_money:
            "Số tiền trong ví không đủ, vui lòng nạp thêm",
          extend_package_success: "Gia hạn thành công",

          // plugin category
          plugin_category: "Loại Tính năng",
          plugin_category_search_by_name: "Tìm theo tên, key",
          plugin: "Tính năng",
          plugin_category_all: "Tất cả",
          plugin_category_english_name_is_required:
            "Tên tiếng anh được yêu cầu",
          create_plugin_category: "Tạo Tính năng",
          list_plugin_category: "Danh sách loại tính năng",
          list_plugin_category_key: "Key",
          list_plugin_category_name_head: "Tên",
          list_plugin_category_name: "Tên Tiếng việt",
          list_plugin_category_english_name: "Tên tiếng anh",
          list_plugin_category_createdAt: "Ngày tạo",
          list_plugin_category_updatedAt: "Ngày cập nhật",
          plugin_category_updateBtn: "Cập nhật",
          plugin_category_createBtn: "Tạo mới",
          do_you_want_to_delete_selected_plugin_category:
            "Bạn muốn xoá loại tính năng được chọn",
          update_successful: "Cập nhật thành công",
          plugin_madeby: "Tạo bởi",
          plugin_price: "Giá",
          plugin_contact_support: "Liên hệ hỗ trợ",
          plugin_privacy_policy: "Chính sách bảo mật",
          plugin_short_description: "Mô tả ngắn",
          plugin_add: "Thêm",
          plugin_remove: "Xóa",
          plugin_add_power_up: "Thêm Power Up",
          plugin_remove_power_up: "Xóa Power Up",

          // Users
          user_detail_login_time: "Thời gian đăng nhập",
          user_detail_visitor: "Người truy cập",
          user_detail_address: "Địa chỉ",
          user_detail_gender: "Giới tính",
          user_detail_birthday: "Ngày sinh",
          user_detail_email: "Thư điện tử",

          //Developer Account
          developer_account_developer_account: "Tài khoản nhà phát triển",
          developer_account_username: "Tài khoản",
          developer_account_password: "Mật khẩu",
          developer_account_tag: "Tag",
          developer_account_code: "Mã",
          create_developer_account_username: "Tên tài khoản",
          create_developer_account_password: "Password",
          create_developer_account_tag: "Tag",
          create_developer_account_sms: "SMS",
          create_developer_account_createbtn: "Tạo mới",
          create_developer_account_addbtn: "Thêm tài khoản mới",
          update_developer_account_updatebtn: "Cập nhật",
          update_developer_account_deletebtn: "Xoá",
          update_developer_account_cancelbtn: "Huỷ",
          create_developer_account_success: "Tạo mới thành công",
          create_developer_account_unsuccess: "Tạo mới thất bại",
          update_developer_account_success: "Cập nhật thành công",
          update_developer_account_unsuccess: "Cập nhật không thành công",
          delete_developer_account_success: "Xoá thành công",
          delete_developer_account_unsuccess: "Xoá không thành công",
          create_developer_account_account_exist: "Tài khoản đã tồn tại",
          create_developer_account_service_tag_exist:
            "Mỗi dịch vụ chỉ được tạo 1 tài khoản cho 1 tag",
          create_developer_account_pls_fill_username:
            "Vui lòng nhập tên tài khoản",
          create_developer_account_pls_fill_password: "Vui lòng nhập mật khẩu",

          // Digital Signal
          digital_signal_search: "Tìm tiêu đề, mã",
          digital_signal_title_list: "Danh sách digital",
          digital_signal_title_create: "Tạo mới digital",
          digital_signal_create_title: "Tiêu đề",
          digital_signal_create_description: "Mô tả",
          digital_signal_create_is_active: "Kích hoạt",
          digital_signal_create_show_on_show: "Hiển thị trên cửa hàng",
          digital_signal_create_add_media: "Thêm tập tin",
          digital_signal_create_remove_media: "Xoá tập tin",
          digital_signal_create: "Tạo",
          digital_signal_create_upload: "Upload",
          digital_signal_create_media_time: "Thời gian",
          digital_signal_create_media_content: "Nội dung",
          digital_signal_update: "Cập nhật",
          digital_signal_list_title: "Tiêu đề",
          digital_signal_list_creator: "Người tạo",
          digital_signal_list_created: "Ngày tạo",
          digital_signal_list_total_media: "Tổng số media",
          digital_signal_list_is_active: "Kích hoạt",
          digital_signal_list_do_you_want_to_remove_digital_from_list:
            "Bạn muốn xoá phần tử này ra khỏi danh sách?",
          digital_signal_list_delete_success: "Xoá thành công",
          digital_signal_list_delete_unsuccess: "Xoá xảy ra lỗi",
          create_degital_signal_success: "Tạo thành công",
          create_degital_signal_unsuccess: "Tạo xảy ra lỗi",
          create_degital_signal_pls_insert_title: "Vui lòng nhập tiêu đề",
          update_degital_signal_success: "Cập nhật thành công",
          update_degital_signal_unsuccess: "Cập nhật không thành công",

          // notification
          notification_notification: "Thông báo",
          notification_received_notification: "Thông báo đã nhận",
          notification_sent_notification: "Thông báo đã gửi",
          notification_template: "Bản Mẫu",
          notification_send: "Gửi",
          notification_type_notification: "Loại thông báo",
          notification_title: "Chủ đề",
          notification_description: "Mô tả",
          notification_content: "Nội dung",
          notification_update: "Cập nhật",
          notification_send_notification: "Gửi thông báo",
          notification_search_by_name: "Tìm kiếm theo tên",
          notification_load_more: "Tải thêm",
          notification_template_please_fill_in_title_and_description:
            "Vui lòng điên vào chủ đề và mô tả cho thông báo",
          notification_template_update_successful:
            "Cập nhật bản mẫu thành công",
          notification_send_to_all_user:
            "Gửi đến tất cả người dùng trong hệ thống",
          notification_send_to_all_customer:
            "Gửi đến tất cả khách hàng của spa",
          notification_send_to_all_owner_service: "Gửi đến tất cả chủ spa",
          notification_send_not_have_template:
            "Bạn chưa cập nhật nội dung thông báo để gửi. Vui lòng cập nhật trước khi gửi thông báo.",
          notification_time: "Thời gian gửi",
          notification_content: "Nội dung",
          notification_list_users: "Người nhận",
          CREATE_BOOKING: "Tạo đặt chỗ",
          UPDATE_STATUS_BOOKING_BY_USER: "Khách hàng cập nhật đặt chỗ",
          UPDATE_STATUS_BOOKING_BY_SERVICE: "Chủ dịch vụ cập nhật đặt chỗ",
          SEND_VOUCHER: "Gửi phiếu giảm giá",
          SEND_MEMBERCARD: "Gửi thẻ thành viên",
          SYSTEM_NOTIFICATION: "Thông báo hệ thống",
          SERVICE_ALERT_NOTIFICATION: "Thông báo dịch vụ",

          // service package
          custom: "Tùy chỉnh",
          gold: "Vàng",
          silver: "Bạc",
          bronze: "Đồng",
          basic: "Cơ bản",

          // SMS
          sms_tag_sms_manage: "Tin nhắn",
          sms_tag_device_manage: "Thiết bị",
          sms_title_sms_send: "Gửi tin nhắn",
          sms_filter_by_time: "Lọc theo ngày tạo",
          sms_send_sms: "Gửi tin nhắn",
          sms_send_sms_by_masspa_device:
            "Gửi tin nhắn bằng thiết bị của Masspa",
          sms_send: "Gửi",
          sms_search_by_to_phone_number: "Tìm kiếm theo số điện thoại gửi",
          sms_listsms_show_all: "Hiển thị tất cả",
          sms_manage_title_code: "Mã",
          sms_manage_title_to: "Số điện thoại",
          sms_manage_title_message: "Tin nhắn",
          sms_manage_title_status: "Trạng thái",
          sms_manage_sms_status_sending: "Đang gửi",
          sms_manage_sms_status_finish: "Hoàn tất",
          sms_manage_sms_status_fail: "Thất Bại",
          sms_manage_device_title_deviceid: "ID Thiết bị",
          sms_manage_device_title_version: "Phiên bản",
          sms_manage_device_title_model: "Mẫu thiết bị",
          sms_manage_device_title_status: "Trạng thái",
          sms_send_error_pls_fill_phone: "Vui lòng điên vào số điện thoại",
          sms_send_error_pls_fill_message:
            "Vui lòng điên vào nội dung tin nhắn",
          sms_send_successfully: "Gửi tin nhắn thành công",

          customer_feedback: "Phản hồi khách hàng",
          customer_feedback_list: "Danh sách phản hồi",
          customer_add_feedback: "Tạo phản hồi",
          customer_edit_feedback: "Sửa phản hồi",
          customer_add_feedback_created: "Phản hồi đã được tạo mới",
          customer_add_feedback_updated: "Phản hồi đã được cập nhật",
          customer_add_feedback_deleted: "Phản hồi đã được xóa",
          customer_remove_feedback_confirm:
            "Bạn có chắc sẽ muốn xóa phản hồi này?",
          // ERROR
          SMS_SEND_SERVICE_NOT_DEVICE_CONNECTED:
            "Không có thiết bị nào đang kết nối để gửi tin nhắn",
          minutes: "phút",
          delete: "Xoá",
          confirm_delete_message: "Bạn có chắc chắn muốn xoá ",
          no_apply: "Không áp dụng",
          free: "Miễn phí",
          insert_ulr: "Chèn url",
          enter_url: "Nhập đường dẫn",
          select_this_image: "Chọn ảnh này",
        },
      },
    },
    fallbackLng: "vi",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: false,

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ",",
    },

    react: {
      wait: true,
    },
  });

export default i18n;
